<!--  Created by   : Namit Tiwari                                                             -->
<!--  Create Dated : 27-Feb-2021                                                              -->
<!--  Purpose      : Online Registration Form                                                 -->
<template>
  <div id="divApplication">
    <div class="Flex_Table" v-if="isShowLoad">
      <div
        class="Flex_Row"
        v-if="candApplication_List.length > 0 && isNew == false"
      >
        <div class="Flex_Cell">
          <fieldset v-if="candApplication_List.length > 0">
            <legend>Registered Application details</legend>
            <div class="Flex_Table tblEntryForm">
              <div class="Flex_Row myHeaderRow">
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 15%"
                >
                  ApplicationNo
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 15%"
                >
                  Dated
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                >
                  Name
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                >
                  Nationality
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                >
                  Application Status
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                ></div>
                <div
                  class="Flex_Cell_Inline"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                ></div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 20%"
                >
                  View / Print
                </div>
              </div>

              <div
                class="Flex_Row"
                style="border-bottom: solid 1px darkgrey"
                v-for="o in candApplication_List"
                :key="o[0]"
              >
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 15%"
                >
                  <span
                    title="Click to get detail of the application"
                    class="appNoClass"
                    v-on:click="getRegistrationData(o)"
                    >{{ o[1] }}</span
                  >
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 15%"
                >
                  {{ o[2] }}
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                >
                  {{ o[3] }}
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                >
                  {{ o[15] }}
                </div>
                <div
                  valign="middle"
                  class="Flex_Cell"
                  align="center"
                  style="width: 10%"
                  :class="[
                    o[9] == '1'
                      ? 'statusSubmit'
                      : o[9] == '2'
                      ? 'statusReject'
                      : '',
                  ]"
                >
                  <span>{{ o[10] }}</span>
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                >
                  <span v-show="o[19] != ''">{{ o[19] }}</span>
                </div>

                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 10%"
                >
                  <input
                    type="button"
                    id="btnDiscard"
                    name="btnDiscard"
                    btnName="btnDiscard"
                    value="Discard"
                    style="
                      padding: 5px 15px 5px 15px;
                      background-color: Red;
                      font-weight: bold;
                    "
                    title="Click to Leave/Discard Application"
                    v-on:click="confirmDiscardApplication(o)"
                    :disabled="isExpired == 1 ? true : false"
                    :class="isExpired == 1 ? 'disabled' : ''"
                    v-if="o[13] == 1 && isExpired == 0"
                  />
                  <span
                    style="font-weight: bold; color: red"
                    v-if="o[13] == 1 && isExpired == 1"
                    >Expired</span
                  >
                </div>
                <div
                  class="Flex_Cell"
                  align="center"
                  valign="middle"
                  style="width: 20%"
                >
                  <span
                    class="Multibutton blackColor"
                    title="click to Print Application Form"
                  >
                    <a
                      v-if="o[17] == 1"
                      title="click to Print Application Form"
                      id="print1"
                      style="cursor: pointer"
                      class="glyphicons print"
                      v-on:click="printApplicationForm(o, 0)"
                      >App Form</a
                    >
                  </span>
                  <span
                    class="Multibutton blackColor"
                    title="click to Print Admit Card"
                  >
                    <a
                      v-if="o[16] == 1"
                      title="click to Print Admit Card"
                      id="print1"
                      style="cursor: pointer"
                      class="glyphicons print"
                      v-on:click="printAdmitCard(o)"
                      >Admit Card</a
                    >
                  </span>
                  <span
                    class="Multibutton blackColor"
                    title="click to Print Call Letter"
                  >
                    <a
                      v-if="o[11] == 1"
                      title="click to Print Call Letter"
                      id="print1"
                      style="cursor: pointer"
                      class="glyphicons nameplate"
                      v-on:click="printCallLetter(o)"
                      >Call Letter</a
                    >
                  </span>
                  <span
                    class="Multibutton blackColor"
                    title="click to Print Appointment Letter"
                  >
                    <a
                      v-if="o[12] == 1"
                      title="click to Print Appointment Letter"
                      id="print1"
                      style="cursor: pointer"
                      class="glyphicons adress_book"
                      v-on:click="printAppointmentLetter(o)"
                      >Offer Letter</a
                    >
                  </span>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="Flex_Row">
        <div class="Flex_Cell">
          <input
            type="button"
            id="btnNew"
            name="btnNew"
            btnName="btnNew"
            value="Add New Application"
            style="padding: 5px 15px 5px 15px"
            title="Click to New Application"
            v-on:click="isNew = !isNew"
            :class="isExpired == 1 ? 'disabled' : ''"
            v-if="isExpired == 0"
          />

          <!-- <transition name="fade"> -->
          <fieldset v-if="isNew">
            <legend>
              <div class="Flex_Table tblEntryForm" style="width: 100%">
                <div class="Flex_Row" valign="middle">
                  <div class="Flex_Cell">New Application Registration</div>
                  <div class="Flex_Cell" align="right" style="">
                    <span
                      style="
                        text-align: right;
                        color: #8a0000;
                        font-weight: bold;
                      "
                      >* Fields are mandatory
                    </span>
                  </div>
                </div>
              </div>
            </legend>
            <fieldset class="EntryBlock">
              <legend>Select Post & Category For Application</legend>
              <div class="Flex_Table tblEntryForm">
                <div class="Flex_Row">
                  <div class="Flex_Cell" style="width: 50%">
                    <label
                      for="ddlAdvertisment"
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      >Advertisement For</label
                    >
                    <select
                      id="ddlAdvertisment"
                      v-model="advtID"
                      v-on:change="
                        getPostType(), GetRecruitmentTypeRelaxation()
                      "
                    >
                      <option value="-1">---Select---</option>
                      <option
                        v-for="c in advt_List"
                        :key="c[0]"
                        v-bind:value="c[0]"
                      >
                        {{ c[1] }}
                      </option>
                    </select>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span v-if="advtID != -1" class="SelectedLabel">
                      {{ selectedAdvt }}
                    </span>
                  </div>
                </div>
                <div class="Flex_Row" style="border-top: solid thin darkgray">
                  <div class="Flex_Cell" style="width: 50%">
                    <label
                      for="ddlPostType"
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      >Post Applied For</label
                    >
                    <select
                      id="ddlPostType"
                      v-model="postTypeID"
                      v-on:change="
                        getCasteTypePostWise(), GetRecruitmentTypeRelaxation()
                      "
                    >
                      <option value="-1">---Select---</option>
                      <option
                        v-for="c in postType_List"
                        :key="c[0]"
                        v-bind:value="c[0]"
                      >
                        {{ c[1] }}
                      </option>
                    </select>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span v-if="postTypeID != -1" class="SelectedLabel">
                      {{ selectedPostType }}
                    </span>
                  </div>
                </div>
                <div class="Flex_Row" style="border-top: solid thin darkgray">
                  <div class="Flex_Cell" style="width: 50%">
                    <label
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      style="margin-bottom: 5px"
                      >Gender</label
                    >
                    <label>
                      <input
                        type="radio"
                        value="M"
                        id="rbnGenderM"
                        :disabled="true"
                        name="gender"
                        v-model="gender"
                        v-on:change="getSelectelabel()"
                      />
                      <label for="rbnGenderM">Male</label>
                      <input
                        type="radio"
                        value="F"
                        id="rbnGenderF"
                        :disabled="true"
                        name="gender"
                        v-model="gender"
                        v-on:change="getSelectelabel()"
                      />
                      <label for="rbnGenderF">Female</label>
                      <input
                        type="radio"
                        value="T"
                        id="rbnGenderT"
                        :disabled="true"
                        name="gender"
                        v-model="gender"
                        v-on:change="getSelectelabel()"
                      />
                      <label for="rbnGenderT">Transgender</label>
                    </label>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span class="SelectedLabel">{{ selectedGender }}</span>
                  </div>
                </div>
                <!-- </div>
                            </fieldset>
                            <fieldset class="EntryBlock">
                                <legend>Choose Applied Category</legend>
                <div class="Flex_Table tblEntryForm">-->
                <div class="Flex_Row" style="border-top: solid thin darkgray">
                  <div class="Flex_Cell" style="width: 50%">
                    <label
                      for="ddlappCastType"
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      style="margin-bottom: 5px"
                      >Applied Caste / Class Type</label
                    >
                    <!-- <label v-for="c in appCastType_List" :key="c[0]">
                      <input
                        type="radio"
                        :value="c[0]"
                        :id="'rbncastType' + c[0]"
                        name="castType"
                        v-model="appCastTypeID"
                        v-on:change="getSelectelabel()"
                      />
                      <label :for="'rbncastType' + c[0]">{{ c[1] }}</label>
                    </label>-->
                    <select
                      id="ddlappCastType"
                      v-model="appCastTypeID"
                      v-on:change="
                        getSelectelabel(), GetRecruitmentTypeRelaxation()
                      "
                    >
                      <option
                        v-for="c in appCastType_List"
                        :key="c[0]"
                        v-bind:value="c[0]"
                      >
                        {{ c[1] }}
                      </option>
                    </select>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span class="SelectedLabel">{{ selectedAppCastType }}</span>
                  </div>
                </div>
                <div class="Flex_Row" style="border-top: solid thin darkgray">
                  <div class="Flex_Cell" style="width: 50%">
                    <label
                      for="ddlmainCatID"
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      style="margin-bottom: 5px"
                      >Category</label
                    >
                    <!-- <label>
                      <input
                        type="radio"
                        value="-1"
                        id="rbnsubcastType"
                        name="subCastType"
                        v-model="mainCatID"
                        v-on:change="getSelectelabel()"
                      />
                      <label for="rbnsubcastType">None</label>
                    </label>
                    <label v-for="c in mainCat_List" :key="c[0]">
                      <input
                        type="radio"
                        :value="c[0]"
                        :id="'rbnsubcastType' + c[0]"
                        name="subCastType"
                        v-model="mainCatID"
                        v-on:change="getSelectelabel()"
                      />
                      <label :for="'rbnsubcastType' + c[0]">{{ c[1] }}</label>
                    </label>-->

                    <select
                      id="ddlmainCatID"
                      v-model="mainCatID"
                      v-on:change="
                        getSelectelabel(), GetRecruitmentTypeRelaxation()
                      "
                    >
                      <option value="-1">None</option>
                      <option
                        v-for="c in mainCat_List"
                        :key="c[0]"
                        v-bind:value="c[0]"
                      >
                        {{ c[1] }}
                      </option>
                    </select>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span class="SelectedLabel">{{ selectedMainCat }}</span>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span class="SelectedLabel">
                      <input
                        type="button"
                        id="btnNew"
                        name="btnNew"
                        btnName="btnNew"
                        v-show="mainCatID == 13"
                        value="Certificates eligibility for recruitment as MSP."
                        style="padding: 5px 15px 5px 15px"
                        title="Click to view Certificates eligibility for recruitment as MSP."
                        v-on:click="OpenMSPEligibilityDiv()"
                      />
                      <input
                        type="button"
                        id="btnNew"
                        name="btnNew"
                        btnName="btnNew"
                        v-show="mainCatID == 11"
                        value="Category of Disability."
                        style="padding: 5px 15px 5px 15px"
                        title="Click to view Category of Disability"
                        v-on:click="OpendisabilityCategoryDiv()"
                      />
                    </span>
                  </div>
                </div>
                <div
                  class="Flex_Row"
                  style="border-top: solid thin darkgray"
                  v-if="appCastTypeID == '5'"
                >
                  <div class="Flex_Cell" style="width: 50%">
                    <span
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      style="margin-bottom: 5px"
                    >
                      Whether You belong to Economically Weeker Sections(EWS)
                    </span>
                    <label>
                      <input
                        disabled="true"
                        type="radio"
                        value="1"
                        id="rbnEWSY"
                        name="youEWS"
                        v-model="youEWS"
                        v-on:change="getSelectelabel()"
                      />
                      <label for="rbnEWSY">Yes</label>
                      <input
                        disabled="true"
                        type="radio"
                        value="0"
                        id="rbnEWSN"
                        name="youEWS"
                        v-model="youEWS"
                        v-on:change="getSelectelabel()"
                      />
                      <label for="rbnEWSN">No</label>
                    </label>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span class="SelectedLabel">{{ selectedEWS }}</span>
                  </div>
                </div>
                <div class="Flex_Row" style="border-top: solid thin darkgray">
                  <div
                    class="Flex_Cell"
                    :style="
                      basicInformation.nationalityTypeID == '1'
                        ? 'width:50%'
                        : 'width:25%'
                    "
                  >
                    <span
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      style="margin-bottom: 5px"
                      >Nationality</span
                    >
                    <label>
                      <input
                        type="radio"
                        value="1"
                        id="rbnNationalityI"
                        name="youNationality"
                        v-model="basicInformation.nationalityTypeID"
                        v-on:change="
                          getSelectelabel(), GetRecruitmentTypeRelaxation()
                        "
                      />
                      <label for="rbnNationalityI">A citizen of India</label>
                      <input
                        type="radio"
                        value="0"
                        id="rbnNationalityNI"
                        name="youNationality"
                        v-model="basicInformation.nationalityTypeID"
                        v-on:change="
                          getSelectelabel(), GetRecruitmentTypeRelaxation()
                        "
                      />
                      <label for="rbnNationalityNI">Other</label>
                    </label>
                  </div>
                  <div
                    class="Flex_Cell"
                    style="width: 25%"
                    v-if="basicInformation.nationalityTypeID == '0'"
                  >
                    <label
                      for="ddlNationality"
                      class="mandatorySpan"
                      :class="{ Required: false }"
                      >Nationality</label
                    >
                    <select
                      id="ddlNationality"
                      v-model="basicInformation.nationalityID"
                      v-on:change="GetRecruitmentTypeRelaxation()"
                    >
                      <!-- <option value="-1">---Select---</option> -->
                      <option
                        v-for="c in Nationality_List"
                        :key="c[0]"
                        v-bind:value="c[0]"
                      >
                        {{ c[1] }}
                      </option>
                    </select>
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span class="SelectedLabel">{{ selectedNationality }}</span>
                  </div>
                </div>
                <div class="Flex_Row" style="border-top: solid thin darkgray">
                  <div class="Flex_Cell" style="width: 50%">
                    <span
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      style="margin-bottom: 5px"
                    >
                      Required Eligibility Criteria for selected post (
                      {{ selectedPostType }} )
                    </span>
                    <div v-for="c in criteria_List" :key="c.qualSetID">
                      <input
                        type="radio"
                        :value="c[0]"
                        :id="'rbn' + c[0]"
                        name="criteriaType"
                        v-model="criteriaQualSetID"
                      />
                      <label :for="'rbn' + c[0]">{{ c[1] }}</label>
                    </div>
                  </div>
                  <div class="Flex_Cell">
                    <div class="Flex_Table">
                      <div
                        class="Flex_Row"
                        v-for="(c, index) in criteriaDetail_List.filter((s) => {
                          return s[0] == criteriaQualSetID;
                        })"
                        :key="c[1]"
                      >
                        <span class="SelectedLabel">
                          {{ index + 1 + "." + c[2] }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Flex_Row" style="border-top: solid thin darkgray">
                  <div class="Flex_Cell" style="width: 50%">
                    <label
                      for="ddlRelaxationOtherType"
                      class="mandatorySpan"
                      :class="{ Required: true }"
                      style="margin-bottom: 5px"
                      >Other Relaxation</label
                    >
                    <select
                      id="ddlRelaxationOtherType"
                      v-model="relaxationTypeID"
                      v-on:change="getSelectelabel()"
                    >
                      <option value="-1">---None---</option>
                      <option
                        v-for="c in recruitmentRelaxation_List"
                        :key="c[0]"
                        v-bind:value="c[0]"
                      >
                        {{ c[1] }}
                      </option>
                    </select>
                  </div>
                  <div class="Flex_Cell" style="width: 50%" valign="middle">
                    <span class="SelectedLabel">
                      {{ selectedrecruitmentRelaxation }}
                    </span>
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="Flex_Table tblEntryForm">
              <div class="Flex_Row" style="border-top: solid thin darkgray">
                <div class="Flex_Cell" align="center" valign="middle">
                  <input
                    type="button"
                    id="btnNew"
                    name="btnNew"
                    btnName="btnNew"
                    value="I Agree"
                    style="padding: 5px 15px 5px 15px"
                    title="Click to New Application"
                    v-on:click="confirmNewApplication()"
                  />
                  <input
                    type="button"
                    id="btnDisAgreeNew"
                    name="btnDisAgreeNew"
                    btnName="btnDisAgreeNew"
                    value="Go Back"
                    style="padding: 5px 15px 5px 15px"
                    v-on:click="isNew = !isNew"
                  />
                </div>
              </div>
            </div>
          </fieldset>
          <!-- </transition> -->
        </div>
        <div class="Flex_Cell" style="width: 4px"></div>
      </div>
    </div>
    <transition name="fade">
      <div class="Flex_Table" v-if="!isShowLoad">
        <div class="Flex_Row">
          <div class="Flex_Cell">
            <div class="Flex_Table tblEntryForm AppHeader">
              <div class="Flex_Row">
                <div
                  class="Flex_Cell"
                  style="width: 30%"
                  :class="isReject == '1' ? 'statusReject' : 'myAppNo'"
                >
                  <span class="mandatorySpan" :class="{ Required: false }"
                    >Application No.</span
                  >
                  <span style="font-weight: bold; font-size: large">
                    {{ applicationNo }}
                  </span>
                </div>
                <div
                  style="width: 44%"
                  class="Flex_Cell"
                  align="right"
                  valign="middle"
                >
                  <span style="font-size: 99%; color: green"
                    >It's a good practice to keep saving your data
                    regularly</span
                  >
                </div>
                <div
                  class="Flex_Cell"
                  style="width: 25%"
                  align="right"
                  valign="bottom"
                >
                  <span
                    style="text-align: right; color: #8a0000; font-weight: bold"
                    >* Fields are mandatory
                  </span>
                  <!-- <input
                    type="button"
                    id="btnPreviewApp"
                    name="btnPreviewApp"
                    btnName="btnPreviewApp"
                    value="Print View of Application"
                    style="padding: 5px 15px 5px 15px"
                    title="Click to Print View of Application"
                    v-on:click="printApplicationForm(null, 2)"
                    v-if="isSubmit == 0 && isExpired == 0"
                  /> -->
                  <input
                    type="button"
                    id="btnSaveApp"
                    name="btnSaveApp"
                    btnName="btnSaveApp"
                    value="Save"
                    style="padding: 5px 15px 5px 15px"
                    title="Click to Save Application"
                    v-on:click="saveApplication(0)"
                    v-if="isSubmit == 0 && isExpired == 0"
                  />
                  <input
                    v-if="!isShowLoad"
                    type="button"
                    id="btnBack"
                    name="btnBack"
                    btnName="btnBack"
                    value="Back"
                    style="padding: 5px 15px 5px 15px"
                    title="Click to Back"
                    v-on:click="clickToBack()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="Flex_Row">
          <div class="Flex_Cell">
            <fieldset class="EntryBlock">
              <legend style="background-color: transparent !important">
                <div
                  class="Flex_Table tblEntryForm"
                  style="margin-left: -10px; margin-bottom: 3px"
                >
                  <div class="Flex_Row">
                    <div class="Flex_Cell_Inline">
                      <span
                        :class="selectTab1 ? 'tabSelectClass' : 'tabClass'"
                        v-on:click="tabClick(1)"
                        >Personal Details</span
                      >
                    </div>
                    <div class="Flex_Cell_Inline">
                      <span
                        :class="selectTab2 ? 'tabSelectClass' : 'tabClass'"
                        v-on:click="tabClick(2)"
                        >Education & Additional Details</span
                      >
                    </div>
                    <div class="Flex_Cell_Inline">
                      <span
                        :class="selectTab5 ? 'tabSelectClass' : 'tabClass'"
                        v-on:click="tabClick(5)"
                        >Other Details</span
                      >
                    </div>
                    <div class="Flex_Cell_Inline">
                      <span
                        :class="selectTab3 ? 'tabSelectClass' : 'tabClass'"
                        v-on:click="tabClick(3)"
                        >Uploading Documents</span
                      >
                    </div>
                    <div class="Flex_Cell_Inline">
                      <span
                        :class="selectTab4 ? 'tabSelectClass' : 'tabClass'"
                        v-on:click="tabClick(4)"
                        >Declaration</span
                      >
                    </div>
                  </div>
                </div>
              </legend>
              <div
                class="Flex_Table tblEntryForm statusReject"
                v-if="isReject == '1'"
                style="margin-left: 10px; margin-bottom: 3px; width: 99%"
              >
                <div class="Flex_Row myHeaderRow">
                  <div
                    class="Flex_Cell"
                    style="width: 5%"
                    align="center"
                    valign="middle"
                  >
                    Sr. No.
                  </div>
                  <div class="Flex_Cell" valign="middle">Reject Reason</div>
                </div>
                <div
                  class="Flex_Row"
                  v-for="(r, index) in candRejectReason"
                  :key="r[1]"
                >
                  <div
                    class="Flex_Cell"
                    style="width: 5%"
                    align="center"
                    valign="middle"
                  >
                    {{ index + 1 }}
                  </div>
                  <div class="Flex_Cell" valign="middle">
                    <span class="mandatorySpan" :class="{ Required: false }">
                      {{ r[1] }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                style="
                  overflow-y: auto;
                  overflow-x: hidden;
                  height: calc(100vh - 230px);
                  width: 100%;
                "
                id="divMainData"
              >
                <div ref="tab1" v-show="selectTab1" style="border: none">
                  <fieldset class="EntryBlock">
                    <legend>Primary Information</legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="ddlTitle"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Title</label
                          >
                          <select
                            id="ddlTitle"
                            ref="titleID"
                            v-model="basicInformation.titleID"
                            :disabled="true"
                          >
                            <option value="-1">---Select---</option>
                            <option value="1">Mr.</option>
                            <option value="2">Ms.</option>
                          </select>
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtFirstName"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >First Name</label
                          >
                          <AcceptInput
                            :isRequired="true"
                            placeholder="First Name"
                            id="txtFirstName"
                            ref="txtFirstName"
                            v-model="basicInformation.firstName"
                            maxlength="256"
                            regExp="([a-zA-Z\s])*"
                            title="Enter first name as matriculation certificate"
                            :disabled="true"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtMiddleName"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Middle Name</label
                          >
                          <AcceptInput
                            placeholder="Middle Name"
                            ref="txtMiddleName"
                            id="txtMiddleName"
                            v-model="basicInformation.middleName"
                            maxlength="256"
                            regExp="([a-zA-Z\s])*"
                            title="Enter middle name as matriculation certificate"
                            :disabled="true"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtLastName"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Last Name</label
                          >
                          <AcceptInput
                            placeholder="Last Name"
                            ref="txtLastName"
                            id="txtLastName"
                            v-model="basicInformation.lastName"
                            maxlength="256"
                            regExp="([a-zA-Z\s])*"
                            title="Enter last name as matriculation certificate"
                            :disabled="true"
                          />
                        </div>
                      </div>
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtfatherName"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Father's Full Name</label
                          >
                          <AcceptInput
                            placeholder="Father's Name"
                            ref="txtfatherName"
                            id="txtfatherName"
                            v-model="basicInformation.fatherName"
                            maxlength="156"
                            regExp="([a-zA-Z\s])*"
                            title="Enter father name "
                            :disabled="true"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtMotherName"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Mother's Name</label
                          >
                          <AcceptInput
                            placeholder="Mother's Name"
                            ref="txtMotherName"
                            id="txtMotherName"
                            v-model="basicInformation.motherName"
                            maxlength="156"
                            regExp="([a-zA-Z\s])*"
                            title="Enter mother name "
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >DOB</span
                          >
                          <DateControl
                            :disabled="true"
                            :isRequired="true"
                            v-model="basicInformation.dob"
                            :showDate="true"
                            title="Enter Date of birth"
                          ></DateControl>
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="ddlReligion"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Religion</label
                          >
                          <select
                            ref="ddlReligion"
                            id="ddlReligion"
                            v-model="basicInformation.religionID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in religion_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtPhoneNumber"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Phone No. with STD Code</label
                          >
                          <AcceptInput
                            ref="txtPhoneNumber"
                            id="txtPhoneNumber"
                            v-model="basicInformation.phoneNumber"
                            title="Your residential landline number (optional)"
                            regExp="([+0-9\\s\\-])*"
                            maxlength="12"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtMobileNumber"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Mobile No.</label
                          >
                          <AcceptInput
                            :isRequired="true"
                            type="mobile"
                            ref="txtMobileNumber"
                            id="txtMobileNumber"
                            v-model="basicInformation.mobileNumberDisplay"
                            title="Your mobile number on which all updates can be received"
                            :disabled="true"
                            maxlength="12"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtEmailID"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Email</label
                          >
                          <AcceptInput
                            :disabled="true"
                            type="email"
                            ref="txtEmailID"
                            id="txtEmailID"
                            :isRequired="true"
                            v-model="basicInformation.emailIDDisplay"
                            title="Your email ID on which communication will be sent"
                            maxlength="50"
                          ></AcceptInput>
                        </div>
                        <div class="Flex_Cell" style="width: 25%" v-if="false">
                          <label
                            for="txtUIDAINo"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                          >
                            Aadhaar No.
                            {{
                              basicInformation.aadhaarNumberDisplay != ""
                                ? basicInformation.aadhaarNumberDisplay
                                    .substring(
                                      basicInformation.aadhaarNumberDisplay
                                        .length - 4
                                    )
                                    .padStart(
                                      basicInformation.aadhaarNumberDisplay
                                        .length,
                                      "*"
                                    )
                                : ""
                            }}
                          </label>
                          <!-- <AcceptInput
                            placeholder="UIDAINo"
                            ref="txtUIDAINo"
                            v-model="basicInformation.aadhaarNumber"
                            type="text"
                            title="Enter your Aadhar Number"
                            maxlength="12"
                            @keypress="isNumber($event)"
                            @click.right.prevent
                            @copy.prevent
                            @paste.prevent
                          />-->
                          <input
                            type="text"
                            id="txtUIDAINo"
                            v-model="basicInformation.aadhaarNumber"
                            ref="txtUIDAINo"
                            v-if="false"
                            placeholder="Enter your Aadhar Number"
                            @keypress="isNumber($event)"
                            @click.right.prevent
                            @copy.prevent
                            @paste.prevent
                            maxlength="12"
                          />
                        </div>
                      </div>
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="ddlMStatus"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Marital Status</label
                          >
                          <select
                            id="ddlMStatus"
                            ref="ddlMStatus"
                            v-model="basicInformation.maritalStatusID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in maritalStatus_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="IdMark"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Identification Mark</label
                          >
                          <AcceptInput
                            placeholder="Enter Identification Marks"
                            ref="IdMark"
                            id="IdMark"
                            v-model="basicInformation.IdMark"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                            maxlength="250"
                            title="Enter Identification Marks"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="this.basicInformation.nationalityID == 1"
                        >
                          <label
                            for="ddlDomicile"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >State of Origin(Domicile)</label
                          >
                          <select
                            ref="domicileStateID"
                            id="ddlDomicile"
                            v-model="basicInformation.domicileStateID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in state_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="basicInformation.domicileStateID == 2"
                        >
                          <span
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Domicile From</span
                          >
                          <DateControl
                            ref="domicileFrom"
                            v-model="basicInformation.domicileFrom"
                            :showDate="true"
                            title="Enter domicile From Date"
                          ></DateControl>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="basicInformation.domicileStateID == 2"
                        >
                          <span
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Domicile To</span
                          >
                          <DateControl
                            ref="domicileTo"
                            v-model="basicInformation.domicileTo"
                            :showDate="true"
                            title="Enter domicile To Date"
                          ></DateControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="EntryBlock">
                    <legend>Correspondence Address</legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 50%">
                          <label
                            for="correspondence_address"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >House No./ Village</label
                          >
                          <textarea
                            ref="address"
                            id="correspondence_address"
                            v-model="correspondanceAddress.address"
                            placeholder="Enter Correspondence Address"
                            title="Enter Correspondence Address"
                            maxlength="500"
                            v-on:keypress="validateAddress($event)"
                            @click.right.prevent
                            @copy.prevent
                            @paste.prevent
                          ></textarea>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="this.basicInformation.nationalityID == 1"
                        >
                          <label
                            for="ddlState_Correspondance"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >State</label
                          >
                          <select
                            ref="ddlState"
                            id="ddlState_Correspondance"
                            v-model="correspondanceAddress.stateID"
                            v-on:change="setDistrict(1)"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in state_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="this.basicInformation.nationalityID == 1"
                        >
                          <label
                            for="ddlDistrict_Correspondance"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >District</label
                          >
                          <select
                            ref="districtID"
                            id="ddlDistrict_Correspondance"
                            v-model="correspondanceAddress.districtID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in district_List.filter((s) => {
                                return s[2] == correspondanceAddress.stateID;
                              })"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="Flex_Row">
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="this.basicInformation.nationalityID == 1"
                        >
                          <label
                            for="txtCityName"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >PO</label
                          >
                          <AcceptInput
                            placeholder="Post Office"
                            ref="txtCityName"
                            id="txtCityName"
                            v-model="correspondanceAddress.city"
                            maxlength="100"
                            regExp="([a-zA-Z\s])*"
                            title="Enter Post Office"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="pinCode"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Pin</label
                          >
                          <AcceptInput
                            ref="pinCode"
                            id="pinCode"
                            placeholder="Pin Code"
                            v-model="correspondanceAddress.pinCode"
                            regExp="([0-9])*"
                            maxlength="6"
                            title="Enter Pin Code"
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="EntryBlock">
                    <legend>
                      <table>
                        <tr>
                          <td valign="middle">Permanent Address</td>
                          <td style="width: 25px" valign="middle"></td>
                          <td valign="middle">
                            <input
                              type="checkbox"
                              id="chkSameAsCorrespondance"
                              v-on:change="SameAsCorrespondance"
                              v-model="IsSameAsCorrespondance"
                            />
                            <label for="chkSameAsCorrespondance"
                              >Same As Correspondence</label
                            >
                          </td>
                        </tr>
                      </table>
                    </legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 50%">
                          <label
                            for="permanentAddress"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >House No./ Village</label
                          >
                          <textarea
                            ref="permanentAddress"
                            id="permanentAddress"
                            v-model="addressInformation.address"
                            placeholder="Enter Permanent Address"
                            title="Enter Permanent address"
                            maxlength="500"
                            v-on:keypress="validateAddress($event)"
                            @click.right.prevent
                            @copy.prevent
                            @paste.prevent
                          ></textarea>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="this.basicInformation.nationalityID == 1"
                        >
                          <label
                            for="ddlState"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >State</label
                          >
                          <select
                            ref="permanentStateID"
                            id="ddlState"
                            v-model="addressInformation.stateID"
                            v-on:change="setDistrict(2)"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in state_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>

                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="this.basicInformation.nationalityID == 1"
                        >
                          <label
                            for="ddlDistrict_Permanent"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >District</label
                          >
                          <select
                            ref="permanentDistrictID"
                            id="ddlDistrict_Permanent"
                            v-model="addressInformation.districtID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in district_List.filter((s) => {
                                return s[2] == addressInformation.stateID;
                              })"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="Flex_Row">
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="this.basicInformation.nationalityID == 1"
                        >
                          <label
                            for="txtPerCityName"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >PO</label
                          >
                          <AcceptInput
                            placeholder="Post Office"
                            ref="txtPerCityName"
                            id="txtPerCityName"
                            v-model="addressInformation.city"
                            maxlength="100"
                            regExp="([a-zA-Z\s])*"
                            title="Enter Post Office"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="permanentPinCode"
                            class="mandatorySpan"
                            :class="{ Required: true }"
                            >Pin</label
                          >
                          <AcceptInput
                            ref="permanentPinCode"
                            id="permanentPinCode"
                            placeholder="Pin Code"
                            v-model="addressInformation.pinCode"
                            regExp="([0-9])*"
                            maxlength="6"
                            title="Enter Pin Code"
                          />
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="EntryBlock">
                    <legend>Caste Category and others</legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 25%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Caste Type</span
                          >
                          <label
                            v-for="c in appCastTypeCand_List"
                            :key="c.castTypeID"
                          >
                            <input
                              type="radio"
                              :value="c[0]"
                              :id="'rbncastType1' + c[0]"
                              name="castType"
                              :disabled="
                                basicInformation.candAppCastTypeID == '1'
                                  ? false
                                  : true
                              "
                              v-model="basicInformation.castTypeID"
                            />
                            <label :for="'rbncastType1' + c[0]">
                              {{ c[1] }}
                            </label>
                          </label>
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="txtcastName"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Sub Caste</label
                          >
                          <AcceptInput
                            placeholder="Sub Caste"
                            ref="txtcastName"
                            id="txtcastName"
                            v-model="basicInformation.castName"
                            maxlength="100"
                            regExp="([a-zA-Z\s])*"
                            title="Enter Sub Caste"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 30%"
                          v-if="basicInformation.candMainCatID == 11"
                        >
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Physically Handicapped (Only 40% and above)</span
                          >
                          <label
                            disabled="basicInformation.candMainCatID=='11'? true:false"
                          >
                            <input
                              type="radio"
                              value="1"
                              id="rbnphyY"
                              name="isphy"
                              v-model="basicInformation.isPhyHandicap"
                              :disabled="true"
                            />
                            <label for="rbnphyY">Yes</label>
                            <input
                              type="radio"
                              value="0"
                              id="rbnphyN"
                              name="isphy"
                              :disabled="true"
                              v-model="basicInformation.isPhyHandicap"
                              v-on:change="
                                basicInformation.physicalHTypeID = '-';
                                basicInformation.phyHandiPercentage = '';
                              "
                            />
                            <label for="rbnphyN">No</label>
                          </label>
                          <select
                            ref="physicalHTypeID"
                            id="ddlPhType"
                            v-model="basicInformation.physicalHTypeID"
                            style="width: 50%"
                            :disabled="basicInformation.isPhyHandicap == '0'"
                            @change="phTypeChange()"
                          >
                            <option value="-">---Select---</option>
                            <option
                              v-for="c in physicalHandicap_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 20%"
                          :disabled="basicInformation.isPhyHandicap == '0'"
                          v-if="basicInformation.candMainCatID == 11"
                        >
                          <span
                            for="phyHandiPercentage"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Percentage</span
                          >
                          <AcceptInput
                            ref="phyHandiPercentage"
                            id="phyHandiPercentage"
                            :disabled="basicInformation.isPhyHandicap == '0'"
                            placeholder="physical handi percentage"
                            v-model="basicInformation.phyHandiPercentage"
                            regExp="([0-9])*"
                            maxlength="2"
                            title="Enter physical handicap percentage"
                          />
                        </div>
                      </div>
                      <div
                        class="Flex_Row"
                        v-if="
                          basicInformation.candMainCatID == 11 && !isscribeHide
                        "
                      >
                        <div class="Flex_Cell" style="width: 25%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Requirement of Scribe</span
                          >
                          <label>
                            <input
                              type="radio"
                              value="0"
                              id="rbnScribeN"
                              name="isScribe"
                              v-model="basicInformation.IsReqForScribe"
                            />
                            <label for="rbnScribeN">No</label>
                            <input
                              type="radio"
                              value="1"
                              id="rbnOwnScribeY"
                              name="isScribe"
                              v-model="basicInformation.IsReqForScribe"
                            />
                            <label for="rbnOwnScribeY">Own Scribe</label>
                            <input
                              type="radio"
                              value="2"
                              id="rbnEcScribe"
                              name="isScribe"
                              v-model="basicInformation.IsReqForScribe"
                            />
                            <label for="rbnEcScribe">Exam Center Scribe</label>
                          </label>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div ref="tab2" v-show="selectTab2" style="border: none">
                  <fieldset class="EntryBlock">
                    <legend>
                      <div class="Flex_Table" style="width: 100%">
                        <div class="Flex_Row">
                          <div class="Flex_Cell">
                            Mandatory Qualification (Fill Marks/Grade/CGPA/CPI.
                            Fill Correct Aggregate % As Per Respective Board
                            Norms. Candidature will be rejected if Aggregate %
                            found incorrect at any stage)
                          </div>
                        </div>
                      </div>
                    </legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row myHeaderRow">
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 3%"
                        >
                          Sr.No.
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Qualification
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Roll No.
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          School/College Name
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <span v-if="basicInformation.nationalityID == 1"
                            >State</span
                          >
                          <span v-else>Country</span>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 15%"
                          valign="middle"
                        >
                          Board/University
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 11%"
                        >
                          Passing Year
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 6%"
                        >
                          Total Marks
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 6%"
                        >
                          Is Grade / CGPA / CPI
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 8%"
                        >
                          Marks / Grade / CGPA / CPI Obtained
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 6%"
                        >
                          Aggregate %
                        </div>
                      </div>
                      <div
                        style="border-bottom: solid 1px darkgrey"
                        class="Flex_Row"
                        v-for="(qual, index) in candQualOne"
                        :key="index"
                      >
                        <div
                          class="Flex_Cell"
                          align="center"
                          valign="middle"
                          style="width: 3%"
                        >
                          {{ index + 1 }}
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <span>{{ qual[4] }}</span>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <AcceptInput
                            :ref="'qualOnetxtRollno_' + index"
                            placeholder="Roll No."
                            v-model="qual[10]"
                            title="Enter Roll No."
                            maxlength="250"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          <AcceptInput
                            :ref="'qualOneSchoolName_' + index"
                            placeholder="School / College Name"
                            v-model="qual[11]"
                            title="Enter School / College name"
                            maxlength="500"
                            regExp="([a-zA-Z\s])*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <select
                            id="ddlState"
                            :ref="'qualOneState_' + index"
                            v-model="qual[12]"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in state_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 15%"
                          valign="middle"
                        >
                          <table width="100%">
                            <tr>
                              <td>
                                <select
                                  id="ddlUniver"
                                  :ref="'qualOneddlUniver_' + index"
                                  v-model="qual[13]"
                                >
                                  <option value="-1">---Select---</option>
                                  <option
                                    v-for="c in university_List.filter((u) => {
                                      if (qual[1] == '1' || qual[1] == '2') {
                                        return u[2] == '2' || u[2] == '0';
                                      } else {
                                        return u[2] == '1' || u[2] == '0';
                                      }
                                    })"
                                    :key="c[0]"
                                    v-bind:value="c[0]"
                                  >
                                    {{ c[1] }}
                                  </option>
                                </select>
                              </td>
                            </tr>
                            <tr v-if="qual[13] == 0">
                              <td>
                                <AcceptInput
                                  :ref="'qualOneBoardName_' + index"
                                  placeholder="Enter Board / Univerity"
                                  v-model="qual[14]"
                                  title="Enter Board / Univerity name"
                                  maxlength="500"
                                  regExp="([a-zA-Z\s])*"
                                />
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 11%"
                        >
                          <select
                            id="ddlYear"
                            :ref="'qualOneYear_' + index"
                            v-model="qual[15]"
                          >
                            <option value>--</option>
                            <option
                              v-for="c in year_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[0] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 6%"
                        >
                          <AcceptInput
                            :ref="'qualOneTotalMark_' + index"
                            placeholder="Total Marks"
                            v-model="qual[19]"
                            regExp="([0-9])*"
                            maxlength="4"
                            title="Enter Total Marks"
                            v-on:keyup="calcAggregate($event, qual)"
                          />
                        </div>
                        <div
                          class="Flex_Cell edit"
                          align="center"
                          valign="middle"
                          style="width: 6%"
                        >
                          <span
                            class="glyphicons unchecked"
                            v-on:click="gradeChange(qual, index)"
                            style="cursor: pointer"
                            title="Please checked to enter Grade / CGPA / CPI"
                            v-if="qual[16] == '0'"
                          ></span>
                          <span
                            v-else
                            class="glyphicons check"
                            v-on:click="gradeChange(qual, index)"
                            style="cursor: pointer"
                            title="Please unchecked to enter Marks"
                          ></span>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 8%"
                        >
                          <AcceptInput
                            :ref="'qualOneMarkObtained_' + index"
                            v-if="qual[16] == '0'"
                            placeholder="Marks Obtained"
                            v-model="qual[18]"
                            regExp="([0-9])+([.]){0,1}([0-9]){0,2}"
                            maxlength="5"
                            title="Enter Marks Obtained"
                            v-on:keyup="calcAggregate($event, qual)"
                          />
                          <input
                            v-else
                            type="text"
                            v-model="qual[17]"
                            maxlength="4"
                            title="Enter Grade / CGPA / CPI Obtained"
                            :ref="'qualOneMarkGrade_' + index"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 6%"
                        >
                          <AcceptInput
                            :ref="'qualOneAggregate_' + index"
                            placeholder="Aggregate %"
                            v-model="qual[20]"
                            regExp="([0-9])+([.]){0,1}([0-9]){0,2}"
                            maxlength="5"
                            title="Enter Aggregate %"
                          />
                        </div>
                      </div>
                    </div>
                    <fieldset class="EntryBlock">
                      <legend>Miscellaneous Qualification</legend>
                      <div class="Flex_Table tblEntryForm">
                        <div class="Flex_Row myHeaderRow">
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 10%"
                          >
                            Qualification
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 10%"
                          >
                            Roll No.
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            School/College Name
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 10%"
                          >
                            <span v-if="basicInformation.nationalityID == 1"
                              >State</span
                            >
                            <span v-else>Country</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 15%"
                            valign="middle"
                          >
                            Board/University
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 11%"
                          >
                            Passing Year
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 6%"
                          >
                            Total Marks
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 6%"
                          >
                            Is Grade / CGPA / CPI
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 8%"
                          >
                            Marks / Grade / CGPA / CPI Obtained
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 6%"
                          >
                            Aggregate %
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 3%"
                          >
                            Add New
                          </div>
                        </div>
                        <div
                          style="border-bottom: solid 1px darkgrey"
                          class="Flex_Row"
                          v-for="(qual, index) in candQualTwo"
                          :key="index"
                        >
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 10%"
                          >
                            <table width="100%">
                              <tr>
                                <td>
                                  <select
                                    id="ddlQualType"
                                    v-model="qual[1]"
                                    v-on:change="onSelectOtherQual(qual, index)"
                                  >
                                    <option value="-1">---Select---</option>
                                    <option
                                      v-for="c in RelistQualMaster"
                                      :key="c[0]"
                                      v-bind:value="c[0]"
                                    >
                                      {{ c[1] }}
                                    </option>
                                  </select>
                                </td>
                              </tr>
                              <tr>
                                <AcceptInput
                                  :ref="'qualTwoQualName_' + index"
                                  v-if="qual[1] == 0"
                                  placeholder="Enter Qualification Name"
                                  v-model="qual[4]"
                                  title="Enter Qualification Name"
                                  maxlength="500"
                                  regExp="([a-zA-Z\s])*"
                                />
                              </tr>
                            </table>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 10%"
                          >
                            <AcceptInput
                              :ref="'qualTwoRollNo_' + index"
                              placeholder="Roll No."
                              v-model="qual[10]"
                              title="Enter Roll No."
                              maxlength="250"
                              regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <AcceptInput
                              :ref="'qualTwoSchoolName_' + index"
                              placeholder="School / College Name"
                              v-model="qual[11]"
                              title="Enter School / College name"
                              maxlength="500"
                              regExp="([a-zA-Z\s])*"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 10%"
                          >
                            <select
                              id="ddlState"
                              :ref="'qualTwoState_' + index"
                              v-model="qual[12]"
                            >
                              <option value="-1">---Select---</option>
                              <option
                                v-for="c in state_List"
                                :key="c[0]"
                                v-bind:value="c[0]"
                              >
                                {{ c[1] }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 15%"
                            valign="middle"
                          >
                            <table width="100%">
                              <tr>
                                <td>
                                  <select
                                    id="ddlUniver"
                                    :ref="'qualTwoUniver_' + index"
                                    v-model="qual[13]"
                                  >
                                    <option value="-1">---Select---</option>
                                    <option
                                      v-for="c in university_List.filter(
                                        (u) => {
                                          if (
                                            qual[1] == '1' ||
                                            qual[1] == '2'
                                          ) {
                                            return u[2] == '2' || u[2] == '0';
                                          } else {
                                            return u[2] == '1' || u[2] == '0';
                                          }
                                        }
                                      )"
                                      :key="c[0]"
                                      v-bind:value="c[0]"
                                    >
                                      {{ c[1] }}
                                    </option>
                                  </select>
                                </td>
                              </tr>
                              <tr v-if="qual[13] == 0">
                                <td>
                                  <AcceptInput
                                    :ref="'qualTwoBoard_' + index"
                                    placeholder="Enter Board / Univerity"
                                    v-model="qual[14]"
                                    title="Enter Board / Univerity name"
                                    maxlength="500"
                                    regExp="([a-zA-Z\s])*"
                                  />
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 11%"
                          >
                            <select
                              id="ddlYear"
                              :ref="'qualTwoYear_' + index"
                              v-model="qual[15]"
                            >
                              <option value>--</option>
                              <option
                                v-for="c in year_List"
                                :key="c[0]"
                                v-bind:value="c[0]"
                              >
                                {{ c[0] }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 6%"
                          >
                            <AcceptInput
                              :ref="'qualTwoTotalMarks_' + index"
                              placeholder="Total Marks"
                              v-model="qual[19]"
                              regExp="([0-9])*"
                              maxlength="4"
                              title="Enter Total Marks"
                              v-on:keyup="
                                calcMiscellaneousAggregate($event, qual)
                              "
                            />
                          </div>
                          <div
                            class="Flex_Cell edit"
                            align="center"
                            valign="middle"
                            style="width: 6%"
                          >
                            <span
                              class="glyphicons unchecked"
                              v-on:click="gradeMiscellaneousChange(qual, index)"
                              style="cursor: pointer"
                              title="Please checked to enter Grade / CGPA / CPI"
                              v-if="qual[16] == '0'"
                            ></span>
                            <span
                              v-else
                              class="glyphicons check"
                              v-on:click="gradeMiscellaneousChange(qual, index)"
                              style="cursor: pointer"
                              title="Please unchecked to enter Marks"
                            ></span>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 8%"
                          >
                            <AcceptInput
                              :ref="'qualTwoMarkObtained_' + index"
                              v-if="qual[16] == '0'"
                              placeholder="Marks Obtained"
                              v-model="qual[18]"
                              regExp="([0-9])+([.]){0,1}([0-9]){0,2}"
                              maxlength="5"
                              title="Enter Marks Obtained"
                              v-on:keyup="
                                calcMiscellaneousAggregate($event, qual)
                              "
                            />
                            <input
                              v-else
                              type="text"
                              v-model="qual[17]"
                              maxlength="4"
                              title="Enter Grade / CGPA / CPI Obtained"
                              :ref="'qualTwoGradeObtained_' + index"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 6%"
                          >
                            <AcceptInput
                              placeholder="Aggregate %"
                              v-model="qual[20]"
                              regExp="([0-9])+([.]){0,1}([0-9]){0,2}"
                              maxlength="5"
                              title="Enter Aggregate %"
                              :ref="'qualTwoAggregate_' + index"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 3%"
                            valign="middle"
                            align="center"
                          >
                            <span
                              v-if="
                                index + 1 == candQualTwo.length &&
                                candQualTwo.length > 1
                              "
                              class="glyphicons Red bin"
                              v-on:click="
                                DeleteMiscelleniousQualification(qual, index)
                              "
                              style="cursor: pointer"
                              title="Delete this row"
                            ></span>
                            <span
                              v-if="index + 1 == candQualTwo.length"
                              class="glyphicons circle_plus"
                              v-on:click="AddNewMiscelleniousQualification()"
                              style="cursor: pointer"
                              title="Add New"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset
                      class="EntryBlock"
                      v-if="candOtherQualOne.length > 0"
                    >
                      <legend>Mandatory Experience / Certificate</legend>
                      <div class="Flex_Table tblEntryForm">
                        <div class="Flex_Row myHeaderRow">
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 5%"
                          >
                            Sr. No.
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Trade
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Name of Institution
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Govt/Private
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Recognised By
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Duration of Experience/Certificate In Years
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 15%"
                            valign="middle"
                          >
                            Duration of Experience/Certificate In Months
                          </div>
                        </div>
                        <div
                          style="border-bottom: solid 1px darkgrey"
                          class="Flex_Row"
                          v-for="(qual, index) in candOtherQualOne"
                          :key="index"
                        >
                          <div
                            class="Flex_Cell"
                            align="center"
                            valign="middle"
                            style="width: 5%"
                          >
                            {{ index + 1 }}
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <span>{{ qual[4] }}</span>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <AcceptInput
                              placeholder="Name of Institution"
                              v-model="qual[10]"
                              title="Enter Name of Institution"
                              maxlength="250"
                              regExp="([a-zA-Z\s])*"
                              :ref="'qualOtherInstName_' + index"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <select id="ddlInstType" v-model="qual[11]">
                              <option value="1">Government</option>
                              <option value="2">Private</option>
                            </select>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <AcceptInput
                              placeholder="Recognised By"
                              v-model="qual[12]"
                              title="Enter Recognised By"
                              maxlength="500"
                              regExp="([a-zA-Z\s])*"
                              :ref="'qualOtherRecognised_' + index"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <select
                              id="ddlExpYear"
                              :ref="'qualOtherYear_' + index"
                              v-model="qual[13]"
                            >
                              <option
                                v-for="c in expYear_List"
                                :key="c[0]"
                                v-bind:value="c[0]"
                              >
                                {{ c[0] }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 15%"
                            valign="middle"
                          >
                            <select
                              id="ddlExpMonth"
                              :ref="'qualOtherExpMonth_' + index"
                              v-model="qual[14]"
                            >
                              <option
                                v-for="c in expMonth_List"
                                :key="c[0]"
                                v-bind:value="c[0]"
                              >
                                {{ c[0] }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset class="EntryBlock">
                      <legend>Miscellaneous Experience</legend>
                      <div class="Flex_Table tblEntryForm">
                        <div class="Flex_Row myHeaderRow">
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 5%"
                          >
                            Sr. No.
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Trade
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Name of Institution
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Govt/private
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Recognised By
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            Experience In Years
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 15%"
                            valign="middle"
                          >
                            Experience In Months
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 5%"
                            valign="middle"
                          >
                            Add New
                          </div>
                        </div>
                        <div
                          style="border-bottom: solid 1px darkgrey"
                          class="Flex_Row"
                          v-for="(qual, index) in candOtherQualTwo"
                          :key="index"
                        >
                          <div
                            class="Flex_Cell"
                            align="center"
                            valign="middle"
                            style="width: 5%"
                          >
                            {{ index + 1 }}
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <table width="100%">
                              <tr>
                                <td>
                                  <select
                                    id="ddlQualType"
                                    v-model="qual[1]"
                                    v-on:change="onSelectOtherExp(qual, index)"
                                  >
                                    <option value="-1">---Select---</option>
                                    <option
                                      v-for="c in qualCertificateMaster_List"
                                      :key="c[0]"
                                      v-bind:value="c[0]"
                                    >
                                      {{ c[1] }}
                                    </option>
                                  </select>
                                </td>
                              </tr>
                              <tr>
                                <AcceptInput
                                  v-if="qual[1] == 0"
                                  placeholder="Enter Experience Name"
                                  v-model="qual[4]"
                                  title="Enter Experience Name"
                                  maxlength="500"
                                  regExp="([a-zA-Z\s])*"
                                  :ref="'qualOtherTwoExpName_' + index"
                                />
                              </tr>
                            </table>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <AcceptInput
                              placeholder="Name of Institution"
                              v-model="qual[10]"
                              title="Enter Name of Institution"
                              maxlength="500"
                              regExp="([a-zA-Z\s])*"
                              :ref="'qualOtherTwoInstName_' + index"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <select id="ddlInstType" v-model="qual[11]">
                              <option value="1">Government</option>
                              <option value="2">Private</option>
                            </select>
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <AcceptInput
                              placeholder="Recognised By"
                              v-model="qual[12]"
                              title="Enter Recognised By"
                              maxlength="500"
                              regExp="([a-zA-Z\s])*"
                              :ref="'qualOtherTwoRecognised_' + index"
                            />
                          </div>
                          <div
                            class="Flex_Cell"
                            valign="middle"
                            style="width: 15%"
                          >
                            <select
                              id="ddlExpYear"
                              :ref="'qualOtherTwoYear_' + index"
                              v-model="qual[13]"
                            >
                              <option
                                v-for="c in expYear_List"
                                :key="c[0]"
                                v-bind:value="c[0]"
                              >
                                {{ c[0] }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 15%"
                            valign="middle"
                          >
                            <select
                              id="ddlExpMonth"
                              :ref="'qualOtherTwoMonth_' + index"
                              v-model="qual[14]"
                            >
                              <option
                                v-for="c in expMonth_List"
                                :key="c[0]"
                                v-bind:value="c[0]"
                              >
                                {{ c[0] }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="Flex_Cell"
                            style="width: 5%"
                            valign="middle"
                            align="center"
                          >
                            <span
                              v-if="
                                index + 1 == candOtherQualTwo.length &&
                                candOtherQualTwo.length > 1
                              "
                              class="glyphicons bin"
                              v-on:click="
                                DeleteMiscelleniousExperience(qual, index)
                              "
                              style="cursor: pointer"
                              title="Delete this row"
                            ></span>
                            <span
                              v-if="index + 1 == candOtherQualTwo.length"
                              class="glyphicons circle_plus"
                              v-on:click="AddNewMiscelleniousExperience()"
                              style="cursor: pointer"
                              title="Add New"
                            ></span>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </fieldset>
                </div>
                <div ref="tab5" v-show="selectTab5" style="border: none">
                  <fieldset
                    class="EntryBlock"
                    v-if="basicInformation.isExServiceMan == '1'"
                  >
                    <legend>
                      <table>
                        <tr>
                          <td valign="middle">Ex-Serviceman</td>
                          <td style="width: 5px"></td>
                          <td
                            valign="middle"
                            v-if="basicInformation.relaxationTypeID != -1"
                          >
                            Relaxation Type
                          </td>
                          <td style="width: 5px"></td>
                          <td valign="middle">
                            <div
                              class="Flex_Cell"
                              v-if="basicInformation.relaxationTypeID != -1"
                            >
                              <!-- {{ basicInformation.relaxationTypeID }}
                              {{ basicInformation.relaxationTypeName }}-->
                              <select
                                id="ddlRelaxationType"
                                v-model="basicInformation.relaxationTypeID"
                              >
                                <!-- <option value="-1">---Select---</option> -->
                                <option
                                  v-for="c in candRelaxation"
                                  :key="c[0]"
                                  v-bind:value="c[0]"
                                >
                                  {{ c[1] }}
                                </option>
                              </select>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row myHeaderRow">
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 5%"
                        >
                          Sr. No.
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          Service Type
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        >
                          Date of Enrolment
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        >
                          Date of Retirement
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        >
                          Total Service Rendered(Year/ Month / Day)
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Dis. Book / Order / Noc No.
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 10%"
                          valign="middle"
                        >
                          Add New
                        </div>
                      </div>
                      <div
                        style="border-bottom: solid 1px darkgrey"
                        class="Flex_Row"
                        v-for="(qual, index) in exServiceMan"
                        :key="index"
                      >
                        <div
                          class="Flex_Cell"
                          align="center"
                          valign="middle"
                          style="width: 5%"
                        >
                          {{ index + 1 }}
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          <select
                            id="ddlExServiceType"
                            :ref="'exServiceServiceType_' + index"
                            v-model="qual[2]"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in exServiceType_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        >
                          <DateControl
                            :ref="'exServiceDOE_' + index"
                            v-model="qual[4]"
                            :showDate="true"
                            :fromDate="basicInformation.dob"
                            :toDate="new Date()"
                          ></DateControl>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        >
                          <DateControl
                            :ref="'exServiceDOR_' + index"
                            v-model="qual[5]"
                            :showDate="true"
                            :fromDate="basicInformation.dob"
                            :toDate="qual[10]"
                          ></DateControl>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        >
                          <span
                            v-if="qual[6] == 0 && qual[7] == 0 && qual[8] == 0"
                            >Auto Calculate After Save</span
                          >
                          <span v-else>
                            {{ qual[6] }} Years / {{ qual[7] }} Month/
                            {{ qual[8] }} Day
                          </span>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <AcceptInput
                            :ref="'exServiceDBookNo_' + index"
                            placeholder="Enter Discharge Book Number / Discharge Order No / NOC No."
                            v-model="qual[9]"
                            title="Enter Discharge Book Number / Discharge Order No / NOC No."
                            maxlength="150"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 10%"
                          valign="middle"
                          align="center"
                        >
                          <span
                            v-if="
                              index + 1 == exServiceMan.length &&
                              exServiceMan.length > 1
                            "
                            class="glyphicons bin"
                            v-on:click="DeleteExServiceman(index)"
                            style="cursor: pointer"
                            title="Delete this row"
                          ></span>
                          <span
                            v-if="index + 1 == exServiceMan.length"
                            class="glyphicons circle_plus"
                            v-on:click="AddNewExServiceman()"
                            style="cursor: pointer"
                            title="Add New row"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="EntryBlock" v-if="sportsMan.length > 0">
                    <legend>
                      <div class="Flex_Table" style="width: 100%">
                        <div class="Flex_Row">
                          <div class="Flex_Cell" style="width: 20%">
                            Sports Man Details
                          </div>
                          <div class="Flex_Cell"></div>
                        </div>
                      </div>
                    </legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row myHeaderRow">
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 5%"
                        >
                          Sr.No.
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Level
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Medal
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Sports Discipline
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Competition Name
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 8%"
                        >
                          Country
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 7%"
                        >
                          <span v-if="basicInformation.nationalityID == 1"
                            >State</span
                          >
                          <span v-else>Country</span>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Year
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Clearance No.
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          Clearance Date
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 5%"
                          valign="middle"
                        >
                          Add New
                        </div>
                      </div>
                      <div
                        style="border-bottom: solid 1px darkgrey"
                        class="Flex_Row"
                        v-for="(sport, index) in sportsMan"
                        :key="index"
                      >
                        <div
                          class="Flex_Cell"
                          align="center"
                          valign="middle"
                          style="width: 5%"
                        >
                          {{ index + 1 }}
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <select
                            id="ddlSportLevel"
                            :ref="'sportsManLevel_' + index"
                            v-model="sport[2]"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in sportLevel_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <select
                            id="ddlSportmedal"
                            :ref="'sportsManMedal_' + index"
                            v-model="sport[4]"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in sportMedal_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <select
                            id="ddlSportDiscipline"
                            :ref="'sportsManDiscipline_' + index"
                            v-model="sport[3]"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in sport_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <AcceptInput
                            :ref="'sportsManCompetitionName_' + index"
                            placeholder="Enter  Competition Name"
                            v-model="sport[5]"
                            title="Enter Competition Name"
                            maxlength="500"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 8%"
                        >
                          <AcceptInput
                            :ref="'sportsManCountryName_' + index"
                            placeholder="Enter Country Name"
                            v-model="sport[7]"
                            title="Enter Country Name"
                            maxlength="128"
                            regExp="([a-zA-Z\s])*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 7%"
                        >
                          <AcceptInput
                            :ref="'sportsManStateName_' + index"
                            placeholder="Enter State Name"
                            v-model="sport[6]"
                            title="Enter State Name"
                            maxlength="128"
                            regExp="([a-zA-Z\s])*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <select
                            id="ddlYear"
                            :ref="'sportsManYear_' + index"
                            v-model="sport[8]"
                          >
                            <option value>--</option>
                            <option
                              v-for="c in year_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[0] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <AcceptInput
                            v-if="sport[2] == 5"
                            placeholder="Enter Clearance No."
                            v-model="sport[9]"
                            title="Enter Clearance No."
                            maxlength="128"
                            :ref="'sportsManClearanceNo_' + index"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          <DateControl
                            v-if="sport[2] == 5"
                            v-model="sport[10]"
                            :showDate="true"
                            :fromDate="basicInformation.dob"
                            :toDate="new Date()"
                            :ref="'sportsManClearanceDate_' + index"
                          ></DateControl>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 5%"
                          valign="middle"
                          align="center"
                        >
                          <span
                            v-if="
                              index + 1 == sportsMan.length &&
                              sportsMan.length > 1
                            "
                            class="glyphicons bin"
                            v-on:click="DeleteSportMan(index)"
                            style="cursor: pointer"
                            title="Add New"
                          ></span>
                          <span
                            v-if="index + 1 == sportsMan.length"
                            class="glyphicons circle_plus"
                            v-on:click="AddNewSportMan()"
                            style="cursor: pointer"
                            title="Add New"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <fieldset
                    class="EntryBlock"
                    v-if="documentCertificate.length > 0"
                  >
                    <legend>
                      <div class="Flex_Table" style="width: 100%">
                        <div class="Flex_Row">
                          <div class="Flex_Cell" style="width: 20%">
                            Document Details
                          </div>
                          <div class="Flex_Cell"></div>
                        </div>
                      </div>
                    </legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row myHeaderRow">
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 5%"
                        >
                          Sr.No.
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Document / Certificate Name
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Document / Certificate No.
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          Issue Date
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Authority Name
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <span v-if="basicInformation.nationalityID == 1"
                            >State</span
                          >
                          <span v-else>Country</span>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          District
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          align="center"
                          style="width: 10%"
                        >
                          Life Time Valid
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          Valid Up To
                        </div>
                      </div>
                      <div
                        style="border-bottom: solid 1px darkgrey"
                        class="Flex_Row"
                        v-for="(doc, index) in documentCertificate"
                        :key="index"
                      >
                        <div
                          class="Flex_Cell"
                          align="center"
                          valign="middle"
                          style="width: 5%"
                        >
                          {{ index + 1 }}
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <span>{{ doc.commonName }}</span>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <AcceptInput
                            :ref="'certificateNo_' + index"
                            placeholder="Enter Document / Certificate No."
                            v-model="doc.certificateNo"
                            title="Enter Document / Certificate No."
                            maxlength="256"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          <DateControl
                            :ref="'certificateIssueDate_' + index"
                            v-model="doc.issueDate"
                            :showDate="true"
                            :fromDate="basicInformation.dob"
                            :toDate="new Date()"
                          ></DateControl>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <AcceptInput
                            :ref="'certificateAuthName_' + index"
                            placeholder="Enter Authority Name"
                            v-model="doc.authorityName"
                            title="Enter Authority Name"
                            maxlength="256"
                            regExp="([a-zA-Z\s])*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <select
                            id="ddlState"
                            :ref="'certificateStateID_' + index"
                            v-model="doc.stateID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in state_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <select
                            id="ddlDistrict"
                            :ref="'certificateDistrictID_' + index"
                            v-model="doc.districtID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in district_List.filter((s) => {
                                return s[2] == doc.stateID;
                              })"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          align="center"
                          style="width: 10%"
                        >
                          <!-- <input
                            type="checkbox"
                            v-model="doc.isLifeTimeValid"
                          />-->
                          <select
                            id="ddlLifTimeValidity"
                            v-model="doc.isLifeTimeValid"
                          >
                            <option value="True">Yes</option>
                            <option value="False">No</option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          <DateControl
                            :ref="'certificateValidUpTo_' + index"
                            v-if="doc.isLifeTimeValid == 'False'"
                            v-model="doc.validUpTo"
                            :showDate="true"
                            :fromDate="new Date()"
                          ></DateControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset
                    class="EntryBlock"
                    v-if="basicInformation.isExServiceMan == '0'"
                  >
                    <legend>Recruitment Type & Departmental/Government</legend>
                    <div class="Flex_Table tblEntryForm">
                      <div
                        class="Flex_Row"
                        style="border-bottom-style: solid; border-width: 1px"
                      >
                        <div class="Flex_Cell" style="width: 35%">
                          <table style="width: 100%">
                            <tr>
                              <td style="width: 25%" valign="middle">
                                <span
                                  class="mandatorySpan"
                                  style="white-space: nowrap"
                                  :class="{ Required: false }"
                                  >Recruitment Type :</span
                                >
                              </td>
                              <td valign="middle">
                                {{ basicInformation.recruitmentTypeName }}
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 65%"
                          v-if="basicInformation.isExServiceMan == '0'"
                        >
                          <table
                            style="width: 100%"
                            v-if="basicInformation.relaxationTypeName != ''"
                          >
                            <tr>
                              <td style="width: 25%" valign="middle">
                                <span
                                  class="mandatorySpan"
                                  style="white-space: nowrap"
                                  :class="{ Required: false }"
                                  >Departmental/Government :</span
                                >
                              </td>

                              <td valign="middle">
                                {{ basicInformation.relaxationTypeName }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div
                      class="Flex_Table tblEntryForm"
                      v-if="
                        basicInformation.recruitmentTypeID == 3 ||
                        basicInformation.recruitmentTypeID == 5
                      "
                    >
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Date of Appointment</span
                          >
                          <DateControl
                            ref="dateOfAppointment"
                            v-model="basicInformation.dateOfAppointment"
                            :showDate="true"
                            :fromDate="basicInformation.dob"
                            :toDate="new Date()"
                            title="Enter Date Of Appointment"
                          ></DateControl>
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <label
                            for="ddlWorkedTillPresent"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Worked Till Present</label
                          >
                          <select
                            id="ddlWorkedTillPresent"
                            v-on:change="SetWorkedTillPresent()"
                            v-model="basicInformation.workedTillPresent"
                          >
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Retirement Date</span
                          >

                          <DateControl
                            v-model="basicInformation.retirementDate"
                            :showDate="true"
                            :fromDate="basicInformation.dateOfAppointment"
                            :toDate="basicInformation.retirementEndDate"
                            title="Enter Date Of Retirment"
                            :disabled="basicInformation.workedTillPresent == 1"
                          ></DateControl>
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Name Of Organization</span
                          >
                          <AcceptInput
                            ref="empOrgName"
                            placeholder="Organization name"
                            v-model="basicInformation.empOrgName"
                            maxlength="100"
                            title="Enter Organization"
                            regExp="([a-zA-Z\s])*"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Name Of Post</span
                          >
                          <AcceptInput
                            ref="empPostName"
                            placeholder="Post name"
                            v-model="basicInformation.empPostName"
                            maxlength="100"
                            title="Enter Post Name "
                            regExp="([a-zA-Z\s])*"
                          />
                        </div>
                      </div>
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 20%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Office Address</span
                          >
                          <AcceptInput
                            ref="employerOffice"
                            placeholder="Enter Office Name"
                            v-model="basicInformation.employerOffice"
                            maxlength="256"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                            title="Enter Office Address"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 20%">
                          <label
                            for="ddlNOCObtained"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >NOC Obtained</label
                          >
                          <select
                            id="ddlNOCObtained"
                            v-model="basicInformation.isNOCObtained"
                          >
                            <option value="0">No</option>
                            <option value="1">Yes</option>
                          </select>
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 20%"
                          v-if="basicInformation.isNOCObtained == 1"
                        >
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Letter No.</span
                          >
                          <AcceptInput
                            ref="empLetterNo"
                            placeholder="Enter Letter No."
                            v-model="basicInformation.empLetterNo"
                            maxlength="250"
                            title="Enter Letter No."
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 20%"
                          v-if="basicInformation.isNOCObtained == 1"
                        >
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Letter Date</span
                          >
                          <DateControl
                            ref="empletterDate"
                            v-model="basicInformation.empletterDate"
                            :showDate="true"
                            :fromDate="basicInformation.dob"
                            :toDate="new Date()"
                            title="Enter Date Of Appointment"
                          ></DateControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <fieldset class="EntryBlock">
                    <legend>
                      <div class="Flex_Table" style="width: 100%">
                        <div class="Flex_Row">
                          <div class="Flex_Cell" style="width: 20%">
                            Employment Exchange
                          </div>
                          <div class="Flex_Cell">
                            <label>
                              <input
                                type="radio"
                                value="1"
                                id="rbnEEY"
                                name="isEERegistered"
                                v-model="OtherDetails.isEERegistered"
                              />
                              <label for="rbnEEY">Yes</label>
                              <input
                                type="radio"
                                value="0"
                                id="rbnEEN"
                                name="isEERegistered"
                                v-model="OtherDetails.isEERegistered"
                              />
                              <label for="rbnEEN">No</label>
                            </label>
                          </div>
                        </div>
                      </div>
                    </legend>
                    <div class="Flex_Table tblEntryForm">
                      <div
                        class="Flex_Row"
                        v-if="OtherDetails.isEERegistered == 1"
                      >
                        <div
                          class="Flex_Cell"
                          style="width: 25%"
                          v-if="OtherDetails.isEERegistered == 1"
                        >
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Registration Number</span
                          >
                          <AcceptInput
                            placeholder="Enter Registration Number"
                            ref="EERegistrationNo"
                            v-model="OtherDetails.eRegistrationNo"
                            maxlength="256"
                            title="Registration Number"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Registration Date</span
                          >
                          <DateControl
                            ref="eRegistrationDate"
                            :isRequired="true"
                            v-model="OtherDetails.eRegistrationDate"
                            :showDate="true"
                            :fromDate="basicInformation.dob"
                            :toDate="new Date()"
                          ></DateControl>
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Employment Exch Name</span
                          >
                          <AcceptInput
                            placeholder="Enter Employee ExchangeName Name"
                            ref="EExchangeName"
                            v-model="OtherDetails.eExchangeName"
                            maxlength="256"
                            title="Employee ExchangeName Name"
                            regExp="([a-zA-Z\s])*"
                          />
                        </div>
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="ddlExchState"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Employment Exch State</label
                          >
                          <select
                            id="ddlExchState"
                            v-model="OtherDetails.eStateID"
                            ref="eStateID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in state_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div
                        class="Flex_Row"
                        v-if="OtherDetails.isEERegistered == 1"
                      >
                        <div class="Flex_Cell" style="width: 25%">
                          <label
                            for="ddlDistrict"
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Employment Exch District</label
                          >
                          <select
                            id="ddlDistrict"
                            v-model="OtherDetails.eDistrictID"
                            ref="eDistrictID"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in district_List.filter((s) => {
                                return s[2] == OtherDetails.eStateID;
                              })"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                        </div>
                        <div class="Flex_Cell" style="width: 50%">
                          <span
                            class="mandatorySpan"
                            :class="{ Required: false }"
                            >Employment Exch Address</span
                          >
                          <textarea
                            ref="eAddress"
                            v-model="OtherDetails.eAddress"
                            placeholder="Enter Employment Exch Address"
                            title="Enter Employment Exch Address"
                            maxlength="500"
                            v-on:keypress="validateAddress($event)"
                            @click.right.prevent
                            @copy.prevent
                            @paste.prevent
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div ref="tab3" v-show="selectTab3" style="border: none">
                  <fieldset class="EntryBlock">
                    <legend>
                      <span class="mandatorySpan" :class="{ Required: true }"
                        >(File Type :jpg)</span
                      >
                    </legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row myHeaderRow">
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 5%"
                        >
                          Sr.No.
                        </div>
                        <div class="Flex_Cell" valign="middle">
                          Documents Type
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 15%"
                        >
                          Document Number
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          Doc Size
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        ></div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 20%"
                        >
                          Uploaded Docs Name
                        </div>
                      </div>
                      <div
                        class="Flex_Row"
                        style="border-bottom: solid 1px darkgray"
                        v-for="(doc, index) in candDocuments"
                        :key="index"
                      >
                        <div
                          class="Flex_Cell"
                          :style="[
                            doc[10] == '1'
                              ? { 'background-color': 'greenyellow' }
                              : '',
                          ]"
                          style="width: 5%"
                          align="center"
                          valign="middle"
                        >
                          <span>{{ index + 1 }}</span>
                        </div>
                        <div class="Flex_Cell" valign="middle">
                          <label for="ddlIdDard" v-if="doc[5] == '2'"
                            >{{ doc[3] }} ::</label
                          >
                          <select
                            v-if="doc[5] == '2'"
                            id="ddlIdDard"
                            :disabled="isSubmit == '1' ? true : false"
                            v-model="doc[2]"
                            style="width: 80%"
                            v-on:change="resetCardDetails(doc, index)"
                          >
                            <option value="-1">---Select---</option>
                            <option
                              v-for="c in idCard_List"
                              :key="c[0]"
                              v-bind:value="c[0]"
                            >
                              {{ c[1] }}
                            </option>
                          </select>
                          <span v-else>{{ doc[3] }}</span>
                        </div>
                        <div class="Flex_Cell" style="width: 15%">
                          <!-- {{ doc[11] }} -->
                          {{
                            doc[11] != ""
                              ? decrypt(doc[11])
                                  .substring(
                                    decrypt(doc[11]).length > 4
                                      ? decrypt(doc[11]).length - 4
                                      : decrypt(doc[11]).length - 2
                                  )
                                  .padStart(decrypt(doc[11]).length, "*")
                              : doc[11]
                          }}
                          <br v-if="doc[11] != ''" />
                          <AcceptInput
                            :ref="'docCertificateNo_' + index"
                            v-if="doc[12] == '1'"
                            placeholder="Enter Document / Certificate No."
                            title="Enter Document / Certificate No."
                            v-model="doc[16]"
                            regExp="^[A-Za-z0-9 -]*[A-Za-z0-9][A-Za-z0-9 -]*"
                            :maxlength="
                              doc[2] == 1 ? '12' : doc[2] == 2 ? '10' : '25'
                            "
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          valign="middle"
                          style="width: 10%"
                        >
                          <label :for="'uploadFilesDocs_' + index"
                            >{{ doc[14] + "-" + doc[15] }} kb</label
                          >
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 20%"
                          align="center"
                          valign="middle"
                        >
                          <input
                            type="button"
                            value="Live Update"
                            @click="ShowLiveUpdate()"
                            v-if="
                              isSubmit == '0' &&
                              isExpired == 0 &&
                              isReject == '0' &&
                              doc[13] == '1' &&
                              doc[5] == '1'
                            "
                          />
                          <input
                            :ref="'uploadFilesDocs_' + index"
                            style
                            type="file"
                            :id="'uploadFilesDocs_' + index"
                            v-on:change="documentsPosting($event, doc, index)"
                            v-if="
                              isSubmit == '0' &&
                              isExpired == 0 &&
                              isReject == '0' &&
                              doc[13] == '1'
                            "
                          />
                        </div>
                        <div
                          class="Flex_Cell"
                          style="width: 20%"
                          align="center"
                          valign="middle"
                        >
                          <span
                            v-if="doc[7] != ''"
                            title="click to view document"
                            v-on:click="openDocImage(doc)"
                            class="docFileName"
                            >{{ doc[7] }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <!-- Here Web Camera Code Writen By Ravi Ranjan Singh  -->
                  <fieldset v-show="liveUpdate == 1">
                    <legend>Capture Live Candidate Photo</legend>
                    <div class="Flex_Table tblEntryForm">
                      <div class="Flex_Row">
                        <div class="Flex_Cell" style="width: 70%"></div>
                        <div class="Flex_Cell" style="width: 30%">
                          <div class="camera">
                            <video id="video">
                              Video stream not available.
                            </video>
                            <div
                              id="dvCandPhotoCapture"
                              class="output"
                              style="display: none"
                            >
                              <img
                                id="photo"
                                class="cand_photo"
                                alt="CandidateImage"
                              />
                            </div>
                          </div>
                          <br />
                          <div style="text-align: center">
                            <button id="startbutton">Capture Photo</button>
                          </div>
                          <canvas id="canvas"></canvas>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                  <!------------------------------------------------------->
                </div>
                <div ref="tab4" v-show="selectTab4" style="border: none">
                  <div class="Flex_Table tblEntryForm">
                    <div class="Flex_Row">
                      <div class="Flex_Cell" style="width: 50%; padding: 0px">
                        <fieldset class="EntryBlock">
                          <legend>
                            <span
                              class="mandatorySpan"
                              :class="{ Required: true }"
                              >Exam City Choice (select All)</span
                            >
                          </legend>
                          <div class="Flex_Table tblEntryForm">
                            <div class="Flex_Row myHeaderRow">
                              <div
                                class="Flex_Cell"
                                valign="middle"
                                style="width: 10%"
                              >
                                Sr.No.
                              </div>
                              <div class="Flex_Cell" valign="middle">
                                Exam City
                              </div>
                            </div>
                            <div
                              class="Flex_Row"
                              v-for="(e, index) in candExamCenter"
                              :key="e[0]"
                            >
                              <div class="Flex_Cell" style="width: 10%">
                                {{ e[0] }}
                              </div>
                              <div class="Flex_Cell">
                                <select
                                  :ref="'ddlExamCenter_' + index"
                                  id="ddlExamCenter"
                                  v-model="e[1]"
                                  :disabled="isExamCenterLock"
                                  v-on:change="onSelectExamCenter(e, index)"
                                >
                                  <option value="-1">---Select---</option>
                                  <option
                                    v-for="c in examCentreChoice_List"
                                    :key="c[0]"
                                    v-bind:value="c[0]"
                                  >
                                    {{ c[1] }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                      <div class="Flex_Cell" style="width: 50%; padding: 0px">
                        <fieldset class="EntryBlock">
                          <legend>
                            <span
                              class="mandatorySpan"
                              :class="{ Required: true }"
                            >
                              Preferred Location for Employment (select All)
                            </span>
                          </legend>
                          <div class="Flex_Table tblEntryForm">
                            <div class="Flex_Row myHeaderRow">
                              <div
                                class="Flex_Cell"
                                valign="middle"
                                style="width: 10%"
                              >
                                Sr.No.
                              </div>
                              <div class="Flex_Cell" valign="middle">
                                Posting Region
                              </div>
                            </div>
                            <div
                              class="Flex_Row"
                              v-for="(e, index) in candPostingCity"
                              :key="e[0]"
                            >
                              <div class="Flex_Cell" style="width: 10%">
                                {{ e[0] }}
                              </div>
                              <div class="Flex_Cell">
                                <select
                                  :ref="'ddlPosting_' + index"
                                  id="ddlPosting"
                                  v-model="e[1]"
                                  v-on:change="onSelectPostingCity(e, index)"
                                >
                                  <option value="-1">---Select---</option>
                                  <option
                                    v-for="c in postingCityChoice_List"
                                    :key="c[0]"
                                    v-bind:value="c[0]"
                                  >
                                    {{ c[1] }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <input
                            type="button"
                            id="btnReSave"
                            name="btnReSave"
                            btnName="btnReSave"
                            value="Save Posting Region"
                            style="padding: 5px 15px 5px 15px"
                            title="Click to Save Again Posting Region"
                            v-if="isAllowToPostingCityChange == '1'"
                            v-on:click="SavePostingCity()"
                          />
                          <input
                            type="button"
                            id="btnReSave"
                            name="btnReSave"
                            btnName="btnReSave"
                            value="Submit Post City"
                            style="padding: 5px 15px 5px 15px"
                            title="Click to Submit Again Posting Region"
                            v-if="isAllowToPostingCityChange == '1'"
                            v-on:click="confirmPostAgainSubmit()"
                          />
                        </fieldset>
                      </div>
                    </div>
                    <div class="Flex_Row">
                      <div class="Flex_Cell" style="padding: 0px">
                        <fieldset class="EntryBlock">
                          <legend>Declaration</legend>
                          <div
                            :class="
                              chk1 == false ? 'instruction' : 'instructionAgree'
                            "
                          >
                            <input type="checkbox" id="chk1" v-model="chk1" />
                            <label for="chk1" style="cursor: pointer">
                              I hereby confirm that I have read the
                              “Instructions to fill online application” provided
                              in documents in https://aocrecruitment.gov.in
                            </label>
                          </div>
                          <div
                            :class="
                              chk2 == false ? 'instruction' : 'instructionAgree'
                            "
                          >
                            <input type="checkbox" id="chk2" v-model="chk2" />
                            <label for="chk2" style="cursor: pointer">
                              I accept all the terms and conditions given in the
                              “Instructions to fill online application” provided
                              in documents in https://aocrecruitment.gov.in
                            </label>
                          </div>
                          <div class="Flex_Table tblEntryForm">
                            <div class="Flex_Row">
                              <div class="Flex_Cell">
                                <label
                                  for="txtcandRegPlace"
                                  class="mandatorySpan"
                                  :class="{ Required: true }"
                                  >Place</label
                                >
                                <input
                                  ref="txtcandRegPlace"
                                  type="text"
                                  id="txtcandRegPlace"
                                  v-model="basicInformation.candRegPlace"
                                  maxlength="50"
                                  @keypress="isCharacter($event)"
                                  @click.right.prevent
                                  @copy.prevent
                                  @paste.prevent
                                />
                              </div>
                              <div class="Flex_Cell" style="font-weight: bold">
                                <span
                                  class="mandatorySpan"
                                  :class="{ Required: false }"
                                  >Date:</span
                                >
                                <span
                                  class="mandatorySpan"
                                  :class="{ Required: false }"
                                  >{{ basicInformation.candRegDate }}</span
                                >
                              </div>
                              <div
                                class="Flex_Cell"
                                style="width: 25%"
                                v-if="isSubmit == 0 && isExpired == 0"
                              >
                                <div class="Flex_Table">
                                  <div class="Flex_Row">
                                    <div class="Flex_Cell">
                                      <label
                                        for="txtcaptchaValue"
                                        class="mandatorySpan"
                                        :class="{ Required: true }"
                                        >Enter captcha</label
                                      >
                                      <input
                                        ref="txtcaptchaValue"
                                        type="text"
                                        id="txtcaptchaValue"
                                        v-model="captchaValue"
                                        maxlength="6"
                                      />
                                    </div>
                                    <div class="Flex_Cell" valign="bottom">
                                      <img
                                        id="imgCaptcha"
                                        alt="Captcha Image"
                                        style="
                                          border: solid 1px black;
                                          border-radius: 0px;
                                        "
                                      />
                                    </div>
                                    <div class="Flex_Cell" valign="bottom">
                                      <img
                                        src="../assets/images/refresh.png"
                                        alt="RefreshCaptcha"
                                        v-on:click="generateCaptcha(1)"
                                        style="
                                          cursor: pointer;
                                          height: 25px;
                                          border: 1px solid #000;
                                          border-radius: 50%;
                                        "
                                        title="Click here to refresh captcha"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <input
                                  type="button"
                                  id="btnSubmitApp"
                                  name="btnSubmitApp"
                                  btnName="btnSubmitApp"
                                  value="Preview and Submit"
                                  style="
                                    padding: 10px 15px 5px 15px;
                                    width: 96%;
                                  "
                                  title="Click to Save Application"
                                  v-on:click="confirmSubmit()"
                                  :disabled="chk1 == false || chk2 == false"
                                  v-if="isSubmit == 0 && isExpired == 0"
                                  :class="
                                    chk1 == true && chk2 == true
                                      ? 'Button3D'
                                      : 'disableButton Button3D'
                                  "
                                />
                              </div>
                              <div class="Flex_Cell" style="width: 20%"></div>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </transition>
    <ModalPopup
      title="AdmitCard Print"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="admitCardDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      v-if="candidateID != -1"
    >
      <div style="text-align: center; background-color: whitesmoke">
        <input
          type="button"
          value="Print"
          v-on:click="printAdmitCardReport()"
        />
      </div>
      <div style="height: calc(100vh - 90px); overflow: auto">
        <AdmitCard
          :candidateID="candidateID"
          :eventBus="admitCardbus"
        ></AdmitCard>
      </div>
    </ModalPopup>
    <ModalPopup
      title="Offer Letter Print"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="appointmentLetterDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      v-if="candidateID != -1"
    >
      <div style="text-align: center; background-color: whitesmoke">
        <input
          type="button"
          value="Print"
          v-on:click="printAppointmentLetterReport()"
        />
      </div>
      <div style="height: calc(100vh - 90px); overflow: auto">
        <AppointmentLetterPrint
          :candidateID="candidateID"
          :eventBus="appointmentLetterbus"
        ></AppointmentLetterPrint>
      </div>
    </ModalPopup>

    <ModalPopup
      title="CallLetter Print"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="callLetterPrintDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      v-if="candidateID != -1"
    >
      <div style="text-align: center; background-color: whitesmoke">
        <input
          type="button"
          value="Print"
          v-on:click="printCallLetterReport()"
        />
      </div>
      <div style="height: calc(100vh - 90px); overflow: auto">
        <CallLetterPrint
          :candidateID="candidateID"
          :eventBus="callLetterprintbus"
        ></CallLetterPrint>
      </div>
    </ModalPopup>
    <ModalPopup
      title="Application Print"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="applicationPrintDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
      v-if="candidateID != -1"
    >
      <div style="height: calc(100vh - 90px); overflow: auto">
        <ApplicationPrint
          :candidateID="candidateID"
          :eventBus="printbus"
          v-if="isShowAppPreview"
        ></ApplicationPrint>
      </div>
      <div style="text-align: center; background-color: whitesmoke">
        <input type="button" value="Print" v-on:click="printPDFReport()" />
        <input
          type="button"
          value="Submit"
          style="width: 150px"
          v-if="isSubmit == 0 && this.isSubmitAllow == 1"
          v-on:click="finalSubmit()"
        />
      </div>
    </ModalPopup>

    <ModalPopup
      title="Eligibility for recruitment as MSP"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="mspEligibilityDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
    >
      <table border="1" style="height: calc(100vh - 450px); overflow: auto">
        <tr style="font-weight: bold">
          <td style="padding: 5px">Competition</td>
          <td style="padding: 5px">Authority Awarding Certificate</td>
          <td style="text-align: center; padding: 5px">
            Form in Which Certificate is to be Awarded
          </td>
        </tr>

        <tr>
          <td style="padding: 5px">International Competition</td>
          <td style="padding: 5px">
            Secretary of theNational Federationof the Game concerned.
          </td>
          <td style="text-align: center; padding: 5px">1</td>
        </tr>

        <tr>
          <td style="padding: 5px">National Competition</td>
          <td style="padding: 5px">
            Secretary of theNationalFederation orSecretary of the
            StateAssociation of the Gameconcerned.
          </td>
          <td style="text-align: center; padding: 5px">2</td>
        </tr>

        <tr>
          <td style="padding: 5px">Inter-University Tournaments</td>
          <td style="padding: 5px">
            Dean of Sports or otherofficer in overall charge ofsports of the
            University concerned.
          </td>
          <td style="text-align: center; padding: 5px">3</td>
        </tr>
        <tr>
          <td style="padding: 5px">National/Sports/Games for Schools</td>
          <td style="padding: 5px">
            Director or Additional/Jointor DeputyDirector in overallcharge of
            sports/games forSchools in the Directorate of
            PublicInstructions/Education ofthe State.
          </td>
          <td style="text-align: center; padding: 5px">4</td>
        </tr>
        <tr>
          <td style="padding: 5px">Physical Efficiency Drive</td>
          <td style="padding: 5px">
            Secretary or other Officer inoverall charge ofPhysicalEfficiency in
            the Ministry ofEducation & Social WelfareGovernment of India
          </td>
          <td style="text-align: center; padding: 5px">5</td>
        </tr>
      </table>
    </ModalPopup>

    <ModalPopup
      title="Category of Disability"
      ref="ModalPopup1"
      @closed="modalPopupClosed"
      @opened="modalPopupShown"
      v-model="disabilityCategoryDiv"
      :okButton="$refs.btnOk"
      :cancelButton="$refs.btnOk"
    >
      <table border="1" style="height: calc(100vh - 500px); overflow: auto">
        <tr>
          <td style="width: 100px; text-align: center; padding: 5px">A</td>
          <td style="padding: 5px">Blindness and low vision.</td>
        </tr>

        <tr>
          <td style="text-align: center; padding: 5px">B</td>
          <td style="padding: 5px">Deaf and hard of hearing.</td>
        </tr>
        <tr>
          <td style="text-align: center; padding: 5px">C</td>
          <td style="padding: 5px">
            Locomotors disability including cerebral palsy, leprosy
            cured,dwarfism, acid attack victims and muscular dystrophy.
          </td>
        </tr>
        <tr>
          <td style="text-align: center; padding: 5px">D</td>
          <td style="padding: 5px">
            Autism, intellectual disability, specific learning disability and
            mental illness
          </td>
        </tr>
      </table>
    </ModalPopup>
  </div>
</template>
<script>
import vue from "vue";
import Router from "vue-router";
import axios from "axios";
import config from "@/router/globalConfig";
import AcceptInput from "./ekkControls/AcceptInput";
import DateControl from "./ekkControls/DateControl";
import ModalPopup from "./ekkControls/ModalPopup";
import ApplicationPrint from "@/components/ApplicationPrint";
import CallLetterPrint from "@/components/CallLetterPrint";
import AdmitCard from "@/components/AdmitCard";
import AppointmentLetterPrint from "@/components/AppointmentLetterPrint";
import masterAPI from "./servicesjs/MasterObject";
import Report from "@/router/Report";
import Tab from "./ekkControls/Tab.vue";
import encryptionJS from "../router/encryption.js";
export default {
  name: "Registration",
  components: {
    DateControl: DateControl,
    AcceptInput: AcceptInput,
    ModalPopup: ModalPopup,
    ApplicationPrint: ApplicationPrint,
    AdmitCard: AdmitCard,
    CallLetterPrint: CallLetterPrint,
    AppointmentLetterPrint: AppointmentLetterPrint,
  },
  data() {
    return {
      isAllowDiscard: 0,
      isAllowToPostingCityChange: 0,
      isSubmit: 0,
      isReject: 0,
      isNew: false,
      advtID: -1,
      advt_List: [],
      gender: "M",
      postTypeID: -1,
      postType_List: [],
      appCastType_List: [],
      appCastTypeCand_List: [],
      appCastTypeID: -1,
      mainCat_List: [],
      mainCatID: -1,
      youEWS: 0,
      selectedAdvt: "",
      selectedPostType: "",
      selectedAppCastType: "",
      selectedrecruitmentRelaxation: "",
      selectedMainCat: "",
      selectedEWS: "",
      selectedNationality: "",
      selectedGender: "",

      criteria_List: [],
      criteriaQualSetID: -1,
      criteriaDetail_List: [],
      candApplication_List: [],

      candidateID: -1,
      callType: 0,
      isSubmitAllow: 0,
      isSubmit: false,
      isShowLoad: true,
      selectTab1: true,
      selectTab2: false,
      selectTab3: false,
      selectTab4: false,
      selectTab5: false,
      applicationNo: "",
      profileFile: "",
      signatureFile: "",
      title_List: [],
      maritalStatus_List: [],
      religion_List: [],
      state_List: [],

      physicalHandicap_List: [],
      exServiceType_List: [],
      sportLevel_List: [],
      sportMedal_List: [],
      sport_List: [],
      examCentreChoice_List: [],
      postingCityChoice_List: [],
      idCard_List: [],

      qualMaster_List: [],
      qualCertificateMaster_List: [],
      qualMasterID: -1,
      university_List: [],
      universityID: -1,
      appMedia_List: [],

      captchaData: "",
      captchaValue: "",
      captchakey: "",

      candidate_MainData: [],
      candQualOne: [],
      candQualTwo: [],
      candOtherQualOne: [],
      candOtherQualTwo: [],
      candRelaxation: [],
      candExamCenter: [],
      candPostingCity: [],
      candDocuments: [],
      candRejectReason: [],
      exServiceMan: [],
      sportsMan: [],
      documentCertificate: [],
      liveUpdate: 0,
      basicInformation: {
        titleID: -1,
        firstName: "",
        middleName: "",
        lastName: "",
        fatherName: "",
        motherName: "",
        dob: new Date("01 Jan 1900"),
        religionID: -1,
        phoneNumber: "",
        mobileNumber: "",
        mobileNumberDisplay: "",
        emailID: "",
        emailIDDisplay: "",
        domicileStateID: -1,
        domicileFrom: new Date("01 Jan 1900"),
        domicileTo: new Date("01 Jan 1900"),
        aadhaarNumberDisplay: "",
        aadhaarNumber: "",
        maritalStatusID: -1,
        candadvtID: -1,
        candgender: "M",
        candpostTypeID: -1,
        candMainCatID: -1,
        candAppCastTypeID: -1,
        castTypeID: -1,
        castName: "",
        isPhyHandicap: 0,
        physicalHTypeID: "-",
        phyHandiPercentage: "",
        isSportsMan: 0,
        sportLevelID: -1,
        sportMedalID: -1,
        sportID: -1,
        sportLevelName: "",
        isExServiceMan: 0,
        exServiceTypeID: -1,
        exServiceNo: "",
        exServiceDate: new Date("01 Jan 1900"),
        exServiceYear: 0,
        exServiceMonth: 0,
        exServiceDay: 0,
        relaxationTypeID: -1,
        appMediaNo: "",
        dateOfAppointment: new Date("01 Jan 1900"),
        dateofRetirement: new Date("01 Jan 1900"),
        empOrgName: "",
        empPostName: "",
        employerOffice: "",
        empLetterNo: "",
        empletterDate: new Date().convertToString("dd MMM yyyy"),
        isNOCObtained: 0,
        candRegPlace: "",
        candRegDate: new Date().convertToString("dd MMM yyyy"),
        nationalityID: 11,
        nationalityTypeID: 1,
        castCetificateNo: "",
        castCetificateDate: new Date().convertToString("dd MMM yyyy"),
        categoryCetificateNo: "",
        categoryCetificateDate: new Date().convertToString("dd MMM yyyy"),
        IsReqForScribe: 0,
        IdMark: "",
        recruitmentTypeID: -1,
        recruitmentTypeName: "",
        relaxationTypeID: -1,
        relaxationTypeName: "",
        workedTillPresent: 0,
        retirementDate: new Date().convertToString("dd MMM yyyy"),
      },
      addressInformation: {
        address: "",
        city: "",
        district: "",
        districtID: -1,
        stateID: -1,
        pinCode: "",
      },
      correspondanceAddress: {
        address: "",
        city: "",
        district: "",
        districtID: -1,
        stateID: -1,
        pinCode: "",
      },
      upFiles: [],
      docRowEdit: [],
      discardRow: [],
      whichTabSelected: 1,
      isExamCenterLock: false,

      OtherDetails: {
        isEERegistered: 0,
        eRegistrationNo: "",
        eExchangeName: "",
        eRegistrationDate: new Date("01 Jan 1900").convertToString(
          "dd MMM yyyy"
        ),
        eAddress: "",
        eStateID: -1,
        eDistrictID: -1,
      },
      IsSameAsCorrespondance: false,
      Nationality_List: [],
      district_List: [],
      applicationPrintDiv: false,
      printbus: new vue(),
      callLetterPrintDiv: false,
      callLetterprintbus: new vue(),
      admitCardDiv: false,
      admitCardbus: new vue(),
      appointmentLetterDiv: false,
      appointmentLetterbus: new vue(),
      year_List: [],
      expYear_List: [],
      expMonth_List: [],

      //Camera variables
      width: 320,
      height: 0,
      streaming: false,
      video: null,
      canvas: null,
      photo: null,
      startbutton: null,
      showvideo: true,
      isShowAppPreview: false,
      isExpired: 0,
      recruitmentTypeID: -1,
      relaxationTypeID: -1,
      recruitmentType_List: [],
      recruitmentRelaxation_List: [],
      chk1: false,
      chk2: false,
      mspEligibilityDiv: false,
      disabilityCategoryDiv: false,
      isscribeHide: false,
    };
  },
  methods: {
    decrypt(text) {
      return encryptionJS.decryptAES(text);
    },
    tabClick(type) {
      this.selectTab1 = false;
      this.selectTab2 = false;
      this.selectTab3 = false;
      this.selectTab4 = false;
      this.selectTab5 = false;
      this.whichTabSelected = type;
      if (type == 1) {
        this.selectTab1 = true;
      }
      if (type == 2) {
        this.selectTab2 = true;
      }
      if (type == 3) {
        this.selectTab3 = true;
      }
      if (type == 4) {
        this.selectTab4 = true;
        this.generateCaptcha(1);
      }
      if (type == 5) {
        this.selectTab5 = true;
      }
    },
    getUserGender() {
      axios
        .get(config.WEB_API_PATH + "Master/GetUserGender", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          crossdomain: true,
        })
        .then(
          (response) => {
            if (response.data.length > 0 && response.data != "") {
              this.gender = response.data;
            }
          },
          (error) => {}
        );
    },
    generateCaptcha(type) {
      this.captchaValue = "";
      const _data_ = { width: 120, height: 40 };
      axios
        .get(config.WEB_API_PATH + "Login/GenerateCaptcha", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          crossdomain: true,
          params: _data_,
        })
        .then(
          (response) => {
            if (type == 1) {
              $("#imgCaptcha").attr("src", response.data.result1);
              this.captchakey = response.data.result;
              this.captchaData = encryptionJS.decryptAES(response.data.result3);
            }
          },
          (error) => {
            if (error.response.data.message != undefined) {
              alert(
                error.response.data.message +
                  "\n" +
                  error.response.data.exceptionMessage
              );
            } else {
              alert("Error: " + error.response.data);
            }
          },
          (failure) => {
            alert("Failure: " + failure.response);
          }
        );
    },
    getAdvertisment() {
      this.getUserGender();
      this.advt_List = [];
      const _data_ = { type: 1 };
      axios
        .get(config.WEB_API_PATH + "Master/GetAdvertisment", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.advt_List = response.data;
            if (response.data.length > 0) {
              this.advtID = response.data[0][0];
              this.getPostType();
              // this.getCandidateApp();
            }
            this.getCandidateApp();
          },
          (error) => {}
        );
    },
    getPostType() {
      this.postType_List = [];
      const _data_ = {
        advtID: this.advtID,
        postTypeID: -1,
        type: 1,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetPostType", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.postType_List = response.data;
            if (response.data.length > 0) {
              this.postTypeID = response.data[0][0];
              this.getCasteTypePostWise();
              //  this.getSelectelabel();
            }
          },
          (error) => {}
        );
    },
    getCasteTypePostWise() {
      this.appCastType_List = [];
      this.mainCat_List = [];
      const _data_ = {
        advtID: this.advtID,
        postTypeID: this.postTypeID,
        casteTypeID: -1,
        type: 1,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetCasteTypePostWise", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.appCastType_List = response.data.result;
            this.mainCat_List = response.data.result1;

            if (response.data.result.length > 0) {
              this.appCastTypeID = response.data.result[0][0];
              this.mainCatID = -1;
              this.getQualStandard();
              // this.getSelectelabel();
            }
            // if(response.data.result1.length>0){
            //     this.mainCatID = response.data.result1[0][0];
            // }
          },
          (error) => {}
        );
    },
    getCasteTypePostWiseByCandID(callback) {
      this.appCastTypeCand_List = [];
      const _data_ = {
        advtID: this.basicInformation.candadvtID,
        postTypeID: this.basicInformation.candpostTypeID,
        casteTypeID: -1,
        type: 1,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetCasteTypePostWise", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.appCastTypeCand_List = response.data.result;
            if (typeof callback === "function") {
              callback();
            }
          },
          (error) => {}
        );
    },
    getQualStandard() {
      this.criteria_List = [];
      this.criteriaDetail_List = [];
      const _data_ = {
        advtID: this.advtID,
        postTypeID: this.postTypeID,
        appCasteTypeID: this.appCastTypeID,
        appCatID: this.mainCatID,
        gender: this.gender,
        type: 1,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetQualStandard", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.criteria_List = response.data.result;
            this.criteriaDetail_List = response.data.result1;
            this.GetRecruitmentTypeRelaxation();
            if (response.data.result.length > 0) {
              this.criteriaQualSetID = response.data.result[0][0];
            }
          },
          (error) => {}
        );
    },
    getYear() {
      this.year_List = [];
      const _data_ = {
        dob: new Date(this.basicInformation.dob).convertToString("dd MMM yyyy"),
      };
      let resp = masterAPI.getYear(
        new Date(this.basicInformation.dob).convertToString("yyyy")
      );
      if (resp.length > 0) {
        this.year_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetYear", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.year_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getExperianceInYear() {
      this.expYear_List = [];
      const _data_ = {
        dob: new Date(this.basicInformation.dob).convertToString("dd MMM yyyy"),
      };
      let resp = masterAPI.getExpYear(
        new Date(this.basicInformation.dob).convertToString("yyyy")
      );
      if (resp.length > 0) {
        this.expYear_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetExperianceInYear", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.expYear_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getExperianceInMonth() {
      this.expMonth_List = [];
      let resp = masterAPI.getExpMonth();
      if (resp.length > 0) {
        this.expMonth_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetExperianceInMonth", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: "",
          crossdomain: true,
        })
        .then(
          (response) => {
            this.expMonth_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getTitle() {
      this.title_List = [];
      const _data_ = { rankID: -1, type: 1 };

      let resp = masterAPI.getRanks();
      this.title_List = resp;
      if (resp.length > 0) {
        this.basicInformation.titleID = resp[0][0];
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetRank", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.title_List = response.data;
            if (response.data.length > 0) {
              this.basicInformation.titleID = response.data[0][0];
            }
          },
          (error) => {}
        );*/
    },
    getMStatus() {
      this.maritalStatus_List = [];
      const _data_ = { type: 1 };
      let resp = masterAPI.getMStatus(this.basicInformation.candgender);
      this.maritalStatus_List = resp;
      if (resp.length > 0) {
        this.basicInformation.maritalStatusID = resp[0][0];
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetMStatus", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.maritalStatus_List = response.data;
            if (response.data.length > 0) {
              this.basicInformation.maritalStatusID = response.data[0][0];
            }
          },
          (error) => {}
        );*/
    },
    getPHType() {
      this.physicalHandicap_List = [];
      const _data_ = {
        advtID: this.basicInformation.candadvtID,
        postTypeID: this.basicInformation.candpostTypeID,
        type: 1,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetPHType", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.physicalHandicap_List = response.data;
            // if(response.data.length > 0){
            //     this.physicalHTypeID = response.data[0][0];
            // }
          },
          (error) => {}
        );
    },
    getExServiceType() {
      this.exServiceType_List = [];
      const _data_ = { type: 1 };
      let resp = masterAPI.getExServiceType();
      if (resp.length > 0) {
        this.exServiceType_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetExServiceType", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.exServiceType_List = response.data;
          },
          (error) => {}
        );*/
    },
    getState() {
      this.state_List = [];
      const _data_ = { stateID: -1, type: this.basicInformation.nationalityID };
      let resp = masterAPI.getState(this.basicInformation.nationalityID);
      //console.log(this.basicInformation.nationalityID);
      //console.log(resp);
      if (resp.length > 0) {
        this.state_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetState", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.state_List = response.data;
          },
          (error) => {}
        );*/
    },
    setDistrict(type) {
      if (type == 1) {
        this.correspondanceAddress.districtID = -1;
      } else if (type == 2) {
        this.addressInformation.districtID = -1;
      }
    },
    getDistrict() {
      this.district_List = [];
      const _data_ = {
        districtID: -1,
        stateID: -1,
        type: 1, //this.basicInformation.nationalityID
      };
      let resp = masterAPI.getDistrict(-1, 1);
      if (resp.length > 0) {
        this.district_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetDistrict", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.district_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getReligion() {
      this.religion_List = [];
      const _data_ = { religionID: -1, type: 1 };
      let resp = masterAPI.getReligion();
      if (resp.length > 0) {
        this.religion_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetReligion", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.religion_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getSportLevel() {
      this.sportLevel_List = [];
      const _data_ = { sportLevelID: -1, type: 1 };
      let resp = masterAPI.getSportsLevel();
      if (resp.length > 0) {
        this.sportLevel_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetSportLevel", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.sportLevel_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getSportMedal() {
      this.sportMedal_List = [];
      const _data_ = { sportMedalID: -1, type: 1 };
      let resp = masterAPI.getSportsMedal();
      if (resp.length > 0) {
        this.sportMedal_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetSportMedal", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.sportMedal_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getSport() {
      this.sport_List = [];
      const _data_ = { sportID: -1, type: 1 };
      let resp = masterAPI.getSport();
      if (resp.length > 0) {
        this.sport_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetSport", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.sport_List = response.data;
          },
          (error) => {}
        );
        */
    },
    getPostingCityChoice() {
      this.postingCityChoice_List = [];
      const _data_ = {
        advtID: this.basicInformation.candadvtID,
        postTypeID: this.basicInformation.candpostTypeID,
        appCasteTypeID: this.basicInformation.castTypeID,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetPostingCityChoice", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.postingCityChoice_List = response.data;
          },
          (error) => {}
        );
    },
    getExamCentreChoice() {
      this.examCentreChoice_List = [];
      const _data_ = {
        advtID: this.basicInformation.candadvtID,
        postTypeID: this.basicInformation.candpostTypeID,
        appCasteTypeID: this.basicInformation.castTypeID,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetExamCentreChoice", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.examCentreChoice_List = response.data;
          },
          (error) => {}
        );
    },
    getQualMaster(qualType) {
      if (qualType == 1) {
        this.qualMaster_List = [];
        let resp = masterAPI.getQualification();
        if (resp.length > 0) {
          this.qualMaster_List = resp;
        }
      }
      if (qualType == 2) {
        this.qualCertificateMaster_List = [];
        let resp = masterAPI.getQualCertificate();
        if (resp.length > 0) {
          this.qualCertificateMaster_List = resp;
        }
      }
      /*
      var _data_ = {};
      if (qualType == 1) {
        this.qualMaster_List = [];
        _data_ = { qualID: -1, qualType: 1, type: 1 };
      } else {
        this.qualCertificateMaster_List = [];
        _data_ = { qualID: -1, qualType: 2, type: 1 };
      }
      axios
        .get(config.WEB_API_PATH + "Master/GetQualification", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            if (qualType == 1) {
              this.qualMaster_List = response.data;
            } else {
              this.qualCertificateMaster_List = response.data;
            }
          },
          (error) => {}
        );
        */
    },
    getUniversity() {
      this.university_List = [];
      const _data_ = { univID: -1, qualID: -1, type: 1 };
      let resp = masterAPI.getUniversity();
      if (resp.length > 0) {
        this.university_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetUniversity", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.university_List = response.data;
          },
          (error) => {}
        );*/
    },
    getCandidateApp() {
      this.candApplication_List = [];
      const _data_ = { advtID: -1, type: 1 };
      axios
        .get(config.WEB_API_PATH + "Registration/GetCandApplication", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            let self = this;
            this.candApplication_List = response.data.result;

            if (this.candApplication_List.length > 0) {
              this.isExpired = response.data.result[0][18];
            }
            if (response.data.result.length <= 0) {
              this.isNew = true;
            } else {
              this.isNew = false;
              response.data.result.forEach((element) => {
                if (element[9] == "1") {
                  self.isExamCenterLock = true;
                }
              });
            }
          },
          (error) => {}
        );
      console.log(this.candApplication_List);
    },
    getIDCardList() {
      this.idCard_List = [];
      const _data_ = { idCardID: -1, type: 1 };
      let resp = masterAPI.getICard();
      if (resp.length > 0) {
        this.idCard_List = resp;
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetIDCard", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.idCard_List = response.data;
          },
          (error) => {}
        );*/
    },
    getSelectelabel() {
      this.advt_List.forEach((element) => {
        if (element[0] == this.advtID) {
          this.selectedAdvt = element[1];
        }
      });
      this.postType_List.forEach((element) => {
        if (element[0] == this.postTypeID) {
          this.selectedPostType = element[1];
        }
      });
      this.selectedGender =
        this.gender == "M"
          ? "Male"
          : this.gender == "F"
          ? "Female"
          : "Transgender";
      this.appCastType_List.forEach((element) => {
        if (element[0] == this.appCastTypeID) {
          this.selectedAppCastType = element[1];
        }
      });
      this.selectedrecruitmentRelaxation = "None";
      this.recruitmentRelaxation_List.forEach((element) => {
        if (element[0] == this.relaxationTypeID) {
          this.selectedrecruitmentRelaxation = element[1];
        }
      });
      if (this.mainCatID == -1) {
        this.selectedMainCat = "None";
      } else {
        this.mainCat_List.forEach((element) => {
          if (element[0] == this.mainCatID) {
            this.selectedMainCat = element[1];
          }
        });
      }
      this.selectedEWS = this.youEWS == "1" ? "Yes" : "No";
      this.selectedNationality =
        this.basicInformation.nationalityTypeID == 1
          ? "A citizen of India "
          : "Other";
    },
    loadMasterDropDowns() {
      this.getTitle();
      this.getMStatus();
      this.getPHType();
      this.getExServiceType();
      this.getState();
      this.getDistrict();
      this.getReligion();
      this.getSportLevel();
      this.getSportMedal();
      this.getSport();
      this.getQualMaster(1);
      this.getQualMaster(2);
      this.getUniversity();
      this.getIDCardList();
    },
    clearBasicData() {
      this.whichTabSelected = 1;
      this.isAllowDiscard = 0;
      this.isAllowToPostingCityChange = 0;
      this.candidate_MainData = [];
      this.basicInformation = {
        titleID: -1,
        firstName: "",
        middleName: "",
        lastName: "",
        fatherName: "",
        motherName: "",
        dob: new Date("01 Jan 1900"),
        religionID: -1,
        phoneNumber: "",
        mobileNumber: "",
        emailID: "",
        domicileStateID: -1,
        aadhaarNumber: "",
        maritalStatusID: -1,
        recruitmentTypeID: -1,
        candadvtID: -1,
        candgender: "M",
        candpostTypeID: -1,
        castTypeID: this.appCasteTypeID,
        castName: "",
        isPhyHandicap: 0,
        physicalHTypeID: "-",
        phyHandiPercentage: "",
        isSportsMan: 0,
        sportLevelID: -1,
        sportMedalID: -1,
        sportID: -1,
        isExServiceMan: 0,
        exServiceTypeID: -1,
        relaxationTypeID: -1,
        exServiceNo: "",
        exServiceDate: new Date("01 Jan 1900"),
        exServiceYear: 0,
        exServiceMonth: 0,
        exServiceDay: 0,
        relaxationTypeID: -1,
        appMediaNo: "",
        dateOfAppointment: new Date("01 Jan 1900"),
        dateofRetirement: new Date("01 Jan 1900"),
        empOrgName: "",
        empPostName: "",
        employerOffice: "",
        empLetterNo: "",
        nationalityID: 11,
        nationalityTypeID: 1,
        IdMark: "",
        empletterDate: new Date().convertToString("dd MMM yyyy"),
        isNOCObtained: 0,
        candRegPlace: "",
        candRegDate: new Date().convertToString("dd MMM yyyy"),
        nationalityID: 11,
        nationalityTypeID: 1,
      };
      this.addressInformation = {
        address: "",
        city: "",
        district: "",
        districtID: -1,
        stateID: -1,
        pinCode: "",
      };
      this.correspondanceAddress = {
        address: "",
        city: "",
        district: "",
        districtID: -1,
        stateID: -1,
        pinCode: "",
      };
      this.candQualOne = [];
      this.candQualTwo = [];
      this.candOtherQualOne = [];
      this.candOtherQualTwo = [];

      this.exServiceMan = [];
      this.sportsMan = [];
      this.documentCertificate = [];

      this.candRelaxation = [];
      this.candExamCenter = [];
      this.candPostingCity = [];
      this.candDocuments = [];

      this.upFiles = [];
      this.docRowEdit = [];
      this.applicationPrintDiv = false;
      this.printbus = new vue();
      this.callLetterPrintDiv = false;
      this.callLetterprintbus = new vue();
    },
    getCandidateInfo() {
      var basicData = {
        CandidateID: this.candidateID,
        AdvtID: this.advtID,
        PostTypeID: this.postTypeID,
        AppCasteTypeID: this.appCastTypeID,
        MainCatID: this.mainCatID,
        IsEWS: this.youEWS,
        Gender: this.gender,
        QualGroupID: this.criteriaQualSetID,
        Type: this.candidateID == -1 ? 1 : 2,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));

      axios
        .post(config.WEB_API_PATH + "Registration/GetCandAppInfo", formData, {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          crossdomain: true,
        })
        .then(
          (response) => {
            let self = this;
            this.candidate_MainData = response.data.result;
            console.log(response.data.result);

            let _cand = this.candidate_MainData.cand;

            if (_cand.length > 0) {
              this.basicInformation.candadvtID = _cand[0][2];
              this.basicInformation.candgender = _cand[0][12];
              this.getMStatus();
              this.basicInformation.candpostTypeID = _cand[0][3];
              this.basicInformation.candMainCatID = _cand[0][4];
              this.basicInformation.candAppCastTypeID = _cand[0][5];
              this.basicInformation.nationalityID = _cand[0][7];
              this.candidateID = _cand[0][0];
              this.applicationNo = _cand[0][1];
              this.basicInformation.titleID = _cand[0][8];
              this.basicInformation.firstName = _cand[0][9];
              this.basicInformation.middleName = _cand[0][10];
              this.basicInformation.lastName = _cand[0][11];
              this.basicInformation.fatherName = _cand[0][15];
              this.basicInformation.motherName = _cand[0][16];
              this.basicInformation.dob = new Date(_cand[0][13]);
              this.getYear();
              this.getExperianceInYear();
              this.getExperianceInMonth();
              this.basicInformation.religionID = _cand[0][20];
              this.basicInformation.phoneNumber = _cand[0][18];
              this.basicInformation.mobileNumber = _cand[0][19];
              this.basicInformation.mobileNumberDisplay =
                _cand[0][19] != ""
                  ? _cand[0][19]
                      .substring(
                        _cand[0][19].length > 4
                          ? _cand[0][19].length - 4
                          : _cand[0][19].length - 2
                      )
                      .padStart(_cand[0][19].length, "*")
                  : "";
              this.basicInformation.emailID = _cand[0][17];
              this.basicInformation.emailIDDisplay =
                _cand[0][17] != ""
                  ? _cand[0][17]
                      .substring(
                        _cand[0][17].split("@")[0].length > 6
                          ? _cand[0][17].split("@")[0].length - 4
                          : _cand[0][17].split("@")[0].length - 2
                      )
                      .padStart(_cand[0][17].length, "*")
                  : "";
              this.basicInformation.domicileStateID = _cand[0][24];
              this.basicInformation.domicileFrom = new Date(_cand[0][25]);
              this.basicInformation.domicileTo = new Date(_cand[0][26]);
              this.basicInformation.aadhaarNumber = ""; //_cand[0][23];
              this.basicInformation.aadhaarNumberDisplay = _cand[0][23];
              this.basicInformation.maritalStatusID = _cand[0][14];
              this.basicInformation.IsReqForScribe = _cand[0][30];
              this.basicInformation.castName = _cand[0][22];
              this.basicInformation.isPhyHandicap = _cand[0][4] == 11 ? 1 : 0;
              this.basicInformation.IdMark = _cand[0][27];
              this.basicInformation.physicalHTypeID = _cand[0][28];
              this.basicInformation.phyHandiPercentage = _cand[0][29];
              this.basicInformation.isExServiceMan = _cand[0][4] == 12 ? 1 : 0;
              this.basicInformation.dateOfAppointment = new Date(_cand[0][46]);
              this.basicInformation.retirementEndDate = new Date(_cand[0][71]);

              this.basicInformation.empOrgName = _cand[0][43];
              this.basicInformation.empPostName = _cand[0][45];
              this.basicInformation.employerOffice = _cand[0][44];
              this.basicInformation.empLetterNo = _cand[0][48];
              this.basicInformation.empletterDate = new Date(_cand[0][49]);
              this.basicInformation.isNOCObtained = _cand[0][47];

              this.addressInformation.address = _cand[0][37];
              this.addressInformation.pinCode = _cand[0][38];
              this.addressInformation.city = _cand[0][39];
              this.addressInformation.stateID = _cand[0][41];
              this.addressInformation.districtID = _cand[0][40];

              this.IsSameAsCorrespondance = _cand[0][36] == "1" ? true : false;

              this.correspondanceAddress.address = _cand[0][31];
              this.correspondanceAddress.pinCode = _cand[0][32];
              this.correspondanceAddress.city = _cand[0][33];
              this.correspondanceAddress.stateID = _cand[0][35];
              this.correspondanceAddress.districtID = _cand[0][34];

              this.basicInformation.candRegPlace = _cand[0][57];
              this.basicInformation.candRegDate = _cand[0][58];
              this.isSubmit = _cand[0][59];
              this.isReject = _cand[0][60];
              this.isAllowToPostingCityChange = _cand[0][61];
              this.isAllowDiscard = _cand[0][64];
              this.OtherDetails.isEERegistered = _cand[0][50];
              this.OtherDetails.eRegistrationNo = _cand[0][51];
              this.OtherDetails.eRegistrationDate = new Date(_cand[0][52]);
              this.OtherDetails.eExchangeName = _cand[0][53];
              this.OtherDetails.eAddress = _cand[0][54];
              this.OtherDetails.eDistrictID = _cand[0][55];
              this.OtherDetails.eStateID = _cand[0][56];

              this.basicInformation.recruitmentTypeID = _cand[0][65];
              this.basicInformation.recruitmentTypeName = _cand[0][66];
              this.basicInformation.relaxationTypeID = _cand[0][67];
              this.basicInformation.relaxationTypeName = _cand[0][68];
              this.basicInformation.workedTillPresent = _cand[0][69];
              this.basicInformation.retirementDate = _cand[0][70];
              if (this.candidateID != -1) {
                this.getCasteTypePostWiseByCandID(function () {
                  self.basicInformation.castTypeID = _cand[0][21];
                  self.getPostingCityChoice();
                  self.getExamCentreChoice();
                });
                this.getPHType();
                this.basicInformation.physicalHTypeID = _cand[0][28];
                if (_cand[0][28] == "" || _cand[0][28] == null) {
                  this.basicInformation.physicalHTypeID = "-";
                }
              }

              if (
                this.basicInformation.physicalHTypeID == "B" ||
                this.basicInformation.physicalHTypeID == "D"
              ) {
                this.isscribeHide = true;
              } else {
                this.isscribeHide = false;
              }

              this.candQualOne = this.candidate_MainData.qual1;
              this.candQualTwo = this.candidate_MainData.qual2;
              this.candOtherQualOne = this.candidate_MainData.otherQual1;
              this.candOtherQualTwo = this.candidate_MainData.otherQual2;
              this.candRelaxation = this.candidate_MainData.relaxation;
              this.exServiceMan = this.candidate_MainData.exServiceMan;
              this.sportsMan = this.candidate_MainData.sportsMan;
              this.documentCertificate =
                this.candidate_MainData.documentCertificate;
              this.candExamCenter = this.candidate_MainData.examCenter;
              this.candPostingCity = this.candidate_MainData.postingCity;
              this.candDocuments = this.candidate_MainData.documents;
              this.candRejectReason = this.candidate_MainData.rejectReason;
              // if (this.candRelaxation.length > 0) {
              //   this.candRelaxation.forEach(element => {
              //     if (element[3] == "1") {
              //       if (self.basicInformation.isExServiceMan == "1") {
              //         self.basicInformation.relaxationTypeID = element[0];
              //       } else {
              //         self.basicInformation.relaxationOtherTypeID = element[0];
              //       }
              //     }
              //   });
              // }

              //self.generateCaptcha(1);
              if (_cand[0][56] == "1") {
                this.tabClick(4);
              } else {
                this.tabClick(this.whichTabSelected);
              }
              self.isShowLoad = false;
            }
          },
          (error) => {}
        );
    },
    calcAggregate(event, row) {
      if (parseFloat(row[19]) > 0 && parseFloat(row[18]) > 0) {
        let per = 0;
        per = (
          parseFloat(parseFloat(row[18]) * 100.0) / parseFloat(row[19])
        ).toFixed(2);
        vue.set(row, 20, per);
      } else {
        vue.set(row, 20, "");
      }
    },
    calcMiscellaneousAggregate(event, row) {
      if (parseFloat(row[19]) > 0 && parseFloat(row[18]) > 0) {
        let per = 0;
        per = (
          parseFloat(parseFloat(row[18]) * 100.0) / parseFloat(row[19])
        ).toFixed(2);
        vue.set(row, 20, per);
      } else {
        vue.set(row, 20, "");
      }
    },
    calcAggregateOther(event, row) {
      //alert(row[9]);
      if (parseFloat(row[6]) > 0 && parseFloat(row[5]) > 0) {
        let per = 0;
        per = (
          parseFloat(parseFloat(row[5]) * 100.0) / parseFloat(row[6])
        ).toFixed(2);
        vue.set(row, 7, per);
      } else {
        vue.set(row, 7, "");
      }
    },
    confirmNewApplication() {
      var isAllSub = true;
      this.candApplication_List.forEach((element) => {
        if (element[9] == "0") {
          isAllSub = false;
        }
      });
      if (!isAllSub) {
        MessageBox.show({
          message: "Please Submit all Application before creating New",
          type: "error",
          title: "API says",
        });
        return;
      }
      MessageBox.show(
        {
          message:
            "Details once saved cannot be amended later.</br>Are you sure want to proceed? </br> Click  New Application to continue",
          type: "confirm",
          title: "",
          defaultButton: 2,
        },
        { buttonName: "New Application", buttonAction: this.newApplicationAdd },
        { buttonName: "Cancel", buttonAction: this.showFlashMessage }
      );
    },
    newApplicationAdd() {
      this.candidateID = -1;
      var nationality = 1;
      if (this.basicInformation.nationalityTypeID == 0) {
        nationality = this.basicInformation.nationalityID;
      } else {
        this.basicInformation.nationalityID = 1;
      }
      var basicData = {
        CandidateID: this.candidateID,
        AdvtID: this.advtID,
        PostTypeID: this.postTypeID,
        AppCasteTypeID: this.appCastTypeID,
        MainCatID: this.mainCatID,
        IsEWS: this.youEWS,
        Gender: this.gender,
        QualGroupID: this.criteriaQualSetID,
        NationalityID: nationality,
        RecruitmentTypeID: this.recruitmentTypeID,
        RelaxationTypeID: this.relaxationTypeID,
        Type: this.candidateID == -1 ? 1 : 2,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));

      axios
        .post(
          config.WEB_API_PATH + "Registration/UpdateCandApplication",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token,
            },
            crossdomain: true,
          }
        )
        .then(
          (response) => {
            if (response.data.isSuccess) {
              let self = this;
              this.candidateID = response.data.result;
              MessageBox.show({
                message: response.data.msg,
                type: "success",
                title: "API says",
              });
              this.getCandidateApp();
              vue.nextTick(() => {
                self.loadMasterDropDowns();
                //self.generateCaptcha(1);
                //self.isShowLoad = false;
              });
              vue.nextTick(() => {
                self.getCandidateInfo();
              });
              //  if(this.mainCatID==12){
              //     this.basicInformation.isExServiceMan=1;
              //  }
              //  if(this.mainCatID==11){
              //     this.basicInformation.isPhyHandicap=1;
              //  }
              //  if(this.mainCatID==13){
              //      this.basicInformation.isSportsMan=1;
              //  }
            } else {
              MessageBox.show({
                message: response.data.msg,
                type: "error",
                title: "API says",
              });
            }
          },
          (error) => {}
        );
    },
    getRegistrationData(row) {
      let self = this;
      this.candidateID = row[0];
      this.basicInformation.nationalityID = row[14];
      vue.nextTick(() => {
        self.loadMasterDropDowns();
      });
      vue.nextTick(() => {
        self.getCandidateInfo();
      });
    },
    clickToBack() {
      this.clearBasicData();
      this.candidateID = -1;
      this.isShowLoad = true;
    },
    documentsPosting(event, docRow, rowIndex) {
      console.log(docRow);
      if (docRow[5] == "2" && docRow[2] == "-1") {
        MessageBox.show({
          message: "Please Select ID Card !!!",
          type: "error",
          title: "API says",
        });
        event.target.value = "";
        return;
      }
      var msg = "";
      if (docRow[12] == "1" && docRow[11] == "" && docRow[16] == "") {
        msg = "Please enter Document Number !!!";
      }
      if (docRow[12] == "1" && docRow[11] != "" && docRow[2] == "1") {
        let isAadharNumOnly = isNaN(docRow[11]);
        if (
          (docRow[11] != "" || docRow[11] == "") &&
          docRow[16] != "" &&
          docRow[16].length != 12 &&
          isAadharNumOnly
        ) {
          msg = "Please enter valid Aadhaar Number !!!";
        }
      }
      if (
        docRow[12] == "1" &&
        (docRow[11] != "" || docRow[11] == "") &&
        docRow[16] != "" &&
        docRow[2] == "2"
      ) {
        if (docRow[16].length != 10) {
          msg = "Please enter valid PAN Number !!!";
        }
      }
      if (msg != "") {
        MessageBox.show({
          message: msg,
          type: "error",
          title: "API says",
        });
        event.target.value = "";
        return;
      }
      var ext = ["JPG", "JPEG"];
      var me = this;
      var myFiles = [];

      var lstFiles = event.target.files;
      var isValidExtension = true;
      var isValidSize = true;
      var isMinValidSize = true;
      var minCheckSize = parseFloat(docRow[14] * 1024);
      var checkSize = parseFloat(docRow[15] * 1024);

      for (var i = 0; i < lstFiles.length; i++) {
        var fName = lstFiles[i].name;
        var fileExt = fName.split(".").pop();
        if (!(ext.indexOf(fileExt.toUpperCase()) >= 0)) {
          isValidExtension = false;
        }
        var size = lstFiles[i].size;
        if (parseFloat(size) < minCheckSize) {
          isMinValidSize = false;
        }

        if (parseFloat(size) > checkSize) {
          isValidSize = false;
        }
        myFiles.push(lstFiles[i]);
      }

      if (isValidExtension == false) {
        alert("Unsupported media type. only JPG image files are upload");
        event.target.value = "";
        return false;
      }
      if (isMinValidSize == false) {
        alert(
          "Individual image files minimum size should be more than " +
            parseFloat(minCheckSize) / 1024 +
            " KB"
        );
        event.target.value = "";
        return false;
      }
      if (isValidSize == false) {
        alert(
          "Individual image files size should be less than " +
            parseFloat(checkSize) / 1024 +
            " KB."
        );
        event.target.value = "";
        return false;
      }
      myFiles.forEach((element) => {
        var fName = element.name;
        var fileExt = fName.split(".").pop();
        var reader = new FileReader();
        reader.addEventListener("load", function (e) {
          var object = new Object();
          object.file = element;
          object.filePreview = e.target.result;
          object.docFileName = fName;
          object.percent = 0;
          object.docFileID = "-1";
          object.isUplodError = false;
          object.isApproved = false;
          object.ext = fileExt;
          me.upFiles.push(object);
        });
        if (ext.indexOf(fileExt.toUpperCase()) >= 0) {
          reader.readAsDataURL(element);
        }
      });
      //event.target.value = "";
      window.setTimeout(() => {
        var encDocNo =
          docRow[16] != ""
            ? encryptionJS.encryptAES(docRow[16])
            : docRow[11] != ""
            ? docRow[11]
            : "";
        me.upFiles.forEach(function (item, index) {
          //if (item.docFileID == "-1") {
          var objData = new Object();
          objData.CandidateID = docRow[1];
          objData.CommonID = docRow[2];
          objData.CommonType = docRow[4];
          objData.DocTypeID = docRow[5];
          objData.DocSerialNo = docRow[6];
          objData.DocumentNo = encDocNo; //docRow[11];
          objData.DocRowID = docRow[9];

          objData.DocFileID = docRow[0];
          objData.DocFileName = item.docFileName;
          objData.DocFileExt = item.ext.toUpperCase();

          var formData = new FormData();
          formData.append("FileInfoData", JSON.stringify(objData));
          formData.append("file", item.file);

          axios
            .post(
              config.WEB_API_PATH + "Registration/UploadDocuments",
              formData,
              {
                headers: {
                  __RequestVerificationToken: config.AF_Token,
                  Authorization: config.LOG_Token,
                },
                onUploadProgress: function (progressEvent) {
                  item.percent = parseInt(
                    Math.round(
                      (progressEvent.loaded * 100) / progressEvent.total
                    )
                  );
                }.bind(me),
                crossdomain: true,
              }
            )
            .then(
              (response) => {
                FlashMessage.show(
                  "<span style='color:red'>" + response.data.msg + "</span>",
                  1000
                );
                item.docFileID = response.data.result;
                docRow[0] = response.data.result;
                docRow[7] = response.data.result1;
                docRow[8] = response.data.result2;
                docRow[10] = "1";

                // Update the array forcefully
                vue.set(me.candDocuments, rowIndex, docRow);
                //me.candDocuments.splice(rowIndex,1,docRow);

                item.isUplodError = false;
                event.target.value = "";
                me.upFiles = [];
                vue.nextTick(function () {
                  me.getCandidateInfo();
                });
              },
              (error) => {
                if (error.response == undefined) {
                  alert("Error:" + error);
                } else {
                  if (error.response.status == "415") {
                    alert("Error: " + error.response.statusText);
                  } else {
                    if (error.response.data.message == undefined) {
                      alert("Error: " + error.response.data);
                    } else {
                      alert("Error: " + error.response.data.message);
                    }
                  }
                }
                item.percent = 0;
                item.isUplodError = true;
                me.upFiles = [];
                event.target.value = "";
              },
              (failure) => {
                alert("Failure: " + failure);
                item.percent = 0;
                item.isUplodError = true;
                me.upFiles = [];
                event.target.value = "";
              }
            );
          //}
        });
      }, 500);
    },
    openDocImage(docRow) {
      var img = new Image();
      axios
        .get(config.WEB_API_PATH + "Registration/GetDocuments", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: { docFileID: docRow[0], candidateID: docRow[1], type: 1 },
          crossdomain: true,
        })
        .then(
          (result) => {
            img.src = result.data;
            this.windowPreview;
            if (this.windowPreview != null) {
              this.windowPreview.close();
            }
            this.windowPreview = window.open(
              "",
              "FilePreview",
              "scrollbars,addressbar=no,location=no,resizable=yes,width=550px,height=600px,left=10,top=10"
            );
            this.windowPreview.document.write(img.outerHTML);
          },
          (error) => {}
        );
    },
    modalPopupClosed(e) {
      if (this.callType == 0) {
        this.candidateID = -1;
      }
      this.isSubmitAllow = 0;
      this.printbus = new vue();
      this.callLetterprintbus = new vue();
      this.admitCardbus = new vue();
      this.appointmentLetterbus = new vue();
      this.isShowAppPreview = false;
    },
    modalPopupShown(e) {
      //console.log("Modal Popup Shown");
    },
    printAdmitCard(row) {
      if (row) {
        let self = this;
        this.candidateID = row[0];
        vue.nextTick(function () {
          self.admitCardbus.$emit("getCandidateDetail");
          self.admitCardDiv = true;
        });
      }
    },
    printAdmitCardReport() {
      this.admitCardbus.$emit("printPDF");
    },
    printAppointmentLetter(row) {
      if (row) {
        let self = this;
        this.candidateID = row[0];
        vue.nextTick(function () {
          self.appointmentLetterbus.$emit("getCandidateDetail");
          self.appointmentLetterDiv = true;
        });
      }
    },
    printAppointmentLetterReport() {
      this.appointmentLetterbus.$emit("printPDF");
    },
    printApplicationForm(row, _type) {
      this.callType = _type;
      this.isShowAppPreview = true;
      if (_type == 1) {
        let self = this;
        this.isSubmitAllow = 1;
        vue.nextTick(function () {
          self.printbus.$emit("getCandidateDetail");
          self.applicationPrintDiv = true;
        });
      } else if (_type == 2) {
        let self = this;
        this.isSubmitAllow = 0;
        vue.nextTick(function () {
          self.printbus.$emit("getCandidateDetail");
          self.applicationPrintDiv = true;
        });
      } else {
        if (row) {
          let self = this;
          this.candidateID = row[0];
          this.isSubmitAllow = 0;
          vue.nextTick(function () {
            self.printbus.$emit("getCandidateDetail");
            self.applicationPrintDiv = true;
          });
        }
      }
    },
    printPDFReport() {
      this.printbus.$emit("printPDF");
    },
    formDataMaking(type, isVerify) {
      var qualTable = [];
      var otherQualTable = [];
      var experianceTable = [];
      var otherExperianceTable = [];
      var examCenterTable = [];
      var postingTable = [];
      var documents = [];
      var exServiceManTable = [];
      var sportManTable = [];
      var documentCertificateTable = [];

      this.candQualOne.forEach((element) => {
        if (element[1] != "-1") {
          qualTable.push({
            QualID: element[1],
            QualType: element[2],
            QualPriority: element[3],
            QualName: element[4],
            PerAgg: element[5],
            QualUnivType: element[6],
            PostQualID: element[7],
            IsCertificateReq: element[8],
            QualSetID: element[9],
            RollNo: element[10],
            SchoolName: element[11], //,
            StateID: element[12], //,
            UnivID: element[13], //,
            UnivName: element[14], //,
            PassingYear: element[15], //,
            IsGrade: element[16], //,
            QualGrade: element[17], //,
            MarkObtained: element[18] == "" ? "0" : element[18],
            MarkTotal: element[19] == "" ? "0" : element[19],
            QualPercent: element[20] == "" ? "0" : element[20],
            IsOtherQual: element[21], //,SchoolName: element[20] //,
            QualRowID: element[22], //,SchoolName: element[20] //,
          });
        }
      });
      this.candQualTwo.forEach((element) => {
        if (element[1] != "-1") {
          otherQualTable.push({
            QualID: element[1],
            QualType: element[2],
            QualPriority: element[3],
            QualName: element[4],
            PerAgg: element[5],
            QualUnivType: element[6],
            PostQualID: element[7],
            IsCertificateReq: element[8],
            QualSetID: element[9],
            RollNo: element[10],
            SchoolName: element[11], //,
            StateID: element[12], //,
            UnivID: element[13], //,
            UnivName: element[14], //,
            PassingYear: element[15], //,
            IsGrade: element[16], //,
            QualGrade: element[17], //,
            MarkObtained: element[18] == "" ? "0" : element[18],
            MarkTotal: element[19] == "" ? "0" : element[19],
            QualPercent: element[20] == "" ? "0" : element[20],
            IsOtherQual: element[21], //,SchoolName: element[20] //,
            QualRowID: element[22], //,SchoolName: element[20] //,
          });
        }
      });
      this.candOtherQualOne.forEach((element) => {
        if (element[1] != "-1") {
          experianceTable.push({
            QualID: element[1],
            QualType: element[2],
            QualPriority: element[3],
            QualName: element[4],
            QualUnivType: element[5],
            PostQualID: element[6],
            IsCertificateReq: element[7],
            QualSetID: element[8],
            TradeName: element[9],
            InstName: element[10],
            InstType: element[11],
            RecognisedBy: element[12],
            ExpInYear: element[13],
            ExpInMonth: element[14],
            IsOtherExp: element[15],
            ExpRowID: element[16],
          });
        }
      });
      this.candOtherQualTwo.forEach((element) => {
        if (element[1] != "-1") {
          otherExperianceTable.push({
            QualID: element[1],
            QualType: element[2],
            QualPriority: element[3],
            QualName: element[4],
            QualUnivType: element[5],
            PostQualID: element[6],
            IsCertificateReq: element[7],
            QualSetID: element[8],
            TradeName: element[9],
            InstName: element[10],
            InstType: element[11],
            RecognisedBy: element[12],
            ExpInYear: element[13],
            ExpInMonth: element[14],
            IsOtherExp: element[15],
            ExpRowID: element[16],
          });
        }
      });
      this.exServiceMan.forEach((element) => {
        if (element[2] != "-1") {
          exServiceManTable.push({
            SerialNo: element[1],
            ExServiceTypeID: element[2],
            ExServiceNo: element[3],
            ExEnrollmentDate: new Date(element[4]).convertToString(
              "dd MMM yyyy"
            ),
            ExRetirementDate: new Date(element[5]).convertToString(
              "dd MMM yyyy"
            ),
            ExServiceInYear: element[6],
            ExServiceInMonth: element[7],
            ExServiceInDay: element[8],
            ExDischargeBookNo: element[9],
          });
        }
      });
      this.sportsMan.forEach((element) => {
        if (element[2] != "-1") {
          sportManTable.push({
            SerialNo: element[1],
            SportLevelID: element[2],
            SportID: element[3],
            SportMedalID: element[4],
            SportCompetitionName: element[5],
            SportStateHeld: element[6],
            SportCountryHeld: element[7],
            SportParticipatingYear: element[8],
            SportClearenceNo: element[9],
            SportClearenceDate: new Date(element[10]).convertToString(
              "dd MMM yyyy"
            ),
          });
        }
      });
      this.documentCertificate.forEach((element) => {
        documentCertificateTable.push({
          MainCatID: element.mainCatID,
          PostQualID: element.postQualID,
          QualID: element.qualID,
          SerialNo: element.serialNo,
          CommonName: element.commonName,
          CertificateNo: element.certificateNo,
          IssueDate: new Date(element.issueDate).convertToString("dd MMM yyyy"),
          AuthorityName: element.authorityName,
          DistrictID: element.districtID,
          StateID: element.stateID,
          IsLifeTimeValid: element.isLifeTimeValid,
          ValidUpTo: new Date(element.validUpTo).convertToString("dd MMM yyyy"),
        });
      });
      this.candExamCenter.forEach((element) => {
        examCenterTable.push({
          ChoiceSerialNo: element[0],
          ExamCityID: element[1],
        });
      });
      this.candPostingCity.forEach((element) => {
        postingTable.push({
          ChoiceSerialNo: element[0],
          PostingCityID: element[1],
        });
      });
      this.candDocuments.forEach((element) => {
        documents.push({
          CandidateID: element[1],
          CommonID: element[2],
          CommonType: element[4],
          DocTypeID: element[5],
          DocSerialNo: element[6],
          DocRowID: element[9],
          DocFileID: element[0],
          DocFileName: element[7],
          DocFileExt: element[8],
          DocFileContent: "",
        });
      });
      var basicData = {
        ApplicationNo: this.applicationNo,
        CandidateID: this.candidateID,
        CourseID: this.basicInformation.candadvtID,
        PostTypeID: this.basicInformation.candpostTypeID,
        RankID: this.basicInformation.titleID,
        FName: this.basicInformation.firstName,
        MName: this.basicInformation.middleName,
        LName: this.basicInformation.lastName,
        Gender: this.basicInformation.candgender,
        DOB: this.basicInformation.dob.convertToString("dd MMM yyyy"),
        MStatusID: this.basicInformation.maritalStatusID,
        FatherName: this.basicInformation.fatherName,
        MotherName: this.basicInformation.motherName,
        EMailID: encryptionJS.encryptAES(this.basicInformation.emailID),
        CandPhone: this.basicInformation.phoneNumber,
        CandMobile: encryptionJS.encryptAES(this.basicInformation.mobileNumber),
        ReligionID: this.basicInformation.religionID,
        CasteTypeID: this.basicInformation.castTypeID,
        Caste: this.basicInformation.castName,
        AADHAARNo:
          this.basicInformation.aadhaarNumber != ""
            ? encryptionJS.encryptAES(this.basicInformation.aadhaarNumber)
            : this.basicInformation.aadhaarNumberDisplay != ""
            ? encryptionJS.encryptAES(
                this.basicInformation.aadhaarNumberDisplay
              )
            : "",
        IsExServiceMan: this.basicInformation.isExServiceMan,
        ExServiceTypeID: this.basicInformation.exServiceTypeID,
        ServiceYear: this.basicInformation.exServiceYear,
        ServiceMonth: this.basicInformation.exServiceMonth,
        ServiceDay: this.basicInformation.exServiceDay,
        ServiceNo: this.basicInformation.exServiceNo,
        DomicileStateID: this.basicInformation.domicileStateID,
        DomicileFrom:
          this.basicInformation.domicileFrom.convertToString("dd MMM yyyy"),
        DomicileTo:
          this.basicInformation.domicileTo.convertToString("dd MMM yyyy"),
        NationalityID: this.basicInformation.nationalityID,
        PHTypeID: this.basicInformation.physicalHTypeID,
        PHPercentage: this.basicInformation.phyHandiPercentage,
        IsSportMan: this.basicInformation.isSportsMan,
        SportLevelID: this.basicInformation.sportLevelID,
        PostalAddress: this.correspondanceAddress.address,
        PostalPinNo: this.correspondanceAddress.pinCode,
        PostalDistrictID: this.correspondanceAddress.districtID,
        PostalStateID: this.correspondanceAddress.stateID,
        PostalCity: this.correspondanceAddress.city,
        IsSameAsPostalAddress: this.IsSameAsCorrespondance,

        PerAddress: this.addressInformation.address,
        PerPinNo: this.addressInformation.pinCode,
        PerDistrictID: this.addressInformation.districtID,
        PerStateID: this.addressInformation.stateID,
        PerCity: this.addressInformation.city,
        AppMediaID: this.basicInformation.recruitmentTypeID,
        EmployerName: this.basicInformation.empOrgName,
        EmployerOffice: this.basicInformation.employerOffice,
        PostName: this.basicInformation.empPostName,
        AppointmentDate:
          this.basicInformation.dateOfAppointment.convertToString(
            "dd MMM yyyy"
          ),
        IsNOCObtained: this.basicInformation.isNOCObtained,
        LetterNo: this.basicInformation.empLetterNo,
        LetterDate:
          this.basicInformation.empletterDate.convertToString("dd MMM yyyy"),
        IsRegInEmploymentExchange: this.OtherDetails.isEERegistered,
        ExchangeRegistrationNo: this.OtherDetails.eRegistrationNo,
        ExchangeRegistrationDate:
          this.OtherDetails.eRegistrationDate.convertToString("dd MMM yyyy"),
        ExchangeName: this.OtherDetails.eExchangeName,
        ExchangeAddress: this.OtherDetails.eAddress,
        ExchangeDistrictID: this.OtherDetails.eDistrictID,
        ExchangeStateID: this.OtherDetails.eStateID,
        AppMediaNo: this.basicInformation.appMediaNo,

        DateofRetirement:
          this.basicInformation.exServiceDate.convertToString("dd MMM yyyy"),
        DateofAppointment:
          this.basicInformation.dateOfAppointment.convertToString(
            "dd MMM yyyy"
          ),
        EmpOrgName: this.basicInformation.empOrgName,
        EmpPostName: this.basicInformation.empPostName,
        employerOffice: this.basicInformation.employerOffice,
        CandRegPlace: this.basicInformation.candRegPlace,
        CandRelaxationID:
          this.basicInformation.isExServiceMan == "1"
            ? this.basicInformation.recruitmentTypeID
            : this.basicInformation.relaxationTypeID,
        CaptchaValue: this.captchaValue,
        CaptchaKey: this.captchakey,
        IDMark: this.basicInformation.IdMark,
        IsReqForScribe:
          this.basicInformation.physicalHTypeID == "B" ||
          this.basicInformation.physicalHTypeID == "D"
            ? 0
            : this.basicInformation.IsReqForScribe,
        IsWorkedTillPresen: this.basicInformation.workedTillPresent,
        RetirementDate: this.basicInformation.retirementDate,
        Type: type,
        IsVerify: isVerify,
        TableCandQual: qualTable,
        TableCandOtherQual: otherQualTable,
        TableCandExp: experianceTable,
        TableCandOtherExp: otherExperianceTable,
        TableExamChoice: examCenterTable,
        TablePostingChoice: postingTable,
        TableDocument: documents,
        TableExServiceMan: exServiceManTable,
        TableSportMan: sportManTable,
        TableDocumentCertificate: documentCertificateTable,
      };
      return basicData;
    },
    saveApplication(_type) {
      var formData = new FormData();
      formData.append(
        "BasicData",
        JSON.stringify(this.formDataMaking(1, _type))
      );
      axios
        .post(
          config.WEB_API_PATH + "Registration/UpdateCandAppInfo",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token,
            },
            crossdomain: true,
          }
        )
        .then(
          (response) => {
            if (response.data.isSuccess) {
              let self = this;

              if (_type != 0) {
                vue.nextTick(() => {
                  self.getCandidateInfo();
                });
              }
              if (_type == 0) {
                MessageBox.show({
                  message: response.data.msg,
                  type: "success",
                  title: "API says",
                });
                self.getCandidateInfo();
              } else {
                this.getCandidateApp();
                this.printApplicationForm(null, 1);
              }
            } else {
              // console.log(response.data.msg);
              MessageBox.show({
                message: response.data.msg,
                type: "error",
                title: "API says",
              });
            }
          },
          (error) => {}
        );
    },
    gradeChange(row, index) {
      if (row[16] == "0") {
        row[16] = "1";
      } else {
        row[16] = "0";
      }
      row[18] = "0";
      vue.set(this.candQualOne, index, row);
    },
    gradeMiscellaneousChange(row, index) {
      if (row[16] == "0") {
        row[16] = "1";
      } else {
        row[16] = "0";
      }
      row[18] = "0";
      vue.set(this.candQualTwo, index, row);
    },
    gradeChangeOther(row, index, type) {
      if (type == 1) {
        if (row[11] == "0") {
          row[11] = "1";
        } else {
          row[11] = "0";
        }
        row[5] = "0";
        vue.set(this.candOtherQualOne, index, row);
      } else {
        if (row[11] == "0") {
          row[11] = "1";
        } else {
          row[11] = "0";
        }
        row[5] = "0";
        vue.set(this.candOtherQualTwo, index, row);
      }
    },
    validationTab1() {
      let msg = "";
      let isError = false;
      if (this.basicInformation.titleID == -1) {
        //this.$refs.titleID.addClass('validationBox');
        isError = true;
        msg += "<br>Select Title !!!";
      }
      if (this.basicInformation.firstName == "") {
        //this.$refs.txtFirstName.addClass('validationBox');
        isError = true;
        msg += "<br>Enter first name as matriculation cirtificate !!!";
      }
      // if (this.basicInformation.fatherName == "") {
      //   this.$refs.txtfatherName.$el.addClass("invalidInput");
      //   isError = true;
      //   msg += "<br>Enter father name  !!!";
      // } else {
      //   this.$refs.txtfatherName.$el.removeClass("invalidInput");
      // }
      var dob = this.basicInformation.dob.convertToString("dd MMM yyyy");
      if (dob == "01 Jan 1900") {
        msg += "<br>Enter Date Of Birth !!!";
      }
      if (this.basicInformation.religionID == -1) {
        this.$refs.ddlReligion.addClass("invalidInput");
        isError = true;
        msg += "<br>Select Religion !!!";
      } else {
        this.$refs.ddlReligion.removeClass("invalidInput");
      }
      if (this.basicInformation.mobileNumber == "") {
        isError = true;
        msg += "<br>Enter mobile number !!!";
      }
      if (!this.$refs.txtMobileNumber.isValid) {
        msg += "<br>Mobile number not entered Properly !!!";
      }
      if (this.basicInformation.emailID == "") {
        isError = true;
        msg += "<br>Enter email ID  !!!";
      }
      if (!this.$refs.txtEmailID.isValid) {
        msg += "<br>Email ID not entered Properly !!!";
      }
      if (this.basicInformation.maritalStatusID == "-1") {
        this.$refs.ddlMStatus.addClass("invalidInput");
        isError = true;
        msg += "<br>Select Maritial Status !!!";
      } else {
        this.$refs.ddlMStatus.removeClass("invalidInput");
      }
      if (this.basicInformation.IdMark == "") {
        this.$refs.IdMark.$el.addClass("invalidInput");
        isError = true;
        msg += "<br>Enter Identification Mark !!!";
      } else {
        this.$refs.IdMark.$el.removeClass("invalidInput");
      }
      if (this.basicInformation.aadhaarNumber != "") {
        if (this.basicInformation.aadhaarNumber.length != 12) {
          this.$refs.txtUIDAINo.addClass("invalidInput");
          isError = true;
          msg += "<br>Enter valid Aadhaar No. !!!";
        } else {
          this.$refs.txtUIDAINo.removeClass("invalidInput");
        }
      }
      if (this.basicInformation.nationalityID == 1) {
        if (this.basicInformation.domicileStateID == -1) {
          this.$refs.domicileStateID.addClass("invalidInput");
          isError = true;
          msg += "<br>Select Domicile State !!!";
        } else {
          this.$refs.domicileStateID.removeClass("invalidInput");
        }
        if (this.basicInformation.domicileStateID == 2) {
          if (
            new Date(this.basicInformation.domicileFrom).convertToString(
              "dd MMM yyyy"
            ) == "01 Jan 1900"
          ) {
            this.$refs.domicileFrom.$el.addClass("invalidInput");
            isError = true;
            msg += "<br>Select Domicile From  !!!";
          } else {
            this.$refs.domicileFrom.$el.removeClass("invalidInput");
          }
          if (
            new Date(this.basicInformation.domicileTo).convertToString(
              "dd MMM yyyy"
            ) == "01 Jan 1900"
          ) {
            this.$refs.domicileTo.$el.addClass("invalidInput");
            isError = true;
            msg += "<br>Select Domicile To !!!";
          } else {
            this.$refs.domicileTo.$el.removeClass("invalidInput");
          }
        }
      }
      if (this.correspondanceAddress.address == "") {
        this.$refs.address.addClass("invalidInput");
        isError = true;
        msg += "<br>Enter Correspondence Address House No./ Village !!! ";
      } else {
        this.$refs.address.removeClass("invalidInput");
      }
      if (this.basicInformation.nationalityID == 1) {
        if (this.correspondanceAddress.stateID == -1) {
          this.$refs.ddlState.addClass("invalidInput");
          isError = true;
          msg += "<br>Select Correspondence Address State !!!";
        } else {
          this.$refs.ddlState.removeClass("invalidInput");
        }
        if (this.correspondanceAddress.districtID == -1) {
          this.$refs.districtID.addClass("invalidInput");
          isError = true;
          msg += "<br>Select Correspondence Address District !!!";
        } else {
          this.$refs.districtID.removeClass("invalidInput");
        }
        if (this.correspondanceAddress.city == "") {
          this.$refs.txtCityName.$el.addClass("invalidInput");
          isError = true;
          msg += "<br>Enter Correspondence  PO !!!";
        } else {
          this.$refs.txtCityName.$el.removeClass("invalidInput");
        }
      }
      if (this.correspondanceAddress.pinCode == "") {
        this.$refs.pinCode.$el.addClass("invalidInput");
        isError = true;
        msg += "<br>Enter Correspondence Pin Code  !!!";
      } else {
        this.$refs.pinCode.$el.removeClass("invalidInput");
      }
      if (this.addressInformation.address == "") {
        this.$refs.permanentAddress.addClass("invalidInput");
        isError = true;
        msg += "<br>Enter Permanent Address House No./ Village !!!";
      } else {
        this.$refs.permanentAddress.removeClass("invalidInput");
      }
      if (this.basicInformation.nationalityID == 1) {
        if (this.addressInformation.stateID == -1) {
          this.$refs.permanentStateID.addClass("invalidInput");
          isError = true;
          msg += "<br>Select Permanent Address State !!!";
        } else {
          this.$refs.permanentStateID.removeClass("invalidInput");
        }
        if (this.addressInformation.districtID == -1) {
          this.$refs.permanentDistrictID.addClass("invalidInput");
          isError = true;
          msg += "<br>Select Permanent Address District !!!";
        } else {
          this.$refs.permanentDistrictID.removeClass("invalidInput");
        }

        if (this.addressInformation.city == "") {
          this.$refs.txtPerCityName.$el.addClass("invalidInput");
          isError = true;
          msg += "<br>Enter Permanent PO !!!";
        } else {
          this.$refs.txtPerCityName.$el.removeClass("invalidInput");
        }
      }
      if (this.addressInformation.pinCode == "") {
        this.$refs.permanentPinCode.$el.addClass("invalidInput");
        isError = true;
        msg += "<br>Enter Permanent Pin Code  !!!";
      } else {
        this.$refs.permanentPinCode.$el.removeClass("invalidInput");
      }
      if (this.basicInformation.isPhyHandicap == 1) {
        if (this.basicInformation.physicalHTypeID == "-") {
          this.$refs.physicalHTypeID.addClass("invalidInput");
          isError = true;
          msg += "<br>Select Physically Handicapped !!!";
        } else {
          this.$refs.physicalHTypeID.removeClass("invalidInput");
        }
        if (parseInt(this.basicInformation.phyHandiPercentage) < 40) {
          this.$refs.phyHandiPercentage.$el.addClass("invalidInput");
          isError = true;
          msg += "<br>Enter Valid Handicapped Percentage !!!";
        } else {
          this.$refs.phyHandiPercentage.$el.removeClass("invalidInput");
        }
      }
      if (msg != "") {
        msg = "PERSONAL DETAILS : <br>" + msg;
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Application says",
        });
      }
      return isError;
    },
    validationTab2() {
      let msg = "";
      let isError = false;

      this.candQualOne.forEach((element, index) => {
        //console.log(element);
        if (element[1] != -1) {
          if (element[10] == "") {
            this.$refs["qualOnetxtRollno_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please enter Roll No. for Mandatory Qualification !!!";
          } else {
            this.$refs["qualOnetxtRollno_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[11] == "") {
            this.$refs["qualOneSchoolName_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter School/College Name for Mandatory Qualification !!!";
          } else {
            this.$refs["qualOneSchoolName_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }

          if (element[12] == "-1") {
            this.$refs["qualOneState_" + index][0].addClass("invalidInput");
            isError = true;
            msg += "<br>Please select State for Mandatory Qualification !!!";
          } else {
            this.$refs["qualOneState_" + index][0].removeClass("invalidInput");
          }
          if (element[13] == "-1") {
            this.$refs["qualOneddlUniver_" + index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please select Board/University for Mandatory Qualification !!!";
          } else {
            this.$refs["qualOneddlUniver_" + index][0].removeClass(
              "invalidInput"
            );
          }
          if (element[13] == "0") {
            if (element[14] == "") {
              this.$refs["qualOneBoardName_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please Enter Board/University  for Mandatory Qualification !!!";
            } else {
              this.$refs["qualOneBoardName_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          }
          if (element[15] == "" || element[15].length != 4) {
            this.$refs["qualOneYear_" + index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please enter valid Passing Year for Mandatory Qualification !!!";
          } else {
            this.$refs["qualOneYear_" + index][0].removeClass("invalidInput");
          }
          if ((element[19] == "" || element[19] == "0") && element[16] == "0") {
            this.$refs["qualOneTotalMark_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Total Mark for Mandatory Qualification !!!";
          } else {
            this.$refs["qualOneTotalMark_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }

          if (element[16] == "0") {
            if (element[18] == "" || element[18] == "0") {
              this.$refs["qualOneMarkObtained_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please enter Mark Obtained for Mandatory Qualification !!!";
            } else {
              this.$refs["qualOneMarkObtained_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          } else {
            if (element[17] == "") {
              this.$refs["qualOneMarkGrade_" + index][0].addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please enter Grade / CGPA / CPI  for Mandatory Qualification !!!";
            } else {
              this.$refs["qualOneMarkGrade_" + index][0].removeClass(
                "invalidInput"
              );
            }
          }
          if (parseInt(element[19]) > 0 && parseInt(element[18]) > 0) {
            if (parseInt(element[19]) < parseInt(element[18])) {
              this.$refs["qualOneTotalMark_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please enter valid Total / Obtained Mark for Mandatory Qualification !!!";
            } else {
              this.$refs["qualOneTotalMark_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          }
          if (
            element[20] == "" ||
            element[20] == "0" ||
            element[20] == "0.00"
          ) {
            this.$refs["qualOneAggregate_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Aggregate % for Mandatory Qualification !!!";
          } else {
            this.$refs["qualOneAggregate_" + index][0].$el.removeClass(
              "invalidInput"
            );
            var pp = parseFloat(element[20]);
            if (parseFloat(pp) > 100) {
              this.$refs["qualOneAggregate_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please enter Aggregate below or equal 100  % for Mandatory Qualification !!!";
            } else {
              this.$refs["qualOneAggregate_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          }
        }
      });

      this.candQualTwo.forEach((element, index) => {
        if (element[1] != -1) {
          if (element[1] == "0") {
            if (element[4] == "") {
              this.$refs["qualTwoQualName_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please Enter Qualification for Miscellaneous Qualification !!!";
            } else {
              this.$refs["qualTwoQualName_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          }
          if (element[10] == "") {
            this.$refs["qualTwoRollNo_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Roll No. for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoRollNo_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[11] == "") {
            this.$refs["qualTwoSchoolName_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter School/College Name for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoSchoolName_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }

          if (element[12] == "-1") {
            this.$refs["qualTwoState_" + index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please select State for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoState_" + index][0].removeClass("invalidInput");
          }
          if (element[13] == "-1") {
            this.$refs["qualTwoUniver_" + index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please select Board/University for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoUniver_" + index][0].removeClass("invalidInput");
          }
          if (element[13] == "0") {
            if (element[14] == "") {
              this.$refs["qualTwoBoard_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please Enter Board/University  for Miscellaneous Qualification !!!";
            } else {
              this.$refs["qualTwoBoard_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          }
          if (element[15] == "" || element[15].length != 4) {
            this.$refs["qualTwoYear_" + index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please enter valid Passing Year for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoYear_" + index][0].removeClass("invalidInput");
          }
          if ((element[19] == "" || element[19] == "0") && element[16] == "0") {
            this.$refs["qualTwoTotalMarks_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Total Mark for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoTotalMarks_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[16] == "0") {
            if (element[18] == "" || element[18] == "0") {
              this.$refs["qualTwoMarkObtained_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please enter Mark Obtained for Miscellaneous Qualification !!!";
            } else {
              this.$refs["qualTwoMarkObtained_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          } else {
            if (element[17] == "") {
              this.$refs["qualTwoGradeObtained_" + index][0].addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please enter Grade / CGPA / CPI for Miscellaneous Qualification !!!";
            } else {
              this.$refs["qualTwoGradeObtained_" + index][0].removeClass(
                "invalidInput"
              );
            }
          }
          if (parseInt(element[19]) < parseInt(element[18])) {
            this.$refs["qualTwoTotalMarks_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter valid Total / Obtained Mark for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoTotalMarks_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (
            element[20] == "" ||
            element[20] == "0" ||
            element[20] == "0.00"
          ) {
            this.$refs["qualTwoAggregate_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Aggregate % for Miscellaneous Qualification !!!";
          } else {
            this.$refs["qualTwoAggregate_" + index][0].$el.removeClass(
              "invalidInput"
            );
            var pp = parseFloat(element[20]);
            if (parseFloat(pp) > 100) {
              this.$refs["qualTwoAggregate_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg +=
                "<br>Please enter Aggregate below or equal 100  % for Miscellaneous Qualification !!!";
            } else {
              this.$refs["qualTwoAggregate_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          }
        }
      });

      this.candOtherQualOne.forEach((element, index) => {
        if (element[1] != -1) {
          if (element[1] == "0") {
            if (element[4] == "") {
              isError = true;
              msg += "<br>Please Enter Trade for Mandatory  Experience !!!";
            }
          }
          if (element[10] == "") {
            this.$refs["qualOtherInstName_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Name of Institution for Mandatory  Experience !!!";
          } else {
            this.$refs["qualOtherInstName_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[12] == "") {
            this.$refs["qualOtherRecognised_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Recognised By for Mandatory  Experience !!!";
          } else {
            this.$refs["qualOtherRecognised_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[13] == "") {
            this.$refs["qualOtherYear_" + index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please enter Valid Experience In Years for Mandatory  Experience !!!";
          } else {
            this.$refs["qualOtherYear_" + index][0].removeClass("invalidInput");
          }
          if (element[14] == "" || parseInt(element[14]) > 12) {
            this.$refs["qualOtherExpMonth_" + index][0].addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Valid Experience In Month for Mandatory  Experience !!!";
          } else {
            this.$refs["qualOtherExpMonth_" + index][0].removeClass(
              "invalidInput"
            );
          }
          /*if (
            parseInt(element[13]) + parseInt(element[14]) == 0 ||
            parseInt(element[13]) + parseInt(element[14]) == "NaN"
          ) {
            this.$refs['qualOtherYear_'+index][0].addClass("invalidInput");
            this.$refs['qualOtherExpMonth_'+index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please enter Valid Experience In Year/Month for Mandatory  Experience !!!";
          }
          else{
            this.$refs['qualOtherYear_'+index][0].removeClass("invalidInput");
            this.$refs['qualOtherExpMonth_'+index][0].removeClass("invalidInput");
          }*/
        }
      });

      this.candOtherQualTwo.forEach((element, index) => {
        if (element[1] != -1) {
          if (element[1] == "0") {
            if (element[4] == "") {
              this.$refs["qualOtherTwoExpName_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg += "<br>Please Enter Trade for Miscellaneous Experience !!!";
            } else {
              this.$refs["qualOtherTwoExpName_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
          }
          if (element[10] == "") {
            this.$refs["qualOtherTwoInstName_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Name of Institution for Miscellaneous Experience !!!";
          } else {
            this.$refs["qualOtherTwoInstName_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[12] == "") {
            this.$refs["qualOtherTwoRecognised_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Recognised By for Miscellaneous Experience !!!";
          } else {
            this.$refs["qualOtherTwoRecognised_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[13] == "") {
            this.$refs["qualOtherTwoYear_" + index][0].addClass("invalidInput");
            isError = true;
            msg +=
              "<br>Please enter Valid Experience In Years for Miscellaneous Experience !!!";
          } else {
            this.$refs["qualOtherTwoYear_" + index][0].removeClass(
              "invalidInput"
            );
          }
          if (element[14] == "" || parseInt(element[14]) > 12) {
            this.$refs["qualOtherTwoMonth_" + index][0].addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Valid Experience In Month for Miscellaneous Experience !!!";
          } else {
            this.$refs["qualOtherTwoMonth_" + index][0].removeClass(
              "invalidInput"
            );
          }
          if (
            parseInt(element[13]) + parseInt(element[14]) == 0 ||
            parseInt(element[13]) + parseInt(element[14]) == "NaN"
          ) {
            this.$refs["qualOtherTwoYear_" + index][0].addClass("invalidInput");
            this.$refs["qualOtherTwoMonth_" + index][0].addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Valid Experience In Year/Month for Miscellaneous Experience !!!";
          } else {
            this.$refs["qualOtherTwoYear_" + index][0].removeClass(
              "invalidInput"
            );
            this.$refs["qualOtherTwoMonth_" + index][0].removeClass(
              "invalidInput"
            );
          }
        }
      });

      if (msg != "") {
        msg = "QUALIFICATION : <br>" + msg;
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Application says",
        });
      }
      return isError;
    },
    validationTab5() {
      let msg = "";
      let isError = false;

      if (this.basicInformation.isExServiceMan == 1) {
        this.exServiceMan.forEach((element, index) => {
          if (element[2] == -1) {
            this.$refs["exServiceServiceType_" + index][0].addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please select Service Type for Ex-Serviceman !!!";
          } else {
            this.$refs["exServiceServiceType_" + index][0].removeClass(
              "invalidInput"
            );
          }
          if (
            new Date(element[4]).convertToString("dd MMM yyyy") == "01 Jan 1900"
          ) {
            this.$refs["exServiceDOE_" + index][0].$el.addClass("invalidInput");
            isError = true;
            msg += "<br>Please select Date of Enrolment for Ex-Serviceman !!!";
          } else {
            this.$refs["exServiceDOE_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (
            new Date(element[5]).convertToString("dd MMM yyyy") == "01 Jan 1900"
          ) {
            this.$refs["exServiceDOR_" + index][0].$el.addClass("invalidInput");
            isError = true;
            msg += "<br>Please select Date of Retirement for Ex-Serviceman !!!";
          } else {
            this.$refs["exServiceDOR_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element[9] == "") {
            this.$refs["exServiceDBookNo_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Discharge Book Number / Discharge Order No / NOC No for Ex-Serviceman !!!";
          } else {
            this.$refs["exServiceDBookNo_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          // if (new Date(element[4]) > new Date(element[5])) {
          //   isError = true;
          //   msg +=
          //     "<br>Please select valid Date of Enrolment and Date of Retirement for Ex-Serviceman !!!";
          // }
        });
      }
      this.sportsMan.forEach((element, index) => {
        if (element[2] == -1) {
          this.$refs["sportsManLevel_" + index][0].addClass("invalidInput");
          isError = true;
          msg += "<br>Please select Level for Sports Man !!!";
        } else {
          this.$refs["sportsManLevel_" + index][0].removeClass("invalidInput");
        }
        if (element[4] == -1) {
          this.$refs["sportsManMedal_" + index][0].addClass("invalidInput");
          isError = true;
          msg += "<br>Please select Medal for Sports Man !!!";
        } else {
          this.$refs["sportsManMedal_" + index][0].removeClass("invalidInput");
        }
        if (element[3] == -1) {
          this.$refs["sportsManDiscipline_" + index][0].addClass(
            "invalidInput"
          );
          isError = true;
          msg += "<br>Please select Sports Discipline for Sports Man !!!";
        } else {
          this.$refs["sportsManDiscipline_" + index][0].removeClass(
            "invalidInput"
          );
        }
        if (element[5] == "") {
          this.$refs["sportsManCompetitionName_" + index][0].$el.addClass(
            "invalidInput"
          );
          isError = true;
          msg += "<br>Please enter Competition Name for Sports Man !!!";
        } else {
          this.$refs["sportsManCompetitionName_" + index][0].$el.removeClass(
            "invalidInput"
          );
        }
        if (element[7] == "") {
          this.$refs["sportsManCountryName_" + index][0].$el.addClass(
            "invalidInput"
          );
          isError = true;
          msg += "<br>Please enter Country Name for Sports Man !!!";
        } else {
          this.$refs["sportsManCountryName_" + index][0].$el.removeClass(
            "invalidInput"
          );
        }
        if (element[6] == "") {
          this.$refs["sportsManStateName_" + index][0].$el.addClass(
            "invalidInput"
          );
          isError = true;
          msg += "<br>Please enter State Name for Sports Man !!!";
        } else {
          this.$refs["sportsManStateName_" + index][0].$el.removeClass(
            "invalidInput"
          );
        }
        if (element[8] == "" || element[8].length != 4) {
          this.$refs["sportsManYear_" + index][0].addClass("invalidInput");
          isError = true;
          msg += "<br>Please enter Year for Sports Man !!!";
        } else {
          this.$refs["sportsManYear_" + index][0].removeClass("invalidInput");
        }
        if (element[2] == 5) {
          if (element[9] == "") {
            this.$refs["sportsManClearanceNo_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please enter Clearance No. for Sports Man !!!";
          } else {
            this.$refs["sportsManClearanceNo_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (
            new Date(element[10]).convertToString("dd MMM yyyy") ==
            "01 Jan 1900"
          ) {
            this.$refs["sportsManClearanceDate_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please enter Clearance Date for Sports Man !!!";
          } else {
            this.$refs["sportsManClearanceDate_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
        }
      });

      this.documentCertificate.forEach((element, index) => {
        if (element[1] != -1) {
          if (element.certificateNo == "") {
            this.$refs["certificateNo_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg +=
              "<br>Please enter Document / Certificate No. for Document Details !!!";
          } else {
            this.$refs["certificateNo_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (
            new Date(element.issueDate).convertToString("dd MMM yyyy") ==
            "01 Jan 1900"
          ) {
            this.$refs["certificateIssueDate_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please select Issue Date for Document Details !!!";
          } else {
            this.$refs["certificateIssueDate_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element.authorityName == "") {
            this.$refs["certificateAuthName_" + index][0].$el.addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please enter Authority Name for Document Details !!!";
          } else {
            this.$refs["certificateAuthName_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
          if (element.stateID == -1) {
            this.$refs["certificateStateID_" + index][0].addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please select State for Document Details !!!";
          } else {
            this.$refs["certificateStateID_" + index][0].removeClass(
              "invalidInput"
            );
          }
          if (element.districtID == -1) {
            this.$refs["certificateDistrictID_" + index][0].addClass(
              "invalidInput"
            );
            isError = true;
            msg += "<br>Please select District for Document Details !!!";
          } else {
            this.$refs["certificateDistrictID_" + index][0].removeClass(
              "invalidInput"
            );
          }
          if (element.isLifeTimeValid == false) {
            if (
              new Date(element.validUpTo).convertToString("dd MMM yyyy") ==
              "01 Jan 1900"
            ) {
              this.$refs["certificateValidUpTo_" + index][0].$el.addClass(
                "invalidInput"
              );
              isError = true;
              msg += "<br>Please select Valid Up To for Document Details !!!";
            } else {
              this.$refs["certificateValidUpTo_" + index][0].$el.removeClass(
                "invalidInput"
              );
            }
            // if (new Date(element.issueDate) > new Date(element.validUpTo)) {
            //   isError = true;
            //   msg +=
            //     "<br>Please select valid Issue Date and Valid Up for Document Details !!!";
            // }
          }
        }
      });
      if (
        this.basicInformation.relaxationTypeID == 3 ||
        this.basicInformation.relaxationTypeID == 5
      ) {
        // if (this.basicInformation.appMediaNo == "") {
        //   isError = true;
        //   msg += "<br>Please enter Registration No for Recruitment Type";
        // }
        if (
          new Date(this.basicInformation.dateOfAppointment).convertToString(
            "dd MMM yyyy"
          ) == "01 Jan 1900"
        ) {
          this.$refs.dateOfAppointment.$el.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please select Date of Appointment for Recruitment Type !!!";
        } else {
          this.$refs.dateOfAppointment.$el.removeClass("invalidInput");
        }
        if (this.basicInformation.empOrgName == "") {
          this.$refs.empOrgName.$el.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please enter Name Of Organization for Recruitment Type !!!";
        } else {
          this.$refs.empOrgName.$el.removeClass("invalidInput");
        }
        if (this.basicInformation.empPostName == "") {
          this.$refs.empPostName.$el.addClass("invalidInput");
          isError = true;
          msg += "<br>Please enter Name Of Post for Recruitment Type !!!";
        } else {
          this.$refs.empPostName.$el.removeClass("invalidInput");
        }
        if (this.basicInformation.employerOffice == "") {
          this.$refs.employerOffice.$el.addClass("invalidInput");
          isError = true;
          msg += "<br>Please enter Office Address for Recruitment Type !!!";
        } else {
          this.$refs.employerOffice.$el.removeClass("invalidInput");
        }
        if (this.basicInformation.isNOCObtained == 1) {
          if (this.basicInformation.empLetterNo == "") {
            this.$refs.empLetterNo.$el.addClass("invalidInput");
            isError = true;
            msg += "<br>Please enter Letter No. for Recruitment Type !!!";
          } else {
            this.$refs.empLetterNo.$el.removeClass("invalidInput");
          }
          if (
            new Date(this.basicInformation.empletterDate).convertToString(
              "dd MMM yyyy"
            ) == "01 Jan 1900"
          ) {
            this.$refs.empletterDate.$el.addClass("invalidInput");
            isError = true;
            msg += "<br>Please enter Letter Date for Recruitment Type !!!";
          } else {
            this.$refs.empletterDate.$el.removeClass("invalidInput");
          }
        }
      }
      if (this.OtherDetails.isEERegistered == 1) {
        if (this.OtherDetails.eRegistrationNo == "") {
          this.$refs.EERegistrationNo.$el.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please enter Registration Number for Employment Exchange !!!";
        } else {
          this.$refs.EERegistrationNo.$el.removeClass("invalidInput");
        }
        if (
          new Date(this.OtherDetails.eRegistrationDate).convertToString(
            "dd MMM yyyy"
          ) == "01 Jan 1900"
        ) {
          this.$refs.eRegistrationDate.$el.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please select Registration Date for Employment Exchange !!!";
        } else {
          this.$refs.eRegistrationDate.$el.removeClass("invalidInput");
        }
        if (this.OtherDetails.eExchangeName == "") {
          this.$refs.EExchangeName.$el.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please enter Employment Exch Name for Employment Exchange !!!";
        } else {
          this.$refs.EExchangeName.$el.removeClass("invalidInput");
        }
        if (this.OtherDetails.eStateID == -1) {
          this.$refs.eStateID.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please enter Employment Exch State for Employment Exchange !!!";
        } else {
          this.$refs.eStateID.removeClass("invalidInput");
        }
        if (this.OtherDetails.eDistrictID == -1) {
          this.$refs.eDistrictID.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please enter Employment Exch District for Employment Exchange !!!";
        } else {
          this.$refs.eDistrictID.removeClass("invalidInput");
        }
        if (this.OtherDetails.eAddress == "") {
          this.$refs.eAddress.addClass("invalidInput");
          isError = true;
          msg +=
            "<br>Please enter Employment Exch Address for Employment Exchange !!!";
        } else {
          this.$refs.eAddress.removeClass("invalidInput");
        }
      }

      if (msg != "") {
        msg = "OTHER DETAILS : <br>" + msg;
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Application says",
        });
      }
      return isError;
    },
    validationTab3() {
      let msg = "";
      let isError = false;
      var isDoc = true;
      var isDocSrNo = true;
      this.candDocuments.forEach((element, index) => {
        if (element[0] == "-1") {
          this.$refs["uploadFilesDocs_" + index][0].addClass("invalidInput");
          isDoc = false;
        } else {
          this.$refs["uploadFilesDocs_" + index][0].removeClass("invalidInput");
        }
        if (element[12] == 1) {
          if (element[11] == "") {
            this.$refs["docCertificateNo_" + index][0].$el.addClass(
              "invalidInput"
            );
            isDocSrNo = false;
          } else {
            this.$refs["docCertificateNo_" + index][0].$el.removeClass(
              "invalidInput"
            );
          }
        }
      });
      if (!isDoc) {
        isError = true;
        msg += "<br>Please upload all documents listed !!!";
      }
      if (!isDocSrNo) {
        isError = true;
        msg += "<br>Please enter Document Number for for required document !!!";
      }
      if (msg != "") {
        msg = "UPLOAD DOCUMENTS : <br>" + msg;
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Application says",
        });
      }
      return isError;
    },
    validationTab4() {
      let self = this;
      let msg = "";
      let isError = false;

      var isCentre = true;
      var cityArray = [];
      this.candExamCenter.forEach((element, index) => {
        cityArray.push({ id: element[1] });
        if (element[1] == "-1") {
          this.$refs["ddlExamCenter_" + index][0].addClass("invalidInput");
          isCentre = false;
        } else {
          this.$refs["ddlExamCenter_" + index][0].removeClass("invalidInput");
        }
      });
      if (!isCentre) {
        isError = true;
        msg += "<br>Please select all Exam City Choice !!!";
      }
      if (isCentre) {
        cityArray.forEach((city, i) => {
          self.candExamCenter.forEach((element, index) => {
            if (element[1] != "-1") {
              if (city.id == element[1] && i != index) {
                isError = true;
                this.$refs["ddlExamCenter_" + index][0].addClass(
                  "invalidInput"
                );
                msg += "<br>Duplicate city Choice not allowed !!!";
              } else {
                this.$refs["ddlExamCenter_" + index][0].removeClass(
                  "invalidInput"
                );
              }
            }
          });
        });
      }

      var isPost = true;
      var postArray = [];
      this.candPostingCity.forEach((element, index) => {
        postArray.push({ id: element[1] });
        if (element[1] == "-1") {
          this.$refs["ddlPosting_" + index][0].addClass("invalidInput");
          isPost = false;
        } else {
          this.$refs["ddlPosting_" + index][0].removeClass("invalidInput");
        }
      });
      if (!isPost) {
        isError = true;
        msg += "<br>Please select all Posting Region Choice !!!";
      }
      if (isPost) {
        postArray.forEach((city, i) => {
          self.candPostingCity.forEach((element, index) => {
            if (element[1] != "-1") {
              if (city.id == element[1] && i != index) {
                this.$refs["ddlPosting_" + index][0].addClass("invalidInput");
                isError = true;
                msg +=
                  "<br>Duplicate Preferred Location for Employment not allowed !!!";
              } else {
                this.$refs["ddlPosting_" + index][0].removeClass(
                  "invalidInput"
                );
              }
            }
          });
        });
      }
      if (this.basicInformation.candRegPlace == "") {
        this.$refs.txtcandRegPlace.addClass("invalidInput");
        isError = true;
        msg += "<br>Enter Registration Place ";
      } else {
        this.$refs.txtcandRegPlace.removeClass("invalidInput");
      }
      if (this.captchaValue == "" || this.captchaValue != this.captchaData) {
        this.$refs.txtcaptchaValue.addClass("invalidInput");
        isError = true;
        msg += "<br>Enter captcha as Showing in Image !!!";
      } else {
        this.$refs.txtcaptchaValue.removeClass("invalidInput");
      }
      if (msg != "") {
        msg = "DECLARATION : <br>" + msg;
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Application says",
        });
      }
      return isError;
    },
    confirmSubmit() {
      if (this.chk1 == true && this.chk2 == true) {
        if (this.validationTab1()) {
          this.tabClick(1);
          return false;
        }
        if (this.validationTab2()) {
          this.tabClick(2);
          return false;
        }
        if (this.validationTab5()) {
          this.tabClick(5);
          return false;
        }
        if (this.validationTab3()) {
          this.tabClick(3);
          return false;
        }
        if (this.validationTab4()) {
          this.tabClick(4);
          return false;
        }
        this.saveApplication(1);
      }
    },
    finalSubmit() {
      MessageBox.show(
        {
          message:
            "Are you sure to Submit , After submission no change is allowed . </br> Click  Submit Application to continue",
          type: "confirm",
          title: "",
          defaultButton: 2,
        },
        {
          buttonName: "Submit Application",
          buttonAction: this.submitApplication,
        },
        { buttonName: "Cancel", buttonAction: this.showFlashMessage }
      );
    },
    submitApplication() {
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(this.formDataMaking(1, 0)));
      axios
        .post(
          config.WEB_API_PATH + "Registration/SubmitCandApplication",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token,
            },
            crossdomain: true,
          }
        )
        .then(
          (response) => {
            if (response.data.isSuccess) {
              let self = this;
              this.getCandidateApp();
              vue.nextTick(() => {
                self.getCandidateInfo();
              });
              MessageBox.show({
                message: response.data.msg,
                type: "success",
                title: "API says",
              });
              //this.modalPopupClosed();
              this.admitCardDiv = false;
            } else {
              MessageBox.show({
                message: response.data.msg,
                type: "error",
                title: "API says",
              });
            }
          },
          (error) => {}
        );
    },
    printCallLetter(row) {
      if (row) {
        let self = this;
        this.candidateID = row[0];
        vue.nextTick(function () {
          self.callLetterprintbus.$emit("getCandidateDetail");
          self.callLetterPrintDiv = true;
        });
      }
    },
    printCallLetterReport() {
      this.callLetterprintbus.$emit("printPDF");
    },
    confirmPostAgainSubmit() {
      MessageBox.show(
        {
          message:
            "Are you sure to SUBMIT  ? </br> Click  Submit Application to continue",
          type: "confirm",
          title: "",
          defaultButton: 2,
        },
        {
          buttonName: "Submit Application",
          buttonAction: this.SubmitPostCityAgain,
        },
        { buttonName: "Cancel", buttonAction: this.showFlashMessage }
      );
    },
    SubmitPostCityAgain() {
      var msg = "";
      var isError = false;
      var isPost = false;
      var postArray = [];
      let self = this;
      this.candPostingCity.forEach((element) => {
        postArray.push({ id: element[1] });
        if (element[1] != "-1") {
          isPost = true;
        }
      });
      if (!isPost) {
        isError = true;
        msg += "<br>Please select at least one Posting Region Choice";
      }
      if (isPost) {
        postArray.forEach((city, i) => {
          self.candPostingCity.forEach((element, index) => {
            if (element[1] != "-1") {
              if (city.id == element[1] && i != index) {
                isError = true;
                msg +=
                  "<br>Duplicate Preferred Location for Employment not allowed ";
              }
            }
          });
        });
      }
      if (msg != "") {
        msg = "DECLARATION : <br>" + msg;
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Application says",
        });
        return;
      }
      var postingTable = [];
      this.candPostingCity.forEach((element) => {
        postingTable.push({
          ChoiceSerialNo: element[0],
          PostingCityID: element[1],
        });
      });
      var basicData = {
        CandidateID: this.candidateID,
        Type: 2,
        TablePostingChoice: postingTable,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));

      axios
        .post(
          config.WEB_API_PATH + "Registration/UpdateNextPostingCityChoice",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token,
            },
            crossdomain: true,
          }
        )
        .then(
          (response) => {
            if (response.data.isSuccess) {
              let self = this;
              MessageBox.show({
                message: response.data.msg,
                type: "success",
                title: "API says",
              });
              vue.nextTick(() => {
                self.getCandidateInfo();
              });
            } else {
              MessageBox.show({
                message: response.data.msg,
                type: "error",
                title: "API says",
              });
            }
          },
          (error) => {}
        );
    },
    SavePostingCity() {
      var msg = "";
      var isError = false;
      var isPost = false;
      var postArray = [];
      let self = this;
      this.candPostingCity.forEach((element) => {
        postArray.push({ id: element[1] });
        if (element[1] != "-1") {
          isPost = true;
        }
      });
      if (!isPost) {
        isError = true;
        msg += "<br>Please select at least one Posting Region Choice";
      }
      if (isPost) {
        postArray.forEach((city, i) => {
          self.candPostingCity.forEach((element, index) => {
            if (element[1] != "-1") {
              if (city.id == element[1] && i != index) {
                isError = true;
                msg +=
                  "<br>Duplicate Preferred Location for Employment not allowed ";
              }
            }
          });
        });
      }
      if (msg != "") {
        msg = "DECLARATION : <br>" + msg;
        MessageBox.show({
          message: msg,
          type: "error",
          title: "Application says",
        });
        return;
      }
      var postingTable = [];
      this.candPostingCity.forEach((element) => {
        postingTable.push({
          ChoiceSerialNo: element[0],
          PostingCityID: element[1],
        });
      });
      var basicData = {
        CandidateID: this.candidateID,
        Type: 1,
        TablePostingChoice: postingTable,
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));

      axios
        .post(
          config.WEB_API_PATH + "Registration/UpdateNextPostingCityChoice",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token,
            },
            crossdomain: true,
          }
        )
        .then(
          (response) => {
            if (response.data.isSuccess) {
              let self = this;
              MessageBox.show({
                message: response.data.msg,
                type: "success",
                title: "API says",
              });
              vue.nextTick(() => {
                self.getCandidateInfo();
              });
            } else {
              MessageBox.show({
                message: response.data.msg,
                type: "error",
                title: "API says",
              });
            }
          },
          (error) => {}
        );
    },
    confirmDiscardApplication(row) {
      this.discardRow = row;
      MessageBox.show(
        {
          message:
            "Are you sure to Discard  ? </br> Click  Discard Application to continue",
          type: "confirm",
          title: "",
          defaultButton: 2,
        },
        {
          buttonName: "Discard Application",
          buttonAction: this.DiscardApplication,
        },
        { buttonName: "Cancel", buttonAction: this.showFlashMessage }
      );
    },
    DiscardApplication() {
      var basicData = {
        CandidateID: this.discardRow[0],
        CourseID: this.discardRow[5],
      };
      var formData = new FormData();
      formData.append("BasicData", JSON.stringify(basicData));

      axios
        .post(
          config.WEB_API_PATH + "Registration/DiscardCandApplication",
          formData,
          {
            headers: {
              __RequestVerificationToken: config.AF_Token,
              Authorization: config.LOG_Token,
            },
            crossdomain: true,
          }
        )
        .then(
          (response) => {
            if (response.data.isSuccess) {
              let self = this;
              MessageBox.show({
                message: response.data.msg,
                type: "success",
                title: "API says",
              });
              this.getCandidateApp();
              //  vue.nextTick(() => {
              //      self.getCandidateInfo();
              //  });
            } else {
              MessageBox.show({
                message: response.data.msg,
                type: "error",
                title: "API says",
              });
            }
          },
          (error) => {}
        );
    },
    onSelectExamCenter(row, rowindex) {
      if (row[1] != "-1") {
        let self = this;
        this.candExamCenter.forEach((element) => {
          if (element[0] != row[0]) {
            if (element[1] == row[1]) {
              MessageBox.show({
                message: "Center already selected",
                type: "error",
                title: "API says",
              });
              row[1] = -1;
              vue.set(self.candExamCenter, rowindex, row);
              return;
            }
          }
        });
      }
    },
    resetCardDetails(row, rowindex) {
      let self = this;
      row[11] = "";
      vue.set(self.candDocuments, rowindex, row);
    },
    onSelectPostingCity(row, rowindex) {
      if (row[1] != "-1") {
        let self = this;
        this.candPostingCity.forEach((element) => {
          if (element[0] != row[0]) {
            if (element[1] == row[1]) {
              MessageBox.show({
                message: "Posting Region already selected",
                type: "error",
                title: "API says",
              });
              row[1] = -1;
              vue.set(self.candPostingCity, rowindex, row);
              return;
            }
          }
        });
      }
    },
    onSelectOtherQual(row, rowindex) {
      if (row[1] != "-1") {
        let self = this;
        this.candQualTwo.forEach((element, itemIndex) => {
          if (rowindex != itemIndex) {
            if (element[1] != 0) {
              if (element[1] == row[1]) {
                MessageBox.show({
                  message: "Qualification already selected",
                  type: "error",
                  title: "API says",
                });
                row[1] = "-1";
                vue.set(self.candQualTwo, rowindex, row);
                return;
              }
            }
          }
        });
      }
    },
    onSelectOtherExp(row, rowindex) {
      if (row[1] != "-1") {
        let self = this;
        this.candOtherQualTwo.forEach((element, itemIndex) => {
          if (rowindex != itemIndex) {
            if (element[1] != 0) {
              if (element[1] == row[1]) {
                MessageBox.show({
                  message: "Experience already selected",
                  type: "error",
                  title: "API says",
                });
                row[1] = "-1";
                vue.set(self.candOtherQualTwo, rowindex, row);
                return;
              }
            }
          }
        });
      }
    },
    SameAsCorrespondance() {
      if (this.IsSameAsCorrespondance == false) {
        this.addressInformation.address = this.correspondanceAddress.address;
        this.addressInformation.stateID = this.correspondanceAddress.stateID;
        this.addressInformation.districtID =
          this.correspondanceAddress.districtID;
        this.addressInformation.city = this.correspondanceAddress.city;
        this.addressInformation.pinCode = this.correspondanceAddress.pinCode;
      } else {
        this.addressInformation.address = "";
        this.addressInformation.stateID = -1;
        this.addressInformation.districtID = -1;
        this.addressInformation.city = "";
        this.addressInformation.pinCode = "";
      }
    },
    getNationality() {
      this.Nationality_List = [];
      const _data_ = { nationalityID: -1, type: 1 };
      let resp = masterAPI.getNationality();
      if (resp.length > 0) {
        this.Nationality_List = resp;
        this.basicInformation.nationalityID = resp[0][0];
      }
      /*
      axios
        .get(config.WEB_API_PATH + "Master/GetNationality", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data_,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.Nationality_List = response.data;
            this.basicInformation.nationalityID = this.Nationality_List[0][0];
          },
          (error) => {}
        );*/
    },
    AddNewMiscelleniousQualification() {
      if (this.candQualTwo.length == 5) {
        alert("Max 5 Qualification Allowed");
        return;
      }
      this.candQualTwo.push([
        this.candQualTwo[0][0], //00 CandidateID
        "-1", //01 QualID
        this.candQualTwo[0][2], //02 QualType
        this.candQualTwo[0][3], //03 QualPriority
        "", //04 QualName
        "0", //05 PerAgg
        "-1", //06 QualUnivType
        "-1", //07 PostQualID
        "0", //08 IsCertificateReq
        "-1", //09 QualSetID
        "", //10 RollNo
        "", //11 SchoolName
        "-1", //12 StateID
        "-1", //13 UnivID
        "", //14 UnivName
        "", //15 PassingYear
        "0", //16 IsGrade
        "0", //17 QualGrade
        "0", //18 MarkObtained
        "0", //19 MarkTotal
        "0.0", //20 QualPercent
        "1", //21 IsOtherQual
        parseInt(this.candQualTwo.length) + 1, //22 QualRowID
      ]);
    },
    DeleteMiscelleniousQualification(rowData, index) {
      if (confirm("Are you sure ?")) {
        this.candQualTwo.splice(index, 1);
      }
    },
    AddNewMiscelleniousExperience() {
      if (this.candOtherQualTwo.length == 5) {
        alert("Max 5 Allowed");
        return;
      }
      this.candOtherQualTwo.push([
        this.candOtherQualTwo[0][0], //00 CandidateID
        "-1", //01 QualID
        "-1", //02 QualType
        this.candOtherQualTwo[0][3], //03 QualPriority
        "", //04 QualName
        "-1", //05 QualUnivType
        "-1", //06 PostQualID
        "0", //07 IsCertificateReq
        "1", //08 QualSetID
        "", //09 TradeName
        "", //10 InstName
        "1", //11 InstType
        "", //12 RecognisedBy
        "0", //13 ExpInYear
        "0", //14 ExpInMonth
        "1", //15 IsOtherExp
        parseInt(this.candOtherQualTwo.length) + 1, // this.candOtherQualTwo[0][16] + 1 //16 ExpRowID
      ]);
    },
    DeleteMiscelleniousExperience(row, index) {
      if (confirm("Are you sure ?")) {
        this.candOtherQualTwo.splice(index, 1);
      }
    },
    AddNewExServiceman() {
      if (this.exServiceMan.length == 5) {
        alert("Max 5 Allowed");
        return;
      }
      this.exServiceMan.push([
        this.exServiceMan[0][0], //00 CandidateID
        parseFloat(this.exServiceMan[0][1]) + 1, //01 SerialNo
        "-1", //02 ExServiceTypeID
        "", //03 ExServiceNo
        new Date("01 Jan 1900"), //04 ExEnrollmentDate
        new Date("01 Jan 1900"), //05 ExRetirementDate
        "0", //06 ExServiceInYear
        "0", //07 ExServiceInMonth
        "0", //08 ExServiceInDay
        "", //09  ExDischargeBookNo
      ]);
    },
    DeleteExServiceman(index) {
      if (confirm("Are you sure ?")) {
        this.exServiceMan.splice(index, 1);
      }
    },
    AddNewSportMan() {
      if (this.sportsMan.length == 5) {
        alert("Max 5 Allowed");
        return;
      }
      this.sportsMan.push([
        this.sportsMan[0][0], //00 CandidateID
        parseInt(this.sportsMan[0][1]) + 1, //01 SerialNo
        "-1", //02 SportLevelID
        "-1", //03 SportID
        "-1", //04 SportMedalID
        "", //05 SportCompetitionName
        "", //06 SportStateHeld
        "", //07 SportCountryHeld
        "", //08 SportParticipatingYear
        "", //09  SportClearenceNo
        new Date("01 Jan 1900").convertToString("dd MMM yyyy"), //09  SportClearenceDate
      ]);
    },
    DeleteSportMan(index) {
      if (confirm("Are you sure ?")) {
        this.sportsMan.splice(index, 1);
      }
    },
    ShowLiveUpdate() {
      if (this.liveUpdate == 1) {
        this.liveUpdate = 0;
      } else {
        this.liveUpdate = 1;
        this.startWebCamera();
      }
    },
    startWebCamera() {
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.webkitGetUserMedia;
      // if (
      //   !(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices)
      // )
      if (!navigator.getUserMedia) {
        MessageBox.show({
          message:
            "Browser not support web camera. Please update or provide proper setting for web camera.",
          type: "error",
          title: "Error",
        });
        return false;
      }
      this.video = document.getElementById("video");
      this.canvas = document.getElementById("canvas");
      this.photo = document.getElementById("photo");
      this.startbutton = document.getElementById("startbutton");
      let me = this;
      // navigator.mediaDevices
      //   .getUserMedia({
      //     video: true,
      //     audio: false
      //   })
      //   .then(function(stream) {
      //     me.video.srcObject = stream;
      //     me.video.play();
      //   })
      //   .catch(function(err) {
      //     console.log("An error occurred: " + err);
      //   });
      navigator.getUserMedia(
        {
          video: true,
          audio: false,
        },
        function (stream) {
          me.video.srcObject = stream;
          me.video.play();
        },
        function (err) {
          console.log("An error occurred: " + err);
        }
      );

      this.video.oncanplay = function (ev) {
        if (!me.streaming) {
          me.height = me.video.videoHeight / (me.video.videoWidth / me.width);

          if (isNaN(me.height)) {
            me.height = width / (4 / 3);
          }

          me.video.setAttribute("width", me.width);
          me.video.setAttribute("height", me.height);
          me.canvas.setAttribute("width", me.width);
          me.canvas.setAttribute("height", me.height);
          me.streaming = true;
        }
      };

      this.startbutton.onclick = function (ev) {
        //alert(me.showvideo);
        if (me.isSubmit == 1) {
          MessageBox.show({
            message: "After submit application capture photo is not allow.",
            type: "error",
            title: "Error",
          });
          return false;
        }
        if (me.showvideo) {
          me.takepicture();
          me.showvideo = false;
          document.getElementById("dvCandPhotoCapture").style.display = "block";
          document.getElementById("video").style.display = "none";
          document.getElementById("startbutton").textContent =
            "Capture Photo Again";
        } else {
          me.showvideo = true;
          document.getElementById("dvCandPhotoCapture").style.display = "none";
          document.getElementById("video").style.display = "block";
          document.getElementById("startbutton").textContent = "Capture Photo";
        }
        ev.preventDefault();
      };

      this.clearphoto();
    },
    clearphoto() {
      var context = this.canvas.getContext("2d");
      context.fillStyle = "#AAA";
      context.fillRect(0, 0, this.canvas.width, this.canvas.height);

      var data = this.canvas.toDataURL("image/png");
      this.photo.setAttribute("src", data);
    },
    takepicture() {
      var context = this.canvas.getContext("2d");
      let me = this;
      if (this.width && this.height) {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        context.drawImage(this.video, 0, 0, this.width, this.height);

        var data = this.canvas.toDataURL("image/jpeg");
        this.photo.setAttribute("src", data);
        this.canvas.toBlob((blob) => {
          if (me.candDocuments == null || me.candDocuments.length == 0) {
            FlashMessage.show(
              "<span style='color:red'>Candidate Documents are not found</span>",
              1000
            );
            return false;
          }
          let rowIndex = 0;
          let docRow = me.candDocuments.find((row, index) => {
            if (row[5] == "1") {
              rowIndex = index;
              return row;
            }
          });
          if (docRow == null || docRow == undefined || docRow.length == 0) {
            FlashMessage.show(
              "<span style='color:red'>Candidate photo information is not found</span>",
              1000
            );
            return false;
          }
          var objData = new Object();
          objData.CandidateID = docRow[1];
          objData.CommonID = docRow[2];
          objData.CommonType = docRow[4];
          objData.DocTypeID = docRow[5];
          objData.DocSerialNo = docRow[6];
          objData.DocumentNo = docRow[11];
          objData.DocRowID = docRow[9];

          objData.DocFileID = docRow[0];
          objData.DocFileName = "LiveCapturePhoto.jpg";
          objData.DocFileExt = "jpg";

          var formData = new FormData();
          formData.append("FileInfoData", JSON.stringify(objData));
          formData.append("file", blob, "LiveCapturePhoto.jpg");

          axios
            .post(
              config.WEB_API_PATH + "Registration/UploadDocuments",
              formData,
              {
                headers: {
                  __RequestVerificationToken: config.AF_Token,
                  Authorization: config.LOG_Token,
                },
                // onUploadProgress: function (progressEvent) {
                //   item.percent = parseInt(
                //     Math.round(
                //       (progressEvent.loaded * 100) / progressEvent.total
                //     )
                //   );
                // }.bind(me),
                crossdomain: true,
              }
            )
            .then(
              (response) => {
                FlashMessage.show(
                  "<span style='color:red'>" + response.data.msg + "</span>",
                  1000
                );
                //item.docFileID = response.data.result;
                docRow[0] = response.data.result;
                docRow[7] = response.data.result1;
                docRow[8] = response.data.result2;
                docRow[10] = "1";

                // Update the array forcefully
                vue.set(me.candDocuments, rowIndex, docRow);
                //me.candDocuments.splice(rowIndex,1,docRow);
              },
              (error) => {
                if (error.response == undefined) {
                  alert("Error:" + error);
                } else {
                  if (error.response.status == "415") {
                    alert("Error: " + error.response.statusText);
                  } else {
                    if (error.response.data.message == undefined) {
                      alert("Error: " + error.response.data);
                    } else {
                      alert("Error: " + error.response.data.message);
                    }
                  }
                }
              },
              (failure) => {
                alert("Failure: " + failure);
              }
            );
        }, "image/jpeg");
      } else {
        this.clearphoto();
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isCharacter: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var ok =
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode == 32;
      if (!ok) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateAddress: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var ok =
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 96 && charCode <= 105) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode == 45 ||
        charCode == 32 ||
        charCode == 44 ||
        charCode == 47;
      if (!ok) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // GetRecruitmentType() {
    //   var nationality = 1;
    //   if (this.basicInformation.nationalityTypeID == 0) {
    //     nationality = this.basicInformation.nationalityID;
    //   } else {
    //     this.basicInformation.nationalityID = 1;
    //   }
    //   var _data = {
    //     courseID: this.advtID,
    //     postTypeID: this.postTypeID,
    //     gender: this.gender,
    //     appCasteTypeID: this.appCastTypeID,
    //     mainCatID: this.mainCatID,
    //     nationalityID: nationality
    //   };
    //   console.log(_data);
    //   axios
    //     .get(config.WEB_API_PATH + "Master/GetRecruitmentType", {
    //       headers: {
    //         __RequestVerificationToken: config.AF_Token,
    //         Authorization: config.LOG_Token
    //       },
    //       params: _data,
    //       crossdomain: true
    //     })
    //     .then(
    //       response => {
    //         this.recruitmentTypeID = -1;
    //         this.recruitmentType_List = response.data;
    //         if (this.recruitmentType_List.length > 0) {
    //           this.recruitmentTypeID = response.data[0][0];
    //           this.GetRecruitmentTypeRelaxation();
    //         }
    //       },
    //       error => {}
    //     );
    // },
    GetRecruitmentTypeRelaxation() {
      var nationality = 1;
      if (this.basicInformation.nationalityTypeID == 0) {
        nationality = this.basicInformation.nationalityID;
      } else {
        this.basicInformation.nationalityID = 1;
      }
      var _data = {
        relaxationID: -1,
        courseID: this.advtID,
        postTypeID: this.postTypeID,
        gender: this.gender,
        appCasteTypeID: this.appCastTypeID,
        mainCatID: this.mainCatID,
        nationalityID: nationality,
        appMediaID: this.recruitmentTypeID,
      };
      axios
        .get(config.WEB_API_PATH + "Master/GetRecruitmentTypeRelaxation", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token,
          },
          params: _data,
          crossdomain: true,
        })
        .then(
          (response) => {
            this.relaxationTypeID = -1;
            this.recruitmentRelaxation_List = response.data;
            if (this.recruitmentRelaxation_List.length > 0) {
              //this.relaxationTypeID = response.data[0][0];
              this.getSelectelabel();
            }
          },
          (error) => {}
        );
    },
    SetWorkedTillPresent() {
      if (this.basicInformation.workedTillPresent == 1) {
        this.basicInformation.retirementDate = new Date(
          "01 01 1900"
        ).convertToString("dd MMM yyyy");
      } else {
        this.basicInformation.retirementDate = new Date().convertToString(
          "dd MMM yyyy"
        );
      }
    },
    OpenMSPEligibilityDiv() {
      this.mspEligibilityDiv = true;
    },
    OpendisabilityCategoryDiv() {
      this.disabilityCategoryDiv = true;
    },
    phTypeChange() {
      if (
        this.basicInformation.physicalHTypeID == "B" ||
        this.basicInformation.physicalHTypeID == "D"
      ) {
        this.isscribeHide = true;
      } else {
        this.isscribeHide = false;
      }
    },
  },
  computed: {
    RelistQualMaster() {
      let qual = [];
      let self = this;
      this.qualMaster_List.forEach((element) => {
        qual.push(element);
      });
      var obj = [];
      obj = ["-1", "None", "3", "1", "False", "False", "3", "1"];

      if (this.candQualOne.length > 0) {
        this.qualMaster_List.forEach((element, index) => {
          self.candQualOne.forEach((c) => {
            if (element[0] === c[1] && c[22] === "1") {
              qual.splice(index, 1, obj);
            }
          });
        });
      }
      return qual.filter((q) => {
        return q[0] != "-1";
      });
      //return qual;
    },
  },
  mounted() {
    this.isNew = false;
    this.getNationality();
    this.getAdvertisment();
  },
  watch: {
    // appCastTypeID(newValue, oldValue) {
    //   this.youEWS = "0";
    // },
    appCastTypeID(newValue, oldValue) {
      if (newValue == 5) {
        this.youEWS = "1";
      } else {
        this.youEWS = "0";
      }
      this.getSelectelabel();
    },
    IsSameAsCorrespondance(oldVal, NewVal) {
      if (NewVal == false) {
        this.addressInformation.address = this.correspondanceAddress.address;
        this.addressInformation.stateID = this.correspondanceAddress.stateID;
        this.addressInformation.districtID =
          this.correspondanceAddress.districtID;
        this.addressInformation.city = this.correspondanceAddress.city;
        this.addressInformation.pinCode = this.correspondanceAddress.pinCode;
      } else {
        this.addressInformation.address = "";
        this.addressInformation.stateID = -1;
        this.addressInformation.districtID = -1;
        this.addressInformation.city = "";
        this.addressInformation.pinCode = "";
      }
    },
  },
  beforeDestroy() {
    let me = this;
    if (
      me.video != null &&
      me.video.srcObject != undefined &&
      me.video.srcObject != null
    ) {
      me.video.srcObject.getTracks().forEach(function (track) {
        if (track.readyState == "live") {
          track.stop();
        }
      });
    }
  },
};
</script>
<style scoped>
/* select:focus,input:focus {
  border: solid 1px red !important;
  z-index: 102;
} */
.statusSubmit {
  background-color: greenyellow;
}
.statusReject {
  background-color: #ee9696;
  color: maroon;
}
.edit .glyphicons:before {
  /*color: Green !important;*/
  cursor: pointer;
}
.myAppNo {
  background-color: paleturquoise;
}
.docFileName {
  border: solid thin darkgray;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  font-weight: bold;
  width: 98%;
  display: inline-block;
}
.docFileName:hover {
  background-color: orange !important;
}
.SelectedLabel {
  font-size: medium;
  color: darkred;
  font-weight: bold;
}
.instruction {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: medium;
  margin-bottom: 6px;
  cursor: pointer;
  /* border-bottom: solid thin darkgrey; */
}
.instructionAgree {
  background: #37758814;
  padding: 1px 16px;
  margin-left: 0;
  margin-right: 0;
  border-left: #03a9f475 solid 5px;
  border-radius: 5px;
  min-height: 30px;
  line-height: 30px;
  font-size: medium;
  margin-bottom: 6px;
  color: forestgreen;
  cursor: pointer;
}
.myHeaderRow {
  font-weight: bold;
  background-color: rgb(0 188 212 / 14%) !important;
  color: black;
  text-align: center;
  min-height: 30px;
  /* line-height: 23px; */
}
.tblEntryForm > .Flex_Row {
  display: flex;
  flex-wrap: wrap;
}
fieldset {
  margin-bottom: 4px !important;
}
.mandatorySpan {
  text-align: left;
  position: relative;
  display: block;
  padding: 0;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: medium;
}
.mandatorySpan.Required:after {
  color: red;
  content: "*";
  position: absolute;
  height: 8px;
  top: -5px;
  font-size: 200%;
}
#divApplication {
  margin-left: 4px;
  margin-right: 5px;
  border: dotted 1px darkgray;
  border-radius: 5px;
  padding: 5px 0px 0px 5px;
}
.appNoClass {
  display: inline-block;
  border: solid thin;
  padding: 5px 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  /* font-family: verdana;
                        box-shadow: 1px 1px 4px 2px darkgrey;*/
  margin: 0px !important;
  background-color: aqua;
}
.appNoClass:hover {
  background-color: darkorange;
}
.Multibutton {
  padding: 0px;
}
.Multibutton a.glyphicons:before {
  font-size: 18px;
  cursor: pointer;
  margin-top: -2px;
  display: block;
}
.blackColor {
  color: black;
}
.redColor {
  color: red;
}

.profileDiv {
  height: 170px;
  width: 180px;
}
.signatureDiv {
  height: 170px;
  width: 300px;
}
.profileImg {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  box-shadow: 5px -4px 5px #807878;
  border-left: solid thin;
  border-bottom: solid thin;
}
.AppHeader {
  border: solid thin gainsboro;
  border-radius: 5px;
  /* min-height: 55px; */
  /* font-size: medium; */
  font-weight: bold;
}
.tabClass {
  padding: 5px 8px;
  margin-right: 3px;
  font-size: medium;
  border: solid 1px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  font-family: consolas;
  cursor: pointer;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px; */
  background-color: white;
  color: Black;
}
.tabSelectClass {
  padding: 5px 8px;
  margin-right: 3px;

  background-color: rgb(1, 164, 246) !important;
  font-weight: bold;
  font-family: consolas;
  font-size: medium;
  border: solid 1px black;
  border-right: solid 2px black;
  border-radius: 6px 6px 0px 0px;
  text-align: center;
  border-right: solid 2px black;
  /* box-shadow: 3px 1px 4px black; */
  border-bottom: solid 2px black;
  cursor: pointer;
  color: black;
}
.disabled {
  background-color: rgb(192 222 243) !important;
}
.disableButton {
  background-color: silver !important;
  cursor: not-allowed !important;
}
</style>
<style scoped>
.fade-enter-active {
  animation: fade-in 0.4s;
}
.fade-leave-active {
  animation: fade-in 0.4s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0.05;
  }
  10% {
    opacity: 0.1;
  }
  20% {
    opacity: 0.2;
  }
  25% {
    opacity: 0.25;
  }
  30% {
    opacity: 0.3;
  }
  35% {
    opacity: 0.35;
  }
  40% {
    opacity: 0.4;
  }
  45% {
    opacity: 0.45;
  }
  50% {
    opacity: 0.5;
  }
  55% {
    opacity: 0.55;
  }
  60% {
    opacity: 0.6;
  }
  65% {
    opacity: 0.65;
  }
  70% {
    opacity: 0.7;
  }
  75% {
    opacity: 0.75;
  }
  80% {
    opacity: 0.8;
  }
  85% {
    opacity: 0.85;
  }
  90% {
    opacity: 0.9;
  }
  95% {
    opacity: 0.95;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style scoped>
@media screen and (max-width: 800px) {
  .EntryBlock {
    width: 80%;
  }
  #divApplication {
    display: block;
    height: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .EntryBlock {
    width: 100%;
  }
  fieldset > div {
    width: calc(100vw - 15px);
    overflow: auto;
  }
  .tblEntryForm {
    width: calc(100vw - 35px);
  } /* width 15px less*/
  .tblEntryForm .Flex_Row {
    display: flex;
    flex-wrap: wrap;
  } /* this is responsible for cell wraping*/
  .tblEntryForm .Flex_Row > .Flex_Cell {
    width: 50% !important;
  } /* width of any cell time of screen sizing*/
  .tblEntryForm .Flex_Row > .Flex_Cell_Inline {
    width: 50% !important;
    line-height: 36px;
  } /* width of any cell time of screen sizing*/
  /* Auto calculate the height of the grid div for scrolling when screen size change*/
  .Location {
    max-width: calc(100vw - 30px) !important;
    width: calc(100vw - 40px) !important;
  }
  /*Overflow for horizontal */
  .ekkGrid .GridContent {
    overflow: unset;
  }
  /*then only horizontal scrolling works */
  .Flex_Table.ekkGrid .Flex_Row {
    width: 100%;
  }
  .disabled {
    background-color: rgb(192 222 243) !important;
  }
}
.cand_photo {
  height: 120px;
  width: 150px;
  border: solid 1px black;
}
#video {
  border: 1px solid black;
  width: 320px;
  height: 240px;
}

#photo {
  border: 1px solid black;
  width: 320px;
  height: 240px;
}

#canvas {
  display: none;
}

.camera {
  width: 340px;
  display: inline-block;
}

.output {
  width: 340px;
  display: inline-block;
}

#startbutton {
  position: relative;
  padding: 5px;
  background-color: #6a67ce;
  border: 1px solid rgba(255, 255, 255, 0.7);
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}

.contentarea {
  font-size: 16px;
  font-family: Arial;
  text-align: center;
}
@media screen and (max-width: 480px) {
  .EntryBlock {
    width: calc(100vw - 35px);
  }
  fieldset > div {
    width: calc(100vw - 35px);
    overflow: auto;
  }
  #location {
    width: 70%;
  }
  .PopUpCover {
    right: 0px !important;
    left: 18px !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell {
    width: 100% !important;
  }
  .tblEntryForm > .Flex_Row > .Flex_Cell_Inline {
    width: 100% !important;
    line-height: 36px;
  }
  .tblEntryForm .divHR {
    display: block;
  }
  .Flex_Table.ekkGrid.Location {
    max-width: calc(100vw - 40px) !important;
    width: calc(100vw - 40px) !important;
  }
  legend {
    width: calc(100vw - 40px) !important;
  }
  .disabled {
    background-color: rgb(192 222 243) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Registration.vue